export const courseCategories = [
  "Бестселлеры",
  "Веб разработка",
  "CMS и Конструкторы",
  "Веб Дизайн",
  "Графический дизайн",
  "Видеомонтаж",
  "Продвинутый уровень",
  "С нуля",
  "Искусственный интеллект",
  "Пакеты курсов"
];

export const courses = [
  {
    "id": 1,
    "slug": "after-effects",
    "skillspaceCourses": [{ "courseId": "15556", "groupId": "25159" }],
    "title": "Курс по Adobe After Effects",
    "subtitle": "C нуля",
    "description": "В этом курсе вы узнаете всё о создании современной и эффектной графики в программе After Effects! Получите востребованные навыки по созданию графики и анимации в After Effects!",
    "fullDescription": "After Effects — одна из самых популярных программ для создания анимации и визуальных эффектов. Она используется в кинопроизводстве, рекламе, видеомонтаже, создании анимированной графики и многого другого.",
    "image": "/images/courses/after-effects-paper-v2.webp",
    "promoVideo": "https://rutube.ru/play/embed/763c51eb85312f2650f8ddb2c41ab292",
    "price": 2290,
    "originalPrice": 4990,
    "discount": 54,
    "saleDiscount": 25,
    "category": "Видеомонтаж",
    "lessons": 73,
    "totalHours": 11.5,
    "duration": "2 месяца обучения",
    "level": "С нуля",
    "students": 2500,
    "rating": 4.9,
    "reviewPlatforms": {
      "udemy": { "url": "https://www.udemy.com/course/adobe-after-effects-2023/#reviews", "rating": 4.7, "count": 500 },
      "stepik": { "url": "https://stepik.org/course/177850/promo#reviews", "rating": 5, "count": 200 }
    },
    "features": [
      "Интерактивность, общение с преподавателем",
      "Практические задания после каждого урока",
      "Реальные проекты для портфолио",
      "Пожизненный доступ к материалам"
    ],
    "stats": [
      {
        "value": "50K+",
        "label": "Просмотров"
      },
      {
        "value": "100K+",
        "label": "Студентов"
      },
      {
        "value": "150K+",
        "label": "Практических заданий"
      }
    ],
    "topics": [
      "Научитесь создавать современную motion-графику в After Effects",
      "Разберётесь в интерфейсе программы After Effects",
      "Сможете создать анимированные текстовые заголовки",
      "Научитесь анимировать любую графику при помощи ключевых точек",
      "Узнаете, как перенести графику, созданную в After Effects, на ваш сайт",
      "Поймёте, как создавать графику и спецэффекты в связке с Illustrator, Photoshop, Premiere Pro",
      "Разберётесь с тем, как создавать маски в After Effects",
      "Научитесь работать в 3D-среде After Effects",
      "Изучите способы отслеживания объектов в кадре с помощью трекеров"
    ],
    "testimonials": [
      {
        "name": "Виктория",
        "role": "Студент курса",
        "text": "Мне очень понравился курс. Я научилась потрясающим вещам. В курсе много интересных трюков с использованием масок. Очень понятно объясняется, поэтому чудесные анимации я смогла повторить и понять как они делаются. Очень рада, что нашла этот курс, советую всем, кто хочет научиться крутым штукам в After Effects. Спасибо огромное Дмитрию Фокееву за такой прекрасный курс.",
        "rating": 5
      },
      {
        "name": "Павел",
        "role": "Студент курса",
        "text": "Доступная подача материала,спрактическими заданиями,от простого к сложному:Как работает 3D Эффекты After Effects. быстро разобрался в программе. Спасибо автору за Курс!",
        "rating": 5
      }
    ],
    "aboutSection": {
      "headline": "Создание сложных анимаций, работа с визуальными эффектами, монтаж и композиция видео, подготовка графики для различных платформ. Всё это — After Effects",
      "highlightedText": "",
      "description": "After Effects — одна из самых популярных программ для создания анимации и визуальных эффектов. Она используется в кинопроизводстве, рекламе, видеомонтаже, создании анимированной графики и многого другого.",
      "featureCard": {
        "text": "AfterEffect - стандарт индустрии по созданию графики и анимации"
      },
      "courseCard": {
        "title": "Adobe After Effects",
        "subtitle": "C нуля",
        "tagline": "В этом курсе вы узнаете всё о создании современной",
        "badge": "КУ"
      },
      "targetAudience": [
        {"icon": "book", "title": "Новичок в моушн-дизайне", "description": "Хотите создавать крутую анимацию с нуля", "color": "teal", "benefits": ["Пошаговое обучение", "Без требований к опыту"]},
        {"icon": "palette", "title": "Видеомейкер", "description": "Хотите добавить эффекты в свои видео", "color": "purple", "benefits": ["Профессиональные эффекты", "Интеграция с Premiere"]},
        {"icon": "briefcase", "title": "Фрилансер", "description": "Хотите брать заказы на анимацию", "color": "orange", "benefits": ["Реальные кейсы", "Портфолио проектов"]},
        {"icon": "zap", "title": "Контент-мейкер", "description": "Создаёте контент для YouTube/соцсетей", "color": "emerald", "benefits": ["Анимированные интро", "Визуальные эффекты"]}
      ]
    },
    "careerSection": {
          "title": "Сколько зарабатывают моушн-дизайнеры?",
          "description": "Специалисты по After Effects создают анимацию для рекламы, кино и контента — одна из самых креативных и высокооплачиваемых профессий",
          "vacancies": "1 700+",
          "growth": "+28%",
          "salaryLevels": [
                {
                      "title": "Начинающий (0-1 год)",
                      "salary": "60 000 ₽",
                      "progress": "30%"
                },
                {
                      "title": "Средний (1-3 года)",
                      "salary": "110 000 ₽",
                      "progress": "55%"
                },
                {
                      "title": "Профессионал (3+ лет)",
                      "salary": "180 000+ ₽",
                      "progress": "100%"
                }
          ],
          "source": "* По данным hh.ru и Хабр Карьера, 2025"
    },
    "skillsSection": {
          "skills": [
                {
                      "name": "Анимация и моушн-дизайн",
                      "level": "Продвинутый",
                      "progress": "90%"
                },
                {
                      "name": "Визуальные эффекты (VFX)",
                      "level": "Уверенный",
                      "progress": "75%"
                },
                {
                      "name": "Композитинг",
                      "level": "Уверенный",
                      "progress": "80%"
                },
                {
                      "name": "Работа с 3D-слоями",
                      "level": "Базовый",
                      "progress": "60%"
                }
          ],
          "opportunities": [
                {
                      "icon": "freelance",
                      "title": "Брать заказы на анимацию",
                      "description": "Создавать рекламные ролики и анимированную графику"
                },
                {
                      "icon": "company",
                      "title": "Работать в студии",
                      "description": "На позицию моушн-дизайнера или VFX-артиста"
                },
                {
                      "icon": "growth",
                      "title": "Развиваться дальше",
                      "description": "Перейти к Cinema 4D и продвинутой 3D-анимации"
                }
          ]
    },
    "curriculum": {
      "headline": "Программа курса",
      "description": "В этом курсе вы узнаете всё о создании современной и эффектной графики в программе After Effects! Получите востребованные навыки по созданию графики и анимации в After Effects!",
      "modules": [
        {
          "id": 1,
          "number": "01",
          "title": "Подготовка",
          "info": "4 лекции • 14м",
          "lessons": [
            {
              "lesson": "О чем курс",
              "time": "03:13"
            },
            {
              "lesson": "Скачиваем материалы и настраиваем интерфейс!",
              "time": "08:01"
            },
            {
              "lesson": "Где скачать лицензионный After Effects",
              "time": "02:15"
            },
            {
              "lesson": "Оставайтесь со мной на связи",
              "time": "00:12"
            }
          ]
        },
        {
          "id": 2,
          "number": "02",
          "title": "Основы After Effects",
          "info": "22 лекции • 3ч 35м",
          "lessons": [
            {
              "lesson": "О чем этот блок",
              "time": "01:18"
            },
            {
              "lesson": "Как создать композицию",
              "time": "12:33"
            },
            {
              "lesson": "Базовые горячие клавиши. Как работают слои",
              "time": "11:38"
            },
            {
              "lesson": "Если у вас потерялся исходник в проекте",
              "time": "03:29"
            },
            {
              "lesson": "Как работают фигуры. Настройки слоев",
              "time": "15:32"
            }
          ]
        },
        {
          "id": 3,
          "number": "03",
          "title": "Эффекты After Effects",
          "info": "6 лекций • 46м",
          "lessons": [
            {
              "lesson": "Как работают эффекты",
              "time": "10:17"
            },
            {
              "lesson": "Как обрезать футаж по середине",
              "time": "02:12"
            },
            {
              "lesson": "Разница эффектов и стилей слоев",
              "time": "10:54"
            },
            {
              "lesson": "Предпросмотр эффектов",
              "time": "05:51"
            },
            {
              "lesson": "Как добавить свой эффект в панель эффектов",
              "time": "06:49"
            }
          ]
        },
        {
          "id": 4,
          "number": "04",
          "title": "Маски",
          "info": "10 лекций • 1ч 52м",
          "lessons": [
            {
              "lesson": "Маска с помощью фигуры",
              "time": "08:48"
            },
            {
              "lesson": "Маска с помощью фигуры на практике",
              "time": "11:50"
            },
            {
              "lesson": "Что такое обтравочная маска",
              "time": "05:29"
            },
            {
              "lesson": "Обтравочная маска на практике",
              "time": "06:31"
            },
            {
              "lesson": "Как работает Track Matte",
              "time": "11:00"
            }
          ]
        },
        {
          "id": 5,
          "number": "05",
          "title": "Дополнительные инструменты",
          "info": "4 лекции • 30м",
          "lessons": [
            {
              "lesson": "Интерполяция ключевых точек",
              "time": "06:51"
            },
            {
              "lesson": "Как работает Parent & Link",
              "time": "09:57"
            },
            {
              "lesson": "Как создать счетчик из цифр",
              "time": "08:14"
            },
            {
              "lesson": "Grids, labels, markers",
              "time": "04:58"
            }
          ]
        },
        {
          "id": 6,
          "number": "06",
          "title": "3D & Camera",
          "info": "4 лекции • 30м",
          "lessons": [
            {
              "lesson": "Как работает 3D",
              "time": "10:48"
            },
            {
              "lesson": "Как создать свет в 3D",
              "time": "05:57"
            },
            {
              "lesson": "Доп настройки камеры",
              "time": "05:31"
            },
            {
              "lesson": "1-Node vs 2-Node Camera",
              "time": "07:36"
            }
          ]
        },
        {
          "id": 7,
          "number": "07",
          "title": "Плагины",
          "info": "1 лекция • 9м",
          "lessons": [
            {
              "lesson": "Как работают плагины",
              "time": "09:10"
            }
          ]
        },
        {
          "id": 8,
          "number": "08",
          "title": "After Effects Tracker",
          "info": "6 лекций • 53м",
          "lessons": [
            {
              "lesson": "Как работает Motion Tracker",
              "time": "19:39"
            },
            {
              "lesson": "Как работает Null Object",
              "time": "03:39"
            },
            {
              "lesson": "Как работает Camera Tracking",
              "time": "07:39"
            },
            {
              "lesson": "Как прикреплять элементы к Camera Tracker",
              "time": "08:06"
            },
            {
              "lesson": "Cinema 4D Делаем слои объемными",
              "time": "11:46"
            }
          ]
        },
        {
          "id": 9,
          "number": "09",
          "title": "AE + Adobe = Love",
          "info": "4 лекции • 52м",
          "lessons": [
            {
              "lesson": "AE + Illustrator",
              "time": "12:32"
            },
            {
              "lesson": "AE + Illustrator доп возможности",
              "time": "09:08"
            },
            {
              "lesson": "PS + AE. Как работать с Photoshop",
              "time": "22:16"
            },
            {
              "lesson": "AE + Premiere Pro",
              "time": "07:51"
            }
          ]
        },
        {
          "id": 10,
          "number": "10",
          "title": "Web анимации созданные в After Effects",
          "info": "1 лекция • 17м",
          "lessons": [
            {
              "lesson": "Lottie анимация на сайте",
              "time": "17:06"
            }
          ]
        },
        {
          "id": 11,
          "number": "11",
          "title": "Трекинг с помощью Mocha",
          "info": "8 лекций • 1ч 26м",
          "lessons": [
            {
              "lesson": "Знакомство с Mocha",
              "time": "17:18"
            },
            {
              "lesson": "Как соблюдать соотношение сторон",
              "time": "14:00"
            },
            {
              "lesson": "Подробнее про доп. композиции",
              "time": "05:52"
            },
            {
              "lesson": "Transform вместо corner pin",
              "time": "08:16"
            },
            {
              "lesson": "Разница Mocha и Tracker",
              "time": "07:34"
            }
          ]
        },
        {
          "id": 12,
          "number": "12",
          "title": "Green screen",
          "info": "2 лекции • 28м",
          "lessons": [
            {
              "lesson": "Как работать с green screen",
              "time": "15:08"
            },
            {
              "lesson": "Жан Клод Ван Дима",
              "time": "12:43"
            }
          ]
        },
        {
          "id": 13,
          "number": "13",
          "title": "До новых встреч!",
          "info": "1 лекция • 2м",
          "lessons": [
            {
              "lesson": "Заключение.",
              "time": "02:23"
            }
          ]
        }
      ]
    },
    "additionalCategories": [
      "С нуля"
    ]
  },
  {
    "id": 2,
    "slug": "design-theory",
    "skillspaceCourses": [{ "courseId": "15633", "groupId": "25263" }],
    "title": "Курс по теории дизайна",
    "subtitle": "C нуля",
    "description": "Этот курс состоит из трёх больших, теоретических тем, которые обязаны иметь в своей копилке знаний, каждый профессиональный дизайнер, фотограф или художник — это теория цвета, типографика и композиция!",
    "fullDescription": "Теория цвета, композиции и типографики — это фундаментальные основы дизайна, которые используются в графическом и веб-дизайне, рекламе, иллюстрации и брендинге. Они помогают создавать эстетически привлекательные, удобные и эффективные визуальные решения",
    "image": "/images/courses/design-theory-paper-v2.webp",
    "promoVideo": "https://rutube.ru/play/embed/0179ea6c46b044eaed5a58facf01b3e1",
    "price": 2290,
    "originalPrice": 3990,
    "discount": 43,
    "saleDiscount": 25,
    "category": "Веб Дизайн",
    "lessons": 62,
    "totalHours": 5.5,
    "duration": "1 месяц",
    "level": "С нуля",
    "students": 2500,
    "rating": 4.9,
    "reviewPlatforms": {
      "udemy": { "url": "https://www.udemy.com/course/cniiaptv/#reviews", "rating": 4.7, "count": 400 },
      "stepik": { "url": "https://stepik.org/course/104844/reviews", "rating": 5, "count": 150 }
    },
    "features": [
      "Интерактивность, общение с преподавателем",
      "Практические задания после каждого урока",
      "Реальные проекты для портфолио",
      "Пожизненный доступ к материалам"
    ],
    "stats": [
      {
        "value": "50K+",
        "label": "Просмотров"
      },
      {
        "value": "100K+",
        "label": "Студентов"
      },
      {
        "value": "150K+",
        "label": "Практических заданий"
      }
    ],
    "topics": [
      "Вы изучите теорию цвета",
      "Вы изучите искусство типографики",
      "Вы изучите правила композиции",
      "Изучите историю теории цвета",
      "Узнаете, как применять цветовой круг на практике",
      "Узнаете, как сочетать цвета, используя правила цветовой теории",
      "Разберётесь в цветовых моделях, таких как HSL, RGB, CMYK",
      "Поймёте технические моменты работы с цветом в современном графическом дизайне",
      "Поймёте психологические особенности влияния цвета на человека"
    ],
    "testimonials": [
      {
        "name": "Надежда",
        "role": "Студент курса",
        "text": "Прекрасный курс. Все четко, лаконично, понятно, без воды и длинных вступлений. Приятная подача, грамотная речь. Собрана база, которой удобно пользоваться, и которая точно пригодиться в работе. Мне, как новичку веб-дизайна, полученная информация точно раскрыла глаза на многие вещи. Теперь действительно, смотрю на работы коллег со знанием дела. Спасибо создателю курса. Обязательно найду для себя что-то еще.",
        "rating": 5
      },
      {
        "name": "Анастасия",
        "role": "Студент курса",
        "text": "Хочу поблагодарить Дмитрия за этот прекрасный курс, который стал моим первым полноценным курсом по дизайну. Я только начинаю свой путь в данной сфере, поэтому мне важно было сформировать хорошую базу для дальнейшего изучения UI/UX и веб-дизайна. Я считаю, что автор действительно вложил душу в создание курса, иначе уроки не получились бы такими увлекательными. Несмотря на то, что видео короткие, Дмитрий затронул большое количество тем, поэтому курс вполне исчерпывающий. Создать нечто подобное в одиночку, да ещё и за небольшую цену – это колоссальный труд, поэтому небольшие орфографические ошибки меня абсолютно не волновали. Ставлю курсу 100/10 и начинаю прохождение другого курса от Дмитрия.",
        "rating": 5
      }
    ],
    "aboutSection": {
      "headline": "Гармоничные цветовые сочетания, визуальный баланс, выразительная типографика и грамотное построение композиции. Всё это — теория цвета, композиции и типографики",
      "highlightedText": "",
      "description": "Теория цвета, композиции и типографики — это фундаментальные основы дизайна, которые используются в графическом и веб-дизайне, рекламе, иллюстрации и брендинге. Они помогают создавать эстетически привлекательные, удобные и эффективные визуальные решения",
      "featureCard": {
        "text": "Теория цвета, композиции и типографики — одни из самых важных основ визуального дизайна"
      },
      "courseCard": {
        "title": "теория дизайна",
        "subtitle": "C нуля",
        "tagline": "Этот курс состоит из трёх больших, теоретических т",
        "badge": "КУ"
      },
      "targetAudience": [
              {
                      "icon": "book",
                      "title": "Начинающий дизайнер",
                      "description": "Хотите понять основы дизайна",
                      "color": "teal",
                      "benefits": [
                              "Теоретическая база",
                              "Принципы композиции"
                      ]
              },
              {
                      "icon": "palette",
                      "title": "Самоучка",
                      "description": "Делаете дизайн, но хотите системных знаний",
                      "color": "purple",
                      "benefits": [
                              "Структурированный подход",
                              "Правила типографики"
                      ]
              },
              {
                      "icon": "briefcase",
                      "title": "Маркетолог",
                      "description": "Создаёте визуалы для рекламы",
                      "color": "orange",
                      "benefits": [
                              "Продающий дизайн",
                              "Работа с цветом"
                      ]
              },
              {
                      "icon": "zap",
                      "title": "Предприниматель",
                      "description": "Хотите делать дизайн для бизнеса",
                      "color": "emerald",
                      "benefits": [
                              "Быстрые результаты",
                              "Профессиональный вид"
                      ]
              }
      ]
    },
    "careerSection": {
          "title": "Зачем дизайнеру теория?",
          "description": "Знание основ дизайна повышает ценность специалиста на рынке и открывает путь к позициям арт-директора и лида",
          "vacancies": "8 500+",
          "growth": "+15%",
          "salaryLevels": [
                {
                      "title": "Junior-дизайнер",
                      "salary": "50 000 ₽",
                      "progress": "25%"
                },
                {
                      "title": "Middle-дизайнер",
                      "salary": "100 000 ₽",
                      "progress": "50%"
                },
                {
                      "title": "Арт-директор",
                      "salary": "200 000+ ₽",
                      "progress": "100%"
                }
          ],
          "source": "* По данным hh.ru и Хабр Карьера, 2025"
    },
    "skillsSection": {
          "skills": [
                {
                      "name": "Композиция и компоновка",
                      "level": "Продвинутый",
                      "progress": "90%"
                },
                {
                      "name": "Типографика",
                      "level": "Продвинутый",
                      "progress": "85%"
                },
                {
                      "name": "Теория цвета",
                      "level": "Уверенный",
                      "progress": "80%"
                },
                {
                      "name": "Визуальная иерархия",
                      "level": "Уверенный",
                      "progress": "75%"
                }
          ],
          "opportunities": [
                {
                      "icon": "freelance",
                      "title": "Создавать качественный дизайн",
                      "description": "Принимать обоснованные дизайн-решения"
                },
                {
                      "icon": "company",
                      "title": "Расти в профессии",
                      "description": "Претендовать на позицию арт-директора"
                },
                {
                      "icon": "growth",
                      "title": "Развиваться дальше",
                      "description": "Применять знания в UI/UX и веб-дизайне"
                }
          ]
    },
    "curriculum": {
      "headline": "Программа курса",
      "description": "Этот курс состоит из трёх больших, теоретических тем, которые обязаны иметь в своей копилке знаний, каждый профессиональный дизайнер, фотограф или художник — это теория цвета, типографика и композиция!",
      "modules": [
        {
          "id": 1,
          "number": "01",
          "title": "Введение",
          "info": "3 лекции • 7м",
          "lessons": [
            {
              "lesson": "О чем этот курс",
              "time": "03:24"
            },
            {
              "lesson": "Пара технических моментов",
              "time": "03:46"
            },
            {
              "lesson": "Оставайтесь со мной на связи",
              "time": "00:11"
            }
          ]
        },
        {
          "id": 2,
          "number": "02",
          "title": "Теория цвета",
          "info": "17 лекций • 1ч 42м",
          "lessons": [
            {
              "lesson": "Что такое теория цвета",
              "time": "01:36"
            },
            {
              "lesson": "Что такое цвет. Физика цвета",
              "time": "08:07"
            },
            {
              "lesson": "Знакомимся с первыми цветовыми кругами",
              "time": "03:57"
            },
            {
              "lesson": "Правила сочетания цветов",
              "time": "03:29"
            },
            {
              "lesson": "Ресурсы для работы с цветом",
              "time": "08:39"
            }
          ]
        },
        {
          "id": 3,
          "number": "03",
          "title": "Типографика",
          "info": "18 лекций • 1ч 51м",
          "lessons": [
            {
              "lesson": "Что такое типографика",
              "time": "03:30"
            },
            {
              "lesson": "Зачем изучать типографику",
              "time": "05:14"
            },
            {
              "lesson": "Пара слов перед большой темой",
              "time": "01:13"
            },
            {
              "lesson": "Шрифты с засечками",
              "time": "06:22"
            },
            {
              "lesson": "Шрифты без засечек",
              "time": "05:12"
            }
          ]
        },
        {
          "id": 4,
          "number": "04",
          "title": "Композиция",
          "info": "22 лекции • 1ч 41м",
          "lessons": [
            {
              "lesson": "Что такое композиция",
              "time": "04:08"
            },
            {
              "lesson": "Зачем изучать композицию",
              "time": "04:25"
            },
            {
              "lesson": "Нам нравится симметрия",
              "time": "07:38"
            },
            {
              "lesson": "Роль фигур в композиции",
              "time": "03:57"
            },
            {
              "lesson": "Баланс элементов",
              "time": "05:47"
            }
          ]
        },
        {
          "id": 5,
          "number": "05",
          "title": "Заключение",
          "info": "1 лекция • 1м",
          "lessons": [
            {
              "lesson": "До новых встреч!",
              "time": "01:15"
            }
          ]
        }
      ]
    },
    "additionalCategories": [
      "С нуля"
    ]
  },
  {
    "id": 3,
    "slug": "figma-animations",
    "skillspaceCourses": [{ "courseId": "15574", "groupId": "25181" }],
    "title": "Курс Figma Анимации",
    "subtitle": "C знаниями основ Figma",
    "description": "Курс Figma Motion и главные правила UX, погрузит вас в самые современные принципы создания анимированных веб сайтов в программе Figma.",
    "fullDescription": "Анимация — это важная часть современного дизайна. В этом курсе вы научитесь создавать впечатляющие анимации, микровзаимодействия и сложные интерфейсы, которые сделают ваши проекты более динамичными и привлекательными.",
    "image": "/images/courses/figma-animations-paper-v2.webp",
    "promoVideo": "https://rutube.ru/play/embed/6e8abdce526e144e58eebe7c0cccb85d",
    "price": 2290,
    "originalPrice": 3990,
    "discount": 43,
    "saleDiscount": 25,
    "category": "Веб Дизайн",
    "lessons": 61,
    "totalHours": 6.5,
    "duration": "1 месяц",
    "level": "Средний",
    "students": 2500,
    "rating": 4.9,
    "reviewPlatforms": {
      "udemy": { "url": "https://www.udemy.com/course/figma-motion-ux/#reviews", "rating": 4.8, "count": 600 },
      "stepik": { "url": "https://stepik.org/course/128116/reviews", "rating": 5, "count": 250 }
    },
    "features": [
      "Интерактивность, общение с преподавателем",
      "Практические задания после каждого урока",
      "Реальные проекты для портфолио",
      "Пожизненный доступ к материалам"
    ],
    "stats": [
      {
        "value": "50K+",
        "label": "Просмотров"
      },
      {
        "value": "100K+",
        "label": "Студентов"
      },
      {
        "value": "150K+",
        "label": "Практических заданий"
      }
    ],
    "topics": [
      "Изучите как создавать самые современные стили в Figma",
      "Узнаете как создавать эффекты ",
      "Узнаете как создать 3D из любой фигуры или элемента в Figma",
      "Узнаете современные способы использования и анимации градиента",
      "Узнаете все о создании анимаций в Figma",
      "Научитесь создавать анимацию 360 градусов прямо в Figma",
      "Сможете создавать анимацию как на сайте Apple",
      "Научитесь анимировать любые элементы страницы сайта, такие как кнопки, гамбургеры и т.д.",
      "Научитесь использовать "
    ],
    "testimonials": [
      {
        "name": "Дина",
        "role": "Студент курса",
        "text": "Дмитрий, спасибо за составленный курс!Вы очень профессионально его организовали: коротко и понятно, без лишних действий для учеников.Этот курс уже помог мне сменить должность с дизайнера на веб-дизайнера во время обучения за счет новых знаний в анимации, я применила их в работе.Мне понравилось то? что не было заморочек по выравниванию текста, блоков - это я итак применяю в своей работе по умолчанию. Понравилась легкость и автоматизация процессов.Я выбрала этот курс, потому что знания, полученные в нем показались мне актуальными и это подтвердилось на практике. Спасибо, успехов Вам, Дмитрий и нам, ученикам, в продвижении нашей практике в веб-дизайне!",
        "rating": 5
      },
      {
        "name": "Евгения",
        "role": "Студент курса",
        "text": "У Дмитрия все как всегда - понятно, просто, полезно! Это далеко не первый курс, который я прошла, поэтому однозначно могу сказать - курс прекрасный! Хочу курс еще дальше и больше в дизайн, работаю дизайнером уже несколько лет и все равно кажется что нужно что-то еще для изучения, нужны советы опытного человека! С удовольствием послушала бы какие-то наставления как двигаться дальше.",
        "rating": 5
      }
    ],
    "aboutSection": {
      "headline": "Создание анимаций, микровзаимодействий, сложных интерфейсов. Все это Курс по Анимации в Figma",
      "highlightedText": "",
      "description": "Анимация — это важная часть современного дизайна. В этом курсе вы научитесь создавать впечатляющие анимации, микровзаимодействия и сложные интерфейсы, которые сделают ваши проекты более динамичными и привлекательными.",
      "featureCard": {
        "text": "Анимация в Figma — это ключ к созданию интерактивных и впечатляющих интерфейсов."
      },
      "courseCard": {
        "title": "Figma Анимации",
        "subtitle": "C знаниями основ Figma",
        "tagline": "Курс Figma Motion и главные правила UX, погрузит в",
        "badge": "КУ"
      },
      "targetAudience": [
              {
                      "icon": "book",
                      "title": "UI/UX дизайнер",
                      "description": "Хотите оживить свои макеты",
                      "color": "teal",
                      "benefits": [
                              "Интерактивные прототипы",
                              "Микроанимации"
                      ]
              },
              {
                      "icon": "palette",
                      "title": "Веб-дизайнер",
                      "description": "Создаёте современные интерфейсы",
                      "color": "purple",
                      "benefits": [
                              "Плавные переходы",
                              "Hover-эффекты"
                      ]
              },
              {
                      "icon": "briefcase",
                      "title": "Продуктовый дизайнер",
                      "description": "Работаете над цифровыми продуктами",
                      "color": "orange",
                      "benefits": [
                              "Презентация идей",
                              "Прототипы для разработки"
                      ]
              },
              {
                      "icon": "zap",
                      "title": "Фрилансер",
                      "description": "Хотите выделиться среди конкурентов",
                      "color": "emerald",
                      "benefits": [
                              "WOW-эффект в портфолио",
                              "Больше заказов"
                      ]
              }
      ]
    },
    "careerSection": {
          "title": "Сколько зарабатывают UI/UX дизайнеры?",
          "description": "Навык анимации в Figma выделяет вас среди конкурентов и позволяет претендовать на более высокие позиции",
          "vacancies": "5 200+",
          "growth": "+42%",
          "salaryLevels": [
                {
                      "title": "Начинающий (0-1 год)",
                      "salary": "70 000 ₽",
                      "progress": "35%"
                },
                {
                      "title": "Средний (1-3 года)",
                      "salary": "130 000 ₽",
                      "progress": "65%"
                },
                {
                      "title": "Senior UI/UX",
                      "salary": "200 000+ ₽",
                      "progress": "100%"
                }
          ],
          "source": "* По данным hh.ru и Хабр Карьера, 2025"
    },
    "skillsSection": {
          "skills": [
                {
                      "name": "Интерактивные прототипы",
                      "level": "Продвинутый",
                      "progress": "90%"
                },
                {
                      "name": "Микроанимации",
                      "level": "Продвинутый",
                      "progress": "85%"
                },
                {
                      "name": "Smart Animate",
                      "level": "Уверенный",
                      "progress": "80%"
                },
                {
                      "name": "Презентация проектов",
                      "level": "Уверенный",
                      "progress": "75%"
                }
          ],
          "opportunities": [
                {
                      "icon": "freelance",
                      "title": "Впечатлять клиентов",
                      "description": "Создавать WOW-прототипы для презентаций"
                },
                {
                      "icon": "company",
                      "title": "Выделяться среди кандидатов",
                      "description": "Показывать живые интерфейсы на собеседованиях"
                },
                {
                      "icon": "growth",
                      "title": "Развиваться дальше",
                      "description": "Перейти к анимации в коде (Framer Motion)"
                }
          ]
    },
    "curriculum": {
      "headline": "Программа курса",
      "description": "Курс Figma Motion и главные правила UX, погрузит вас в самые современные принципы создания анимированных веб сайтов в программе Figma.",
      "modules": [
        {
          "id": 1,
          "number": "01",
          "title": "Введение в прототипирование",
          "info": "3 урока",
          "lessons": [
            { "lesson": "Первая анимация" },
            { "lesson": "Настройки вкладки Prototype" },
            { "lesson": "Основные настройки анимирования" }
          ]
        },
        {
          "id": 2,
          "number": "02",
          "title": "Базовая настройка прототипов",
          "info": "6 уроков",
          "lessons": [
            { "lesson": "Как работает настройка скроллинга" },
            { "lesson": "Как работают Fixed & Sticky" },
            { "lesson": "Анимируем приложение" },
            { "lesson": "Подробно про настройку open overlay" },
            { "lesson": "Поведение анимации во времени (Кривые)" },
            { "lesson": "Создаем анимацию nav menu" }
          ]
        },
        {
          "id": 3,
          "number": "03",
          "title": "Компоненты и варианты",
          "info": "6 уроков",
          "lessons": [
            { "lesson": "Как работают компоненты" },
            { "lesson": "Как работают варианты" },
            { "lesson": "Как работает swap instance" },
            { "lesson": "Знакомство с переменными" },
            { "lesson": "Особенности вариантов в прототипировании" },
            { "lesson": "Прототипирование вариантами меню" }
          ]
        },
        {
          "id": 4,
          "number": "04",
          "title": "Компоненты в анимировании",
          "info": "6 уроков",
          "lessons": [
            { "lesson": "Создаем прелоадер приложения" },
            { "lesson": "Прелоадер с помощью вариантов" },
            { "lesson": "Создаем параллакс эффект. Часть 1" },
            { "lesson": "Создаем параллакс эффект. Часть 2" },
            { "lesson": "2 действия на 1 триггер" },
            { "lesson": "Делаем еще один параллакс эффект" }
          ]
        },
        {
          "id": 5,
          "number": "05",
          "title": "Video and 3D Animation",
          "info": "3 урока",
          "lessons": [
            { "lesson": "Разница платной и бесплатной Figma" },
            { "lesson": "Покадровое прототипирование видео" },
            { "lesson": "3D Анимация" }
          ]
        },
        {
          "id": 6,
          "number": "06",
          "title": "Как профессионально использовать переменные",
          "info": "4 урока",
          "lessons": [
            { "lesson": "Создаем переменные цвета" },
            { "lesson": "Что такое токены и alias" },
            { "lesson": "Создаем токены для всех свойств" },
            { "lesson": "Темная и светлая тема в 1 клик" }
          ]
        },
        {
          "id": 7,
          "number": "07",
          "title": "Прототипирование переменных",
          "info": "7 уроков",
          "lessons": [
            { "lesson": "How Set Variable Mode Works" },
            { "lesson": "Прототипируем табы переменными" },
            { "lesson": "Изменение нескольких переменных за раз" },
            { "lesson": "Как работает ветвление IF / else" },
            { "lesson": "Финальная практика" },
            { "lesson": "Пример преподавателя. Часть 1" },
            { "lesson": "Пример преподавателя. Часть 2" }
          ]
        },
        {
          "id": 8,
          "number": "08",
          "title": "Бонус. Дополнительные анимации",
          "info": "6 уроков",
          "lessons": [
            { "lesson": "Анимация градиента" },
            { "lesson": "Как работают режимы наложения" },
            { "lesson": "Как работает Paper Cut Effect" },
            { "lesson": "Как создать эффект 3D" },
            { "lesson": "Создаем объемную иконку Figma" },
            { "lesson": "Создаем 3D элементы на стартовой странице сайта" }
          ]
        }
      ]
    },
    "additionalCategories": [
      "Продвинутый уровень"
    ]
  },
  {
    "id": 4,
    "slug": "figma-pro-self",
    "skillspaceCourses": [{ "courseId": "98232", "groupId": "" }],
    "title": "Веб дизайн в Figma - Pro | Самостоятельный курс",
    "subtitle": "Cо знаниями Figma",
    "description": "Освойте правила современного веб-дизайна и создавайте профессиональные макеты в Figma. (Бонус: использование нейросетей в дизайне)",
    "fullDescription": "Большой практический курс, посвящённый современному веб-дизайну, визуальному стилю и правилам, по которым создают сайты профессионалы.",
    "image": "/images/courses/figma-pro-self-paper-v3.webp",
    "promoVideo": "https://rutube.ru/play/embed/a587e83c6b863ce741d904854c4b8bf1",
    "price": 2790,
    "originalPrice": 4990,
    "discount": 44,
    "saleDiscount": 25,
    "category": "Веб Дизайн",
    "lessons": 108,
    "totalHours": 12.5,
    "duration": "6 недель обучения",
    "level": "Средний",
    "students": 2500,
    "rating": 4.9,
    "reviewPlatforms": {
      "udemy": { "url": "https://www.udemy.com/course/figma-pro-level/#reviews", "rating": 4.8, "count": 350 },
      "stepik": { "url": "https://stepik.org/course/261291/promo#reviews", "rating": 5, "count": 100 }
    },
    "features": [
      "Интерактивность, общение с преподавателем",
      "Практические задания после каждого урока",
      "Реальные проекты для портфолио",
      "Пожизненный доступ к материалам"
    ],
    "stats": [
      {
        "value": "50K+",
        "label": "Просмотров"
      },
      {
        "value": "100K+",
        "label": "Студентов"
      },
      {
        "value": "150K+",
        "label": "Практических заданий"
      }
    ],
    "topics": [
      "Научитесь создавать современные и стильные макеты сайтов",
      "Изучите десятки правил современного веб-дизайна",
      "Научитесь применять правила веб-дизайна на практике в реальных задачах",
      "Научитесь строить сетки и направляющие для структуры макета",
      "Научитесь настраивать отступы, ритм и визуальный порядок в макете",
      "Изучите методы работы с типографикой",
      "Изучите правила композиции в веб-дизайне",
      "Научитесь создавать аккуратные и модульные композиции",
      "Изучите методы работы с цветом: палитры, контраст, акценты"
    ],
    "testimonials": [
      {
        "name": "Виктория",
        "role": "Студент курса",
        "text": "Интенсивный, но очень понятный курс! Я разобралась в типографике, научилась создавать модульные композиции и использовать тени так, чтобы макеты выглядели дорого. После финального проекта мой руководитель сказал, что дизайн стал более зрелым. Огромное спасибо!",
        "rating": 5
      },
      {
        "name": "Павел",
        "role": "Студент курса",
        "text": "Это уже второй курс, который я прохожу у Дмитрия, и он — лучший! Узнал много современных техник и потренировался применять ИИ в веб-дизайне. Midjourney и Firefly теперь в списке моих рабочих инструментов. Сделал сильный проект для портфолио. Поддержка — супер!",
        "rating": 5
      }
    ],
    "aboutSection": {
      "headline": "О том, как сделать работу сильной визуально, логически продуманной, структурированной и современной.",
      "highlightedText": "",
      "description": "Большой практический курс, посвящённый современному веб-дизайну, визуальному стилю и правилам, по которым создают сайты профессионалы.",
      "featureCard": {
        "text": "Здесь мы говорим не о кнопках Figma — а о современных правилах дизайна."
      },
      "courseCard": {
        "title": "Веб дизайн в Figma - Pro | Самостоятельный курс",
        "subtitle": "Cо знаниями Figma",
        "tagline": "Освойте правила современного веб-дизайна и создава",
        "badge": "ВЕ"
      },
      "targetAudience": [
              {
                      "icon": "book",
                      "title": "Новичок в дизайне",
                      "description": "Хотите освоить Figma с нуля",
                      "color": "teal",
                      "benefits": [
                              "От основ к продвинутому",
                              "Самостоятельное обучение"
                      ]
              },
              {
                      "icon": "palette",
                      "title": "Дизайнер из другой программы",
                      "description": "Переходите на Figma",
                      "color": "purple",
                      "benefits": [
                              "Быстрая адаптация",
                              "Новые возможности"
                      ]
              },
              {
                      "icon": "briefcase",
                      "title": "Фрилансер",
                      "description": "Хотите работать с современным инструментом",
                      "color": "orange",
                      "benefits": [
                              "Командная работа",
                              "Облачные проекты"
                      ]
              },
              {
                      "icon": "zap",
                      "title": "Разработчик",
                      "description": "Хотите понимать дизайн-макеты",
                      "color": "emerald",
                      "benefits": [
                              "Dev Mode",
                              "Экспорт ассетов"
                      ]
              }
      ]
    },
    "careerSection": {
          "title": "Сколько зарабатывают Figma-дизайнеры?",
          "description": "Figma — стандарт индустрии. Владение этим инструментом открывает двери в лучшие компании",
          "vacancies": "5 200+",
          "growth": "+42%",
          "salaryLevels": [
                {
                      "title": "Начинающий (0-1 год)",
                      "salary": "60 000 ₽",
                      "progress": "30%"
                },
                {
                      "title": "Средний (1-3 года)",
                      "salary": "120 000 ₽",
                      "progress": "60%"
                },
                {
                      "title": "Senior-дизайнер",
                      "salary": "200 000+ ₽",
                      "progress": "100%"
                }
          ],
          "source": "* По данным hh.ru и Хабр Карьера, 2025"
    },
    "skillsSection": {
          "skills": [
                {
                      "name": "Дизайн интерфейсов",
                      "level": "Продвинутый",
                      "progress": "90%"
                },
                {
                      "name": "Компоненты и варианты",
                      "level": "Продвинутый",
                      "progress": "85%"
                },
                {
                      "name": "Auto Layout",
                      "level": "Уверенный",
                      "progress": "80%"
                },
                {
                      "name": "Дизайн-системы",
                      "level": "Уверенный",
                      "progress": "75%"
                }
          ],
          "opportunities": [
                {
                      "icon": "freelance",
                      "title": "Брать заказы на дизайн",
                      "description": "Создавать UI/UX дизайн сайтов и приложений"
                },
                {
                      "icon": "company",
                      "title": "Устроиться дизайнером",
                      "description": "На позицию Junior/Middle UI/UX дизайнера"
                },
                {
                      "icon": "growth",
                      "title": "Развиваться дальше",
                      "description": "Освоить анимации в Figma и прототипирование"
                }
          ]
    },
    "curriculum": {
      "headline": "Программа курса",
      "description": "Освойте правила современного веб-дизайна и создавайте профессиональные макеты в Figma. (Бонус: использование нейросетей в дизайне)",
      "modules": [
        {
          "id": 1,
          "number": "01",
          "title": "Введение",
          "info": "5 лекций • 17м",
          "lessons": [
            {
              "lesson": "О чем курс",
              "time": "02:13"
            },
            {
              "lesson": "Скачиваем материалы к курсу",
              "time": "02:01"
            },
            {
              "lesson": "Это мультиязычный курс",
              "time": "03:15"
            },
            {
              "lesson": "Как проходить курс",
              "time": "02:12"
            },
            {
              "lesson": "Как задавать вопросы",
              "time": "07:18"
            }
          ]
        },
        {
          "id": 2,
          "number": "02",
          "title": "Типографика",
          "info": "10 лекций • 1ч 38м",
          "lessons": [
            {
              "lesson": "Консистентность — это самое главное",
              "time": "09:18"
            },
            {
              "lesson": "Самый первый UXUI в мире",
              "time": "13:33"
            },
            {
              "lesson": "Правильные настройки текста в веб-дизайне",
              "time": "05:38"
            },
            {
              "lesson": "Типы шрифтов",
              "time": "09:59"
            },
            {
              "lesson": "Как выбрать шрифт для проекта",
              "time": "03:49"
            }
          ]
        },
        {
          "id": 3,
          "number": "03",
          "title": "Насмотренность и вдохновение",
          "info": "5 лекций • 29м",
          "lessons": [
            {
              "lesson": "Дилема дизайнера",
              "time": "06:17"
            },
            {
              "lesson": "Ресурсы для насмотренности",
              "time": "05:12"
            },
            {
              "lesson": "Плагины для насмотренности",
              "time": "09:54"
            },
            {
              "lesson": "Стили сайтов в веб-дизайне",
              "time": "07:51"
            },
            {
              "lesson": "Используйте нейросети для насмотренности",
              "time": "16:49"
            }
          ]
        },
        {
          "id": 4,
          "number": "04",
          "title": "Сетки и направляющие",
          "info": "7 лекций • 1ч 5м",
          "lessons": [
            {
              "lesson": "Типы сеток",
              "time": "10:08"
            },
            {
              "lesson": "Создайте неудобную сетку",
              "time": "04:50"
            },
            {
              "lesson": "Анализируйте чужие сетки",
              "time": "08:28"
            },
            {
              "lesson": "Итоги — Типографика и сетки",
              "time": "07:33"
            },
            {
              "lesson": "Практика # 2 —  Разместите контент в сетке",
              "time": "04:06"
            }
          ]
        },
        {
          "id": 5,
          "number": "05",
          "title": "Первый проект",
          "info": "15 лекций • 2ч 16м",
          "lessons": [
            {
              "lesson": "Задача и описание проекта",
              "time": "10:51"
            },
            {
              "lesson": "Дополнение. Где брать фото",
              "time": "07:57"
            },
            {
              "lesson": "Создаем модульную сетку",
              "time": "04:14"
            },
            {
              "lesson": "Создаем Hero Section, часть 1",
              "time": "07:08"
            },
            {
              "lesson": "Создаем Hero Section, часть 2",
              "time": "08:18"
            }
          ]
        },
        {
          "id": 6,
          "number": "06",
          "title": "Отступы",
          "info": "3 лекции • 11м",
          "lessons": [
            {
              "lesson": "Правило прямого угла",
              "time": "05:48"
            },
            {
              "lesson": "Какие отступы использовать?",
              "time": "07:57"
            },
            {
              "lesson": "Использование пустого пространства в дизайне",
              "time": "04:31"
            }
          ]
        },
        {
          "id": 7,
          "number": "07",
          "title": "Визуальная иерархия",
          "info": "8 лекций • 55м",
          "lessons": [
            {
              "lesson": "Что такое визуальная иерархия",
              "time": "11:10"
            },
            {
              "lesson": "Уровни визуальной иерархии",
              "time": "06:10"
            },
            {
              "lesson": "Какой элемент важнее",
              "time": "16:10"
            },
            {
              "lesson": "Как использовать серый цвет",
              "time": "07:10"
            },
            {
              "lesson": "Делайте наоборот. Уберите акценты с ненужного",
              "time": "02:10"
            }
          ]
        },
        {
          "id": 8,
          "number": "08",
          "title": "Границы и скругление элементов",
          "info": "2 лекции • 9м",
          "lessons": [
            {
              "lesson": "Каким должено быть скругление углов",
              "time": "05:39"
            },
            {
              "lesson": "Консистентное скругление углов",
              "time": "07:29"
            }
          ]
        },
        {
          "id": 9,
          "number": "09",
          "title": "Цвет",
          "info": "14 лекций • 1ч 17м",
          "lessons": [
            {
              "lesson": "Проблема подхода 60·30·10",
              "time": "11:32"
            },
            {
              "lesson": "Как создавать цветовую шкалу",
              "time": "08:08"
            },
            {
              "lesson": "Создаем шкалу на практике",
              "time": "11:16"
            },
            {
              "lesson": "Правило 60·30·10 и шкала цвета",
              "time": "04:35"
            },
            {
              "lesson": "Необязательно использовать только 3 цвета",
              "time": "4:51"
            }
          ]
        },
        {
          "id": 10,
          "number": "10",
          "title": "Изображения",
          "info": "4 лекции • 22м",
          "lessons": [
            {
              "lesson": "Как размещать текст на изображениях",
              "time": "07:06"
            },
            {
              "lesson": "Какие изображения использовать",
              "time": "13:08"
            },
            {
              "lesson": "Как работать с иконками",
              "time": "16:08"
            },
            {
              "lesson": "Как использовать скриншоты в дизайне",
              "time": "11:16"
            }
          ]
        },
        {
          "id": 11,
          "number": "11",
          "title": "Искусственный интеллект в изображениях",
          "info": "10 лекции • 53м",
          "lessons": [
            {
              "lesson": "Про ИИ-изображения",
              "time": "03:18"
            },
            {
              "lesson": "Функционал и цены на ИИ",
              "time": "06:50"
            },
            {
              "lesson": "Удаление заднего фона  с помощью ИИ",
              "time": "05:22"
            },
            {
              "lesson": "Удаление объектов  с помощью ИИ",
              "time": "04:33"
            },
            {
              "lesson": "Расширение границ изображений с помощью ИИ",
              "time": "08:20"
            }
          ]
        },
        {
          "id": 12,
          "number": "12",
          "title": "Тени",
          "info": "3 лекции • 19м",
          "lessons": [
            {
              "lesson": "О тенях",
              "time": "07:08"
            },
            {
              "lesson": "Техники и приемы работы с тенями",
              "time": "05:43"
            },
            {
              "lesson": "Практика # 5 —  Применяем эффекты теней правильно",
              "time": "08:52"
            }
          ]
        },
        {
          "id": 13,
          "number": "13",
          "title": "Мобильный дизайн",
          "info": "7 лекций • 1ч 24м",
          "lessons": [
            {
              "lesson": "Особенности мобильного дизайна",
              "time": "07:23"
            },
            {
              "lesson": "Размер текста на мобильных устройствах",
              "time": "03:31"
            },
            {
              "lesson": "Размеры и выравнивание элементов",
              "time": "3:42"
            },
            {
              "lesson": "Практика # 6 —  Адаптируйте первый проект",
              "time": "9:32"
            },
            {
              "lesson": "Практика # 6 —  Выполненная ч. 1",
              "time": "03:18"
            }
          ]
        },
        {
          "id": 14,
          "number": "14",
          "title": "Визуальные приемы в дизайне",
          "info": "2 лекции • 11м",
          "lessons": [
            {
              "lesson": "О визуальных приёмах",
              "time": "08:48"
            },
            {
              "lesson": "Полезные ресурсы для веб-дизайнеров",
              "time": "05:33"
            }
          ]
        },
        {
          "id": 15,
          "number": "15",
          "title": "Второй проект",
          "info": "12 лекций • 1ч 51м",
          "lessons": [
            {
              "lesson": "Обзор и задачи проекта",
              "time": "03:48"
            },
            {
              "lesson": "Подготовка и поиск референсов",
              "time": "08:48"
            },
            {
              "lesson": "Создаём Hero Section",
              "time": "06:48"
            },
            {
              "lesson": "Создаем навигационное меню",
              "time": "03:48"
            },
            {
              "lesson": "Создаем декоративные линии",
              "time": "03:42"
            }
          ]
        }
      ]
    },
    "additionalCategories": [
      "Продвинутый уровень"
    ]
  },
  {
    "id": 5,
    "slug": "figma-pro-support",
    "skillspaceCourses": [{ "courseId": "98232", "groupId": "" }],
    "title": "Веб дизайн в Figma - Pro | Курс с проверкой ДЗ автором",
    "subtitle": "Cо знаниями Figma",
    "description": "Освойте правила современного веб-дизайна и создавайте профессиональные макеты в Figma. (Бонус: использование нейросетей в дизайне)",
    "fullDescription": "Большой практический курс, посвящённый современному веб-дизайну, визуальному стилю и правилам, по которым создают сайты профессионалы.",
    "image": "/images/courses/figma-pro-support-paper-v3.webp",
    "promoVideo": "https://rutube.ru/play/embed/a587e83c6b863ce741d904854c4b8bf1",
    "price": 7990,
    "originalPrice": 9990,
    "discount": 20,
    "saleDiscount": 10,
    "category": "Веб Дизайн",
    "lessons": 108,
    "totalHours": 12.5,
    "duration": "6 недель обучения",
    "level": "Средний",
    "students": 2500,
    "rating": 4.9,
    "reviewPlatforms": {
      "udemy": { "url": "https://www.udemy.com/course/figma-pro-level/#reviews", "rating": 4.8, "count": 350 },
      "stepik": { "url": "https://stepik.org/course/261291/promo#reviews", "rating": 5, "count": 100 }
    },
    "features": [
      "Интерактивность, общение с преподавателем",
      "Практические задания после каждого урока",
      "Реальные проекты для портфолио",
      "Пожизненный доступ к материалам"
    ],
    "stats": [
      {
        "value": "50K+",
        "label": "Просмотров"
      },
      {
        "value": "100K+",
        "label": "Студентов"
      },
      {
        "value": "150K+",
        "label": "Практических заданий"
      }
    ],
    "topics": [
      "Научитесь создавать современные и стильные макеты сайтов",
      "Изучите десятки правил современного веб-дизайна",
      "Научитесь применять правила веб-дизайна на практике в реальных задачах",
      "Научитесь строить сетки и направляющие для структуры макета",
      "Научитесь настраивать отступы, ритм и визуальный порядок в макете",
      "Изучите методы работы с типографикой",
      "Изучите правила композиции в веб-дизайне",
      "Научитесь создавать аккуратные и модульные композиции",
      "Изучите методы работы с цветом: палитры, контраст, акценты"
    ],
    "testimonials": [
      {
        "name": "Виктория",
        "role": "Студент курса",
        "text": "Интенсивный, но очень понятный курс! Я разобралась в типографике, научилась создавать модульные композиции и использовать тени так, чтобы макеты выглядели дорого. После финального проекта мой руководитель сказал, что дизайн стал более зрелым. Огромное спасибо!",
        "rating": 5
      },
      {
        "name": "Павел",
        "role": "Студент курса",
        "text": "Это уже второй курс, который я прохожу у Дмитрия, и он — лучший! Узнал много современных техник и потренировался применять ИИ в веб-дизайне. Midjourney и Firefly теперь в списке моих рабочих инструментов. Сделал сильный проект для портфолио. Поддержка — супер!",
        "rating": 5
      }
    ],
    "aboutSection": {
      "headline": "О том, как сделать работу сильной визуально, логически продуманной, структурированной и современной.",
      "highlightedText": "",
      "description": "Большой практический курс, посвящённый современному веб-дизайну, визуальному стилю и правилам, по которым создают сайты профессионалы.",
      "featureCard": {
        "text": "Здесь мы говорим не о кнопках Figma — а о современных правилах дизайна."
      },
      "courseCard": {
        "title": "Освойте правила современного веб-дизайна и создавайте профессиональные макеты в Figma. (Бонус: использование нейросетей в дизайне)",
        "subtitle": "Cо знаниями Figma",
        "tagline": "Освойте правила современного веб-дизайна и создава",
        "badge": "ОС"
      },
      "targetAudience": [
              {
                      "icon": "book",
                      "title": "Новичок в дизайне",
                      "description": "Хотите освоить Figma с поддержкой",
                      "color": "teal",
                      "benefits": [
                              "Обратная связь",
                              "Проверка заданий"
                      ]
              },
              {
                      "icon": "palette",
                      "title": "Дизайнер",
                      "description": "Хотите углубить знания Figma",
                      "color": "purple",
                      "benefits": [
                              "Продвинутые техники",
                              "Ответы на вопросы"
                      ]
              },
              {
                      "icon": "briefcase",
                      "title": "Начинающий фрилансер",
                      "description": "Нужна поддержка в начале пути",
                      "color": "orange",
                      "benefits": [
                              "Менторство",
                              "Помощь с заказами"
                      ]
              },
              {
                      "icon": "zap",
                      "title": "Карьерист",
                      "description": "Хотите устроиться дизайнером",
                      "color": "emerald",
                      "benefits": [
                              "Портфолио",
                              "Сертификат"
                      ]
              }
      ]
    },
    "careerSection": {
          "title": "Сколько зарабатывают Figma-дизайнеры?",
          "description": "Figma — стандарт индустрии. С поддержкой ментора вы быстрее выйдете на рынок труда",
          "vacancies": "5 200+",
          "growth": "+42%",
          "salaryLevels": [
                {
                      "title": "Начинающий (0-1 год)",
                      "salary": "60 000 ₽",
                      "progress": "30%"
                },
                {
                      "title": "Средний (1-3 года)",
                      "salary": "120 000 ₽",
                      "progress": "60%"
                },
                {
                      "title": "Senior-дизайнер",
                      "salary": "200 000+ ₽",
                      "progress": "100%"
                }
          ],
          "source": "* По данным hh.ru и Хабр Карьера, 2025"
    },
    "skillsSection": {
          "skills": [
                {
                      "name": "Дизайн интерфейсов",
                      "level": "Продвинутый",
                      "progress": "90%"
                },
                {
                      "name": "Компоненты и варианты",
                      "level": "Продвинутый",
                      "progress": "85%"
                },
                {
                      "name": "Auto Layout",
                      "level": "Уверенный",
                      "progress": "80%"
                },
                {
                      "name": "Дизайн-системы",
                      "level": "Уверенный",
                      "progress": "75%"
                }
          ],
          "opportunities": [
                {
                      "icon": "freelance",
                      "title": "Получить первые заказы",
                      "description": "С поддержкой ментора начать зарабатывать"
                },
                {
                      "icon": "company",
                      "title": "Устроиться дизайнером",
                      "description": "Подготовить портфолио с обратной связью"
                },
                {
                      "icon": "growth",
                      "title": "Развиваться дальше",
                      "description": "Получить сертификат и рекомендации"
                }
          ]
    },
    "curriculum": {
      "headline": "Программа курса",
      "description": "Освойте правила современного веб-дизайна и создавайте профессиональные макеты в Figma. (Бонус: использование нейросетей в дизайне)",
      "modules": [
        {
          "id": 1,
          "number": "01",
          "title": "Введение",
          "info": "5 лекций • 17м",
          "lessons": [
            {
              "lesson": "О чем курс",
              "time": "02:13"
            },
            {
              "lesson": "Скачиваем материалы к курсу",
              "time": "02:01"
            },
            {
              "lesson": "Это мультиязычный курс",
              "time": "03:15"
            },
            {
              "lesson": "Как проходить курс",
              "time": "02:12"
            },
            {
              "lesson": "Как задавать вопросы",
              "time": "07:18"
            }
          ]
        },
        {
          "id": 2,
          "number": "02",
          "title": "Типографика",
          "info": "10 лекций • 1ч 38м",
          "lessons": [
            {
              "lesson": "Консистентность — это самое главное",
              "time": "09:18"
            },
            {
              "lesson": "Самый первый UXUI в мире",
              "time": "13:33"
            },
            {
              "lesson": "Правильные настройки текста в веб-дизайне",
              "time": "05:38"
            },
            {
              "lesson": "Типы шрифтов",
              "time": "09:59"
            },
            {
              "lesson": "Как выбрать шрифт для проекта",
              "time": "03:49"
            }
          ]
        },
        {
          "id": 3,
          "number": "03",
          "title": "Насмотренность и вдохновение",
          "info": "5 лекций • 29м",
          "lessons": [
            {
              "lesson": "Дилема дизайнера",
              "time": "06:17"
            },
            {
              "lesson": "Ресурсы для насмотренности",
              "time": "05:12"
            },
            {
              "lesson": "Плагины для насмотренности",
              "time": "09:54"
            },
            {
              "lesson": "Стили сайтов в веб-дизайне",
              "time": "07:51"
            },
            {
              "lesson": "Используйте нейросети для насмотренности",
              "time": "16:49"
            }
          ]
        },
        {
          "id": 4,
          "number": "04",
          "title": "Сетки и направляющие",
          "info": "7 лекций • 1ч 5м",
          "lessons": [
            {
              "lesson": "Типы сеток",
              "time": "10:08"
            },
            {
              "lesson": "Создайте неудобную сетку",
              "time": "04:50"
            },
            {
              "lesson": "Анализируйте чужие сетки",
              "time": "08:28"
            },
            {
              "lesson": "Итоги — Типографика и сетки",
              "time": "07:33"
            },
            {
              "lesson": "Практика # 2 —  Разместите контент в сетке",
              "time": "04:06"
            }
          ]
        },
        {
          "id": 5,
          "number": "05",
          "title": "Первый проект",
          "info": "15 лекций • 2ч 16м",
          "lessons": [
            {
              "lesson": "Задача и описание проекта",
              "time": "10:51"
            },
            {
              "lesson": "Дополнение. Где брать фото",
              "time": "07:57"
            },
            {
              "lesson": "Создаем модульную сетку",
              "time": "04:14"
            },
            {
              "lesson": "Создаем Hero Section, часть 1",
              "time": "07:08"
            },
            {
              "lesson": "Создаем Hero Section, часть 2",
              "time": "08:18"
            }
          ]
        },
        {
          "id": 6,
          "number": "06",
          "title": "Отступы",
          "info": "3 лекции • 11м",
          "lessons": [
            {
              "lesson": "Правило прямого угла",
              "time": "05:48"
            },
            {
              "lesson": "Какие отступы использовать?",
              "time": "07:57"
            },
            {
              "lesson": "Использование пустого пространства в дизайне",
              "time": "04:31"
            }
          ]
        },
        {
          "id": 7,
          "number": "07",
          "title": "Визуальная иерархия",
          "info": "8 лекций • 55м",
          "lessons": [
            {
              "lesson": "Что такое визуальная иерархия",
              "time": "11:10"
            },
            {
              "lesson": "Уровни визуальной иерархии",
              "time": "06:10"
            },
            {
              "lesson": "Какой элемент важнее",
              "time": "16:10"
            },
            {
              "lesson": "Как использовать серый цвет",
              "time": "07:10"
            },
            {
              "lesson": "Делайте наоборот. Уберите акценты с ненужного",
              "time": "02:10"
            }
          ]
        },
        {
          "id": 8,
          "number": "08",
          "title": "Границы и скругление элементов",
          "info": "2 лекции • 9м",
          "lessons": [
            {
              "lesson": "Каким должено быть скругление углов",
              "time": "05:39"
            },
            {
              "lesson": "Консистентное скругление углов",
              "time": "07:29"
            }
          ]
        },
        {
          "id": 9,
          "number": "09",
          "title": "Цвет",
          "info": "14 лекций • 1ч 17м",
          "lessons": [
            {
              "lesson": "Проблема подхода 60·30·10",
              "time": "11:32"
            },
            {
              "lesson": "Как создавать цветовую шкалу",
              "time": "08:08"
            },
            {
              "lesson": "Создаем шкалу на практике",
              "time": "11:16"
            },
            {
              "lesson": "Правило 60·30·10 и шкала цвета",
              "time": "04:35"
            },
            {
              "lesson": "Необязательно использовать только 3 цвета",
              "time": "4:51"
            }
          ]
        },
        {
          "id": 10,
          "number": "10",
          "title": "Изображения",
          "info": "4 лекции • 22м",
          "lessons": [
            {
              "lesson": "Как размещать текст на изображениях",
              "time": "07:06"
            },
            {
              "lesson": "Какие изображения использовать",
              "time": "13:08"
            },
            {
              "lesson": "Как работать с иконками",
              "time": "16:08"
            },
            {
              "lesson": "Как использовать скриншоты в дизайне",
              "time": "11:16"
            }
          ]
        },
        {
          "id": 11,
          "number": "11",
          "title": "Искусственный интеллект в изображениях",
          "info": "10 лекции • 53м",
          "lessons": [
            {
              "lesson": "Про ИИ-изображения",
              "time": "03:18"
            },
            {
              "lesson": "Функционал и цены на ИИ",
              "time": "06:50"
            },
            {
              "lesson": "Удаление заднего фона  с помощью ИИ",
              "time": "05:22"
            },
            {
              "lesson": "Удаление объектов  с помощью ИИ",
              "time": "04:33"
            },
            {
              "lesson": "Расширение границ изображений с помощью ИИ",
              "time": "08:20"
            }
          ]
        },
        {
          "id": 12,
          "number": "12",
          "title": "Тени",
          "info": "3 лекции • 19м",
          "lessons": [
            {
              "lesson": "О тенях",
              "time": "07:08"
            },
            {
              "lesson": "Техники и приемы работы с тенями",
              "time": "05:43"
            },
            {
              "lesson": "Практика # 5 —  Применяем эффекты теней правильно",
              "time": "08:52"
            }
          ]
        },
        {
          "id": 13,
          "number": "13",
          "title": "Мобильный дизайн",
          "info": "7 лекций • 1ч 24м",
          "lessons": [
            {
              "lesson": "Особенности мобильного дизайна",
              "time": "07:23"
            },
            {
              "lesson": "Размер текста на мобильных устройствах",
              "time": "03:31"
            },
            {
              "lesson": "Размеры и выравнивание элементов",
              "time": "3:42"
            },
            {
              "lesson": "Практика # 6 —  Адаптируйте первый проект",
              "time": "9:32"
            },
            {
              "lesson": "Практика # 6 —  Выполненная ч. 1",
              "time": "03:18"
            }
          ]
        },
        {
          "id": 14,
          "number": "14",
          "title": "Визуальные приемы в дизайне",
          "info": "2 лекции • 11м",
          "lessons": [
            {
              "lesson": "О визуальных приёмах",
              "time": "08:48"
            },
            {
              "lesson": "Полезные ресурсы для веб-дизайнеров",
              "time": "05:33"
            }
          ]
        },
        {
          "id": 15,
          "number": "15",
          "title": "Второй проект",
          "info": "12 лекций • 1ч 51м",
          "lessons": [
            {
              "lesson": "Обзор и задачи проекта",
              "time": "03:48"
            },
            {
              "lesson": "Подготовка и поиск референсов",
              "time": "08:48"
            },
            {
              "lesson": "Создаём Hero Section",
              "time": "06:48"
            },
            {
              "lesson": "Создаем навигационное меню",
              "time": "03:48"
            },
            {
              "lesson": "Создаем декоративные линии",
              "time": "03:42"
            }
          ]
        }
      ]
    },
    "additionalCategories": [
      "Продвинутый уровень"
    ]
  },
  {
    "id": 6,
    "slug": "html-css",
    "skillspaceCourses": [{ "courseId": "15551", "groupId": "25151" }],
    "title": "Курс Верстка HTML / CSS",
    "subtitle": "С нуля",
    "description": "В этом курсе вы найдете все о современной верстке сайтов, для быстрого старта в профессию веб разработчик!",
    "fullDescription": "HTML — это основа всех веб-страниц. В этом курсе вы изучите структуру HTML-документов, основы верстки и научитесь создавать семантически правильные и доступные сайты",
    "image": "/images/courses/html-css-paper-v2.webp",
    "promoVideo": "https://rutube.ru/play/embed/dceabb3b3490fa7db24a9513b17b61ad",
    "price": 2790,
    "originalPrice": 4990,
    "discount": 44,
    "saleDiscount": 25,
    "category": "Веб разработка",
    "lessons": 133,
    "totalHours": 18.5,
    "duration": "2 месяца",
    "level": "С нуля",
    "students": 2500,
    "rating": 4.9,
    "reviewPlatforms": {
      "udemy": { "url": "https://www.udemy.com/course/dmitrii-fokeev-web-dev-essential/#reviews", "rating": 4.8, "count": 1200 },
      "stepik": { "url": "https://stepik.org/course/114109/reviews", "rating": 5, "count": 500 }
    },
    "features": [
      "Интерактивность, общение с преподавателем",
      "Практические задания после каждого урока",
      "Реальные проекты для портфолио",
      "Пожизненный доступ к материалам"
    ],
    "stats": [
      {
        "value": "50K+",
        "label": "Просмотров"
      },
      {
        "value": "100K+",
        "label": "Студентов"
      },
      {
        "value": "150K+",
        "label": "Практических заданий"
      }
    ],
    "topics": [
      "Вы узнаете как создавать сайты на языках HTML и CSS",
      "Научитесь размещать свой сайт в сети интернет",
      "Получите необходимые знания для использования библиотеки Bootstrap",
      "Научитесь работать с препроцессором SASS/SCSS",
      "Изучите методологию БЭМ",
      "Научитесь создавать адаптивные сайты, которые будут выглядеть отлично на любом устройстве",
      "Научитесь создавать дизайн сайтов",
      "Изучите базу программы Figma",
      "Научитесь работать в программе VS Code"
    ],
    "testimonials": [
      {
        "name": "Григорий",
        "role": "Студент курса",
        "text": "Замечательный курс, крутой автор и наставник Дмитрий) 1. За курс освоили базу по HTML/CSS, плотно познакомились с препроцессорами, особенно с Sass, узнали про дизайн сайтов, про методологию БЭМ. Прошли путь по созданию сайта от концепции до реальной верстки и публикации сайта на хостинге. 2. Всё понравилось, крутой специалист Дмитрий Фокеев, хотелось бы подружиться лично с ним) Классное комьюнити, ребята оставляют реально полезные ссылки и мысли под каждым видео. 3. Не было ничего, что могло бы не понравиться. 4. Интересна веб-разработка поэтому и выбрал данное направление. У Дмитрия много положительных отзывов и преподает он классно, поэтому выбрал его.",
        "rating": 5
      },
      {
        "name": "Милена",
        "role": "Студент курса",
        "text": "Курс интересный, понятный и полезный) Видео-уроки короткие, чрезмерно не перегружают мозг, поэтому проходить курс в целом легко и не хочется всё бросить на пол-пути. Отдельное спасибо автору курса за актуализацию информации по мере того, как какие-то функции/инструменты/приложения становятся недоступны.",
        "rating": 5
      }
    ],
    "aboutSection": {
      "headline": "Основы HTML, структура веб-страниц, вёрстка и семантика. Все это Курс по HTML",
      "highlightedText": "",
      "description": "HTML — это основа всех веб-страниц. В этом курсе вы изучите структуру HTML-документов, основы верстки и научитесь создавать семантически правильные и доступные сайты",
      "featureCard": {
        "text": "HTML — это основа всех веб-страниц и язык разметки для создания структуры сайтов."
      },
      "courseCard": {
        "title": "Верстка HTML / CSS",
        "subtitle": "С нуля",
        "tagline": "В этом курсе вы найдете все о современной верстке ",
        "badge": "КУ"
      },
      "targetAudience": [
              {
                      "icon": "book",
                      "title": "Новичок в вёрстке",
                      "description": "Хотите научиться создавать сайты",
                      "color": "teal",
                      "benefits": [
                              "С полного нуля",
                              "Понятные объяснения"
                      ]
              },
              {
                      "icon": "palette",
                      "title": "Дизайнер",
                      "description": "Хотите воплощать макеты в код",
                      "color": "purple",
                      "benefits": [
                              "От дизайна к вёрстке",
                              "Пиксель-перфект"
                      ]
              },
              {
                      "icon": "briefcase",
                      "title": "Маркетолог",
                      "description": "Хотите сами делать лендинги",
                      "color": "orange",
                      "benefits": [
                              "Посадочные страницы",
                              "Быстрые правки"
                      ]
              },
              {
                      "icon": "zap",
                      "title": "Предприниматель",
                      "description": "Хотите делать сайты для бизнеса",
                      "color": "emerald",
                      "benefits": [
                              "Экономия бюджета",
                              "Контроль над сайтом"
                      ]
              }
      ]
    },
    "careerSection": {
          "title": "Сколько зарабатывают верстальщики?",
          "description": "HTML и CSS — фундамент веб-разработки. Верстальщики нужны в каждой IT-компании и веб-студии",
          "vacancies": "3 800+",
          "growth": "+18%",
          "salaryLevels": [
                {
                      "title": "Начинающий (0-1 год)",
                      "salary": "50 000 ₽",
                      "progress": "30%"
                },
                {
                      "title": "Средний (1-2 года)",
                      "salary": "80 000 ₽",
                      "progress": "50%"
                },
                {
                      "title": "Опытный верстальщик",
                      "salary": "130 000+ ₽",
                      "progress": "100%"
                }
          ],
          "source": "* По данным hh.ru и Хабр Карьера, 2025"
    },
    "skillsSection": {
          "skills": [
                {
                      "name": "HTML5 семантическая вёрстка",
                      "level": "Продвинутый",
                      "progress": "90%"
                },
                {
                      "name": "CSS3 стилизация",
                      "level": "Продвинутый",
                      "progress": "85%"
                },
                {
                      "name": "Flexbox",
                      "level": "Уверенный",
                      "progress": "80%"
                },
                {
                      "name": "Адаптивная вёрстка",
                      "level": "Уверенный",
                      "progress": "75%"
                }
          ],
          "opportunities": [
                {
                      "icon": "freelance",
                      "title": "Брать заказы на вёрстку",
                      "description": "Верстать лендинги и многостраничные сайты"
                },
                {
                      "icon": "company",
                      "title": "Устроиться в компанию",
                      "description": "На позицию Junior верстальщика"
                },
                {
                      "icon": "growth",
                      "title": "Развиваться дальше",
                      "description": "Перейти к изучению JavaScript"
                }
          ]
    },
    "curriculum": {
      "headline": "Программа курса",
      "description": "В этом курсе вы найдете все о современной верстке сайтов, для быстрого старта в профессию веб разработчик!",
      "modules": [
        {
          "id": 1,
          "number": "01",
          "title": "Введение",
          "info": "3 лекции • 8м",
          "lessons": [
            {
              "lesson": "О чем этот курс",
              "time": "03:44"
            },
            {
              "lesson": "Подготовка. Скачиваем материалы. Как проходить курс.",
              "time": "03:57"
            },
            {
              "lesson": "Оставайтесь со мной на связи",
              "time": "00:11"
            }
          ]
        },
        {
          "id": 2,
          "number": "02",
          "title": "Основы HTML и CSS",
          "info": "10 лекций • 1ч 8м",
          "lessons": [
            {
              "lesson": "О чем этот блок",
              "time": "01:06"
            },
            {
              "lesson": "Создаем первый веб-сайт!",
              "time": "07:57"
            },
            {
              "lesson": "Как работают теги HTML и стили CSS",
              "time": "12:35"
            },
            {
              "lesson": "Теги Head и Body. Правильная структура веб страницы",
              "time": "09:29"
            },
            {
              "lesson": "Как работают теги заголовка и описания, в теге head.",
              "time": "05:08"
            }
          ]
        },
        {
          "id": 3,
          "number": "03",
          "title": "Мини-курс по ChatGPT для обучения и работы (Опционально)",
          "info": "12 лекций • 1ч 11м",
          "lessons": [
            {
              "lesson": "Обзор нейросетей",
              "time": "11:24"
            },
            {
              "lesson": "Лучшие модели искусственного интеллекта на сегодня",
              "time": "04:56"
            },
            {
              "lesson": "Как оплатить подписку на Chat GPT",
              "time": "04:38"
            },
            {
              "lesson": "Обзор тарифов Chat GPT",
              "time": "05:48"
            },
            {
              "lesson": "Программа Chat GPT на разные операционные системы",
              "time": "02:56"
            }
          ]
        },
        {
          "id": 4,
          "number": "04",
          "title": "Погружение в HTML и CSS",
          "info": "35 лекций • 5ч 26м",
          "lessons": [
            {
              "lesson": "О чем этот блок",
              "time": "01:37"
            },
            {
              "lesson": "Классификация сайтов",
              "time": "12:48"
            },
            {
              "lesson": "Правильная структура файлов и папок проекта",
              "time": "13:14"
            },
            {
              "lesson": "Как использовать плагины VS Code",
              "time": "13:58"
            },
            {
              "lesson": "Если у вас не работает плагин Go Live",
              "time": "00:55"
            }
          ]
        },
        {
          "id": 5,
          "number": "05",
          "title": "Работа в Figma. Мини курс Figma free.",
          "info": "29 лекций • 2ч 50м",
          "lessons": [
            {
              "lesson": "О чем этот блок",
              "time": "01:07"
            },
            {
              "lesson": "Об обновлении интерфейса figma",
              "time": "12:49"
            },
            {
              "lesson": "О чем мини курс?",
              "time": "01:44"
            },
            {
              "lesson": "Подготовка. Скачиваем материалы",
              "time": "03:41"
            },
            {
              "lesson": "Какой размер у сайта?",
              "time": "13:03"
            }
          ]
        },
        {
          "id": 6,
          "number": "06",
          "title": "Продвинутая верстка SASS / БЭМ / FlexBox",
          "info": "18 лекций • 4ч 18м",
          "lessons": [
            {
              "lesson": "О чем этот блок",
              "time": "01:05"
            },
            {
              "lesson": "Препроцессор SASS ч.1",
              "time": "18:40"
            },
            {
              "lesson": "Препроцессор SASS ч.2",
              "time": "21:50"
            },
            {
              "lesson": "Как работать с ошибками",
              "time": "18:01"
            },
            {
              "lesson": "FlexBox. Новый способ позиционирования элементов.",
              "time": "17:21"
            }
          ]
        },
        {
          "id": 7,
          "number": "07",
          "title": "Адаптивная верстка",
          "info": "12 лекций • 1ч 54м",
          "lessons": [
            {
              "lesson": "О чем этот блок",
              "time": "01:06"
            },
            {
              "lesson": "Какие существуют типы верстки",
              "time": "08:13"
            },
            {
              "lesson": "Как работает meta тег viewport",
              "time": "06:37"
            },
            {
              "lesson": "Под какие размеры нужно адаптировать сайт",
              "time": "07:33"
            },
            {
              "lesson": "Адаптация под планшетную версию ч.1",
              "time": "14:33"
            }
          ]
        },
        {
          "id": 8,
          "number": "08",
          "title": "Библиотека bootstrap",
          "info": "13 лекций • 1ч 20м",
          "lessons": [
            {
              "lesson": "О чем этот блок",
              "time": "00:41"
            },
            {
              "lesson": "Что такое bootstrap",
              "time": "04:12"
            },
            {
              "lesson": "Как подключить bootstrap в свой проект",
              "time": "08:48"
            },
            {
              "lesson": "Какие настройки содержит в себе bootstrap",
              "time": "01:31"
            },
            {
              "lesson": "Как задавать свои стили в bootstrap",
              "time": "07:42"
            }
          ]
        },
        {
          "id": 9,
          "number": "09",
          "title": "До новых встреч!",
          "info": "1 лекция • 2м",
          "lessons": [
            {
              "lesson": "Прощальное слово",
              "time": "02:13"
            }
          ]
        }
      ]
    },
    "additionalCategories": [
      "Бестселлеры",
      "С нуля"
    ]
  },
  {
    "id": 7,
    "slug": "html-css-pro",
    "skillspaceCourses": [{ "courseId": "15583", "groupId": "25193" }],
    "title": "Курс Верстка HTML/CSS (Pro)",
    "subtitle": "Со знанием HTML / CSS",
    "description": "Продвинутые приёмы HTML и CSS для тех, кто уже знаком с основами вёрстки.",
    "fullDescription": "HTML Pro — это курс для тех, кто хочет углубить знания в верстке. Вы изучите семантику, современные стандарты HTML5 и научитесь создавать сложные и адаптивные структуры веб-страниц.",
    "image": "/images/courses/html-css-pro-paper-v3.webp",
    "promoVideo": "https://rutube.ru/play/embed/abc69711cc48ac3bd301a00373b84d0d",
    "price": 2990,
    "originalPrice": 4990,
    "discount": 40,
    "saleDiscount": 25,
    "category": "Веб разработка",
    "lessons": 130,
    "totalHours": 20.0,
    "duration": "2 месяца",
    "level": "Средний",
    "students": 2500,
    "rating": 4.9,
    "reviewPlatforms": {
      "udemy": { "url": "https://www.udemy.com/course/2022-wkk/#reviews", "rating": 4.8, "count": 450 },
      "stepik": { "url": "https://stepik.org/course/118223/reviews", "rating": 5, "count": 180 }
    },
    "features": [
      "Интерактивность, общение с преподавателем",
      "Практические задания после каждого урока",
      "Реальные проекты для портфолио",
      "Пожизненный доступ к материалам"
    ],
    "stats": [
      {
        "value": "50K+",
        "label": "Просмотров"
      },
      {
        "value": "100K+",
        "label": "Студентов"
      },
      {
        "value": "150K+",
        "label": "Практических заданий"
      }
    ],
    "topics": [
      "По окончании курса вы будете владеть всеми современными способами верстки и создания сайтов",
      "Вы научитесь использовать CSS анимации на своих сайтах",
      "Вы узнаете продвинутые способы адаптивного дизайна",
      "Вы изучите продвинутые техники работы с препроцессором SASS",
      "Вы научитесь использовать систему контроля версий Git",
      "Вы изучите систему создания сайтов на CSS GRID",
      "Вы узнаете современные способы верстки сайтов"
    ],
    "testimonials": [
      {
        "name": "Дмитрий",
        "role": "Студент курса",
        "text": "Это просто ВЕЛИКОЛЕПНЫЙ курс по верстке сайтов. Очень много полезной информации. Научился создавать различную анимацию, это просто завораживает. Очень интересный и полезный модуль про Float. Очень подробный и главное понятный блок по работе с Git и Github. Немного затрагивается Gulp. Последний блок на нем и верстается в итоге. А от Grid-css я вообще в восторге, применяются различные подхоы и методы работы с этой технологией. Я даже и не подозревал что на Grid так легко и быстро можно делать сайты. Сайт, который в итоге получается на гридах, Очень классный.Курс Очень рекомендую!!!",
        "rating": 5
      },
      {
        "name": "Артем",
        "role": "Студент курса",
        "text": "Очень годное продолжение первого курса которое научит вас всему что есть в верстке и фронтенд разработке. Советую всем данный курс без раздумий ведь он научит вас тому чему не научат многие курсы. Годное повествование материала, крутая практика, удивительные новые вещи все это будет в курсе!",
        "rating": 5
      }
    ],
    "aboutSection": {
      "headline": "HTML, структура веб-страниц, вёрстка и семантика. Все это Курс HTML Pro",
      "highlightedText": "",
      "description": "HTML Pro — это курс для тех, кто хочет углубить знания в верстке. Вы изучите семантику, современные стандарты HTML5 и научитесь создавать сложные и адаптивные структуры веб-страниц.",
      "featureCard": {
        "text": "HTML Pro позволяет углубиться в семантическую верстку и современные стандарты HTML5."
      },
      "courseCard": {
        "title": "Верстка HTML/CSS (Pro)",
        "subtitle": "Со знанием HTML / CSS",
        "tagline": "Продвинутые приёмы HTML и CSS для тех, кто уже знаком с основами вёрстки.",
        "badge": "КУ"
      },
      "targetAudience": [
              {
                      "icon": "book",
                      "title": "Начинающий верстальщик",
                      "description": "Знаете основы, хотите углубиться",
                      "color": "teal",
                      "benefits": [
                              "Продвинутый CSS",
                              "Grid и Flexbox"
                      ]
              },
              {
                      "icon": "palette",
                      "title": "Фронтенд-разработчик",
                      "description": "Хотите писать качественный код",
                      "color": "purple",
                      "benefits": [
                              "Методологии CSS",
                              "Оптимизация"
                      ]
              },
              {
                      "icon": "briefcase",
                      "title": "Фрилансер",
                      "description": "Хотите брать сложные проекты",
                      "color": "orange",
                      "benefits": [
                              "Адаптивная вёрстка",
                              "Кроссбраузерность"
                      ]
              },
              {
                      "icon": "zap",
                      "title": "Веб-студия",
                      "description": "Хотите повысить качество вёрстки",
                      "color": "emerald",
                      "benefits": [
                              "Стандарты кода",
                              "Скорость работы"
                      ]
              }
      ]
    },
    "careerSection": {
          "title": "Сколько зарабатывают frontend-разработчики?",
          "description": "Продвинутая вёрстка — путь к позиции frontend-разработчика с высокой зарплатой",
          "vacancies": "6 500+",
          "growth": "+22%",
          "salaryLevels": [
                {
                      "title": "Junior frontend",
                      "salary": "60 000 ₽",
                      "progress": "25%"
                },
                {
                      "title": "Middle frontend",
                      "salary": "140 000 ₽",
                      "progress": "60%"
                },
                {
                      "title": "Senior frontend",
                      "salary": "250 000+ ₽",
                      "progress": "100%"
                }
          ],
          "source": "* По данным hh.ru и Хабр Карьера, 2025"
    },
    "skillsSection": {
          "skills": [
                {
                      "name": "CSS Grid & Flexbox",
                      "level": "Продвинутый",
                      "progress": "95%"
                },
                {
                      "name": "SASS/SCSS",
                      "level": "Продвинутый",
                      "progress": "90%"
                },
                {
                      "name": "БЭМ методология",
                      "level": "Уверенный",
                      "progress": "85%"
                },
                {
                      "name": "CSS-анимации",
                      "level": "Уверенный",
                      "progress": "80%"
                }
          ],
          "opportunities": [
                {
                      "icon": "freelance",
                      "title": "Брать сложные проекты",
                      "description": "Верстать любые макеты с анимациями"
                },
                {
                      "icon": "company",
                      "title": "Устроиться frontend-ом",
                      "description": "На позицию Middle верстальщика/frontend"
                },
                {
                      "icon": "growth",
                      "title": "Развиваться дальше",
                      "description": "Освоить JavaScript и React"
                }
          ]
    },
    "curriculum": {
      "headline": "Программа курса",
      "description": "Продвинутые приёмы HTML и CSS для тех, кто уже знаком с основами вёрстки.",
      "modules": [
        {
          "id": 1,
          "number": "01",
          "title": "Подготовка / Повторение / Первые анимации",
          "info": "12 лекций • 2ч 24м",
          "lessons": [
            {
              "lesson": "Hello world! Скачиваем материалы к курсу",
              "time": "03:57"
            },
            {
              "lesson": "Устанавливаем и настраиваем необходимое программное обеспечение",
              "time": "16:46"
            },
            {
              "lesson": "Новое свойство clip-path. Начинаем создавать первую секцию сайта",
              "time": "27:35"
            },
            {
              "lesson": "Если у вас не работает Scout-app",
              "time": "06:37"
            },
            {
              "lesson": "Практика: Создайте свою фигуру с помощью Clip-path",
              "time": "00:47"
            }
          ]
        },
        {
          "id": 2,
          "number": "02",
          "title": "Git и GitHub",
          "info": "42 лекции • 4ч 7м",
          "lessons": [
            {
              "lesson": "О чем этот блок",
              "time": "01:50"
            },
            {
              "lesson": "Базовые команды в терминале",
              "time": "12:53"
            },
            {
              "lesson": "Как редактировать файлы через терминал",
              "time": "04:59"
            },
            {
              "lesson": "Устанавливаем систему git на наш компьютер",
              "time": "03:35"
            },
            {
              "lesson": "Как запустить git в определенном проекте. Настраиваем имя и email.",
              "time": "08:54"
            }
          ]
        },
        {
          "id": 3,
          "number": "03",
          "title": "Продвинутая верстка - CSS/SASS",
          "info": "27 лекций • 6ч 2м",
          "lessons": [
            {
              "lesson": "О чем этот блок",
              "time": "02:11"
            },
            {
              "lesson": "Как работают SASS переменные",
              "time": "09:45"
            },
            {
              "lesson": "Как работают миксины",
              "time": "04:03"
            },
            {
              "lesson": "Как добавлять аргументы для миксинов",
              "time": "05:06"
            },
            {
              "lesson": "Что такое шаблоны SASS",
              "time": "09:42"
            }
          ]
        },
        {
          "id": 4,
          "number": "04",
          "title": "Adaptive design",
          "info": "11 лекций • 2ч 1м",
          "lessons": [
            {
              "lesson": "О чем этот блок",
              "time": "00:59"
            },
            {
              "lesson": "Как создают адаптивные сайты",
              "time": "09:05"
            },
            {
              "lesson": "Создаем миксин с медиа правилами",
              "time": "13:44"
            },
            {
              "lesson": "Адаптация проекта ч.1",
              "time": "15:40"
            },
            {
              "lesson": "Адаптация проекта ч.2",
              "time": "18:56"
            }
          ]
        },
        {
          "id": 5,
          "number": "05",
          "title": "Node package manager",
          "info": "6 лекций • 57м",
          "lessons": [
            {
              "lesson": "О чем этот блок",
              "time": "01:19"
            },
            {
              "lesson": "Что такое node.js и npm",
              "time": "07:45"
            },
            {
              "lesson": "Готовим к использованию первый npm пакет",
              "time": "09:41"
            },
            {
              "lesson": "Запускаем первый npm пакет",
              "time": "08:26"
            },
            {
              "lesson": "Используем gulp в нашем проекте",
              "time": "25:40"
            }
          ]
        },
        {
          "id": 6,
          "number": "06",
          "title": "Введение в CSS GRID",
          "info": "16 лекций • 1ч 40м",
          "lessons": [
            {
              "lesson": "О чем этот блок",
              "time": "01:45"
            },
            {
              "lesson": "Подготовка",
              "time": "04:25"
            },
            {
              "lesson": "Как создать шаблон сетки. Grid template",
              "time": "08:42"
            },
            {
              "lesson": "Как работают единицы измерения fr",
              "time": "06:48"
            },
            {
              "lesson": "Как переместить элемент в другую ячейку",
              "time": "07:57"
            }
          ]
        },
        {
          "id": 7,
          "number": "07",
          "title": "GRID CSS Project",
          "info": "15 лекций • 2ч 49м",
          "lessons": [
            {
              "lesson": "О чем этот блок",
              "time": "01:03"
            },
            {
              "lesson": "Подготовка",
              "time": "06:22"
            },
            {
              "lesson": "Создаем шаблон grid сетки ч.1",
              "time": "10:14"
            },
            {
              "lesson": "Создаем шаблон grid сетки ч.2",
              "time": "19:46"
            },
            {
              "lesson": "Как работают SVG спрайты",
              "time": "17:12"
            }
          ]
        },
        {
          "id": 8,
          "number": "08",
          "title": "До новых встреч!",
          "info": "1 лекция • 3м",
          "lessons": [
            {
              "lesson": "До свидания!",
              "time": "02:43"
            }
          ]
        }
      ]
    },
    "additionalCategories": [
      "Продвинутый уровень"
    ]
  },
  {
    "id": 8,
    "slug": "illustrator",
    "skillspaceCourses": [{ "courseId": "15527", "groupId": "25123" }],
    "title": "Курс Illustrator с нуля",
    "subtitle": "C нуля",
    "description": "Курс Adobe illustrator, позволит вам быстро освоить инструменты создания иллюстраций, логотипов, иконок и векторов!",
    "fullDescription": "Adobe Illustrator — это мощное средство для создания векторной графики, иллюстраций, логотипов и иконок. В этом курсе вы научитесь профессионально использовать все инструменты программы и воплощать свои идеи в векторной графике",
    "image": "/images/courses/illustrator-paper-v2.webp",
    "promoVideo": "https://rutube.ru/play/embed/fec948b1665f9ad4059e8586f5fbc5e3",
    "price": 2290,
    "originalPrice": 3990,
    "discount": 43,
    "saleDiscount": 25,
    "category": "Графический дизайн",
    "lessons": 52,
    "totalHours": 7.5,
    "duration": "1 месяц",
    "level": "С нуля",
    "students": 2500,
    "rating": 4.9,
    "reviewPlatforms": {
      "udemy": { "url": "https://www.udemy.com/course/adobe-illustrator-2021-x/#reviews", "rating": 4.8, "count": 700 },
      "stepik": { "url": "https://stepik.org/course/106825/reviews", "rating": 5, "count": 300 }
    },
    "features": [
      "Интерактивность, общение с преподавателем",
      "Практические задания после каждого урока",
      "Реальные проекты для портфолио",
      "Пожизненный доступ к материалам"
    ],
    "stats": [
      {
        "value": "50K+",
        "label": "Просмотров"
      },
      {
        "value": "100K+",
        "label": "Студентов"
      },
      {
        "value": "150K+",
        "label": "Практических заданий"
      }
    ],
    "topics": [
      "Научитесь понимать интерфейс программы и изучите необходимые инструменты для профессиональной работы",
      "Сможете рисовать иллюстрации животных",
      "Сможете отрисовать интернет баннер",
      "Научитесь создавать логотипы",
      "Сможете рисовать фигуры и иконки",
      "Научитесь превращать в графику ваши рисунки, нарисованные от руки",
      "Узнаете где искать вдохновение для своего собственного дизайна",
      "Научитесь стилизовать текст и получите базовые знания по типографии",
      "Научитесь работать с цветом"
    ],
    "testimonials": [
      {
        "name": "Максим",
        "role": "Студент курса",
        "text": "Идеальный курс для новичков! Идея тут в том что, Дмитрий объясняет элементарные вещи, которые многим могут показаться не важными) видео-уроки короткие, но информативные, курс поглощается в удовольствие и пользу!",
        "rating": 5
      },
      {
        "name": "Сергей",
        "role": "Студент курса",
        "text": "Спасибо! Замечательный курс для тех, кто не имел никакого представления об Adobe Illustrator. Доступно изложены основы программы. Понравился преподаватель. Думаю продолжить обучение на его курсах.",
        "rating": 5
      }
    ],
    "aboutSection": {
      "headline": "Векторная графика, создание иллюстраций, логотипов и иконок. Все это Курс по Illustrator",
      "highlightedText": "",
      "description": "Adobe Illustrator — это мощное средство для создания векторной графики, иллюстраций, логотипов и иконок. В этом курсе вы научитесь профессионально использовать все инструменты программы и воплощать свои идеи в векторной графике",
      "featureCard": {
        "text": "Adobe Illustrator — мощный инструмент для создания векторной графики, логотипов и иллюстраций."
      },
      "courseCard": {
        "title": "Illustrator с нуля",
        "subtitle": "C нуля",
        "tagline": "Курс Adobe illustrator, позволит вам быстро освоит",
        "badge": "КУ"
      },
      "targetAudience": [
              {
                      "icon": "book",
                      "title": "Новичок в графике",
                      "description": "Хотите создавать векторную графику",
                      "color": "teal",
                      "benefits": [
                              "Основы Illustrator",
                              "Работа с кривыми"
                      ]
              },
              {
                      "icon": "palette",
                      "title": "Дизайнер",
                      "description": "Хотите расширить набор инструментов",
                      "color": "purple",
                      "benefits": [
                              "Логотипы и иконки",
                              "Иллюстрации"
                      ]
              },
              {
                      "icon": "briefcase",
                      "title": "Фрилансер",
                      "description": "Хотите брать заказы на графику",
                      "color": "orange",
                      "benefits": [
                              "Брендинг",
                              "Полиграфия"
                      ]
              },
              {
                      "icon": "zap",
                      "title": "Контент-мейкер",
                      "description": "Создаёте графику для соцсетей",
                      "color": "emerald",
                      "benefits": [
                              "Инфографика",
                              "Визуальный контент"
                      ]
              }
      ]
    },
    "careerSection": {
          "title": "Сколько зарабатывают иллюстраторы?",
          "description": "Illustrator — инструмент для создания логотипов, иконок и векторной графики. Навык нужен в брендинге и рекламе",
          "vacancies": "2 100+",
          "growth": "+12%",
          "salaryLevels": [
                {
                      "title": "Начинающий (0-1 год)",
                      "salary": "50 000 ₽",
                      "progress": "30%"
                },
                {
                      "title": "Средний (1-3 года)",
                      "salary": "90 000 ₽",
                      "progress": "55%"
                },
                {
                      "title": "Профессионал",
                      "salary": "160 000+ ₽",
                      "progress": "100%"
                }
          ],
          "source": "* По данным hh.ru и Хабр Карьера, 2025"
    },
    "skillsSection": {
          "skills": [
                {
                      "name": "Векторная графика",
                      "level": "Продвинутый",
                      "progress": "90%"
                },
                {
                      "name": "Работа с кривыми Безье",
                      "level": "Уверенный",
                      "progress": "80%"
                },
                {
                      "name": "Создание логотипов",
                      "level": "Уверенный",
                      "progress": "85%"
                },
                {
                      "name": "Иллюстрации и иконки",
                      "level": "Уверенный",
                      "progress": "75%"
                }
          ],
          "opportunities": [
                {
                      "icon": "freelance",
                      "title": "Брать заказы на графику",
                      "description": "Создавать логотипы, иконки, иллюстрации"
                },
                {
                      "icon": "company",
                      "title": "Работать в агентстве",
                      "description": "На позицию графического дизайнера"
                },
                {
                      "icon": "growth",
                      "title": "Развиваться дальше",
                      "description": "Освоить Photoshop для полного стека"
                }
          ]
    },
    "curriculum": {
      "headline": "Программа курса",
      "description": "Курс Adobe illustrator, позволит вам быстро освоить инструменты создания иллюстраций, логотипов, иконок и векторов!",
      "modules": [
        {
          "id": 1,
          "number": "01",
          "title": "Подготовка",
          "info": "4 лекции • 16м",
          "lessons": [
            {
              "lesson": "Скачиваем материалы! Как проходить курс.",
              "time": "02:18"
            },
            {
              "lesson": "Где приобрести лицензионный иллюстратор",
              "time": "02:15"
            },
            {
              "lesson": "Настройка программы Adobe Illustrator",
              "time": "11:19"
            },
            {
              "lesson": "Оставайтесь со мной на связи",
              "time": "00:11"
            }
          ]
        },
        {
          "id": 2,
          "number": "02",
          "title": "Рисование в Adobe Illustrator",
          "info": "17 лекций • 2ч 43м",
          "lessons": [
            {
              "lesson": "Рисование фигурами и линиями",
              "time": "15:15"
            },
            {
              "lesson": "Дорисовываем первую иллюстрацию",
              "time": "25:15"
            },
            {
              "lesson": "Создание теней на иллюстрации с помощью инструмента ",
              "time": "12:09"
            },
            {
              "lesson": "Возможные проблемы",
              "time": "04:32"
            },
            {
              "lesson": "Как сохранить работу",
              "time": "02:23"
            }
          ]
        },
        {
          "id": 3,
          "number": "03",
          "title": "Ресурсы",
          "info": "3 лекции • 24м",
          "lessons": [
            {
              "lesson": "Как устанавливать кисти в Illustrator",
              "time": "06:42"
            },
            {
              "lesson": "Стоковые площадки",
              "time": "06:28"
            },
            {
              "lesson": "Что такое графический планшет",
              "time": "10:52"
            }
          ]
        },
        {
          "id": 4,
          "number": "04",
          "title": "Текст и шрифт",
          "info": "3 лекции • 33м",
          "lessons": [
            {
              "lesson": "Как создавать текст в Adobe Illustrator",
              "time": "14:57"
            },
            {
              "lesson": "Как устанавливать шрифты в Illustrator",
              "time": "10:27"
            },
            {
              "lesson": "Как писать текст на линии",
              "time": "07:46"
            }
          ]
        },
        {
          "id": 5,
          "number": "05",
          "title": "Цвет в Adobe Illustrator",
          "info": "5 лекций • 29м",
          "lessons": [
            {
              "lesson": "Как подбирать цвета",
              "time": "06:39"
            },
            {
              "lesson": "Как добавлять цвета в Illustrator",
              "time": "05:30"
            },
            {
              "lesson": "Как создавать градиент",
              "time": "07:02"
            },
            {
              "lesson": "Как использовать произвольный градиент",
              "time": "04:34"
            },
            {
              "lesson": "RGB VS CMYK",
              "time": "05:37"
            }
          ]
        },
        {
          "id": 6,
          "number": "06",
          "title": "Технические вещи",
          "info": "5 лекций • 44м",
          "lessons": [
            {
              "lesson": "Как работать с библиотеками",
              "time": "08:21"
            },
            {
              "lesson": "Что такое трассировка изображений",
              "time": "06:28"
            },
            {
              "lesson": "Какие бывают форматы изображений",
              "time": "08:46"
            },
            {
              "lesson": "В чем измеряется качество изображений",
              "time": "16:36"
            },
            {
              "lesson": "Про приложение Capture",
              "time": "03:35"
            }
          ]
        },
        {
          "id": 7,
          "number": "07",
          "title": "Использование масок в Adobe Illustrator",
          "info": "3 лекции • 22м",
          "lessons": [
            {
              "lesson": "Как создавать обтравочную маску",
              "time": "06:39"
            },
            {
              "lesson": "Как использовать составной контур",
              "time": "14:33"
            },
            {
              "lesson": "Создаем эффект ",
              "time": "01:11"
            }
          ]
        },
        {
          "id": 8,
          "number": "08",
          "title": "Эффекты",
          "info": "4 лекции • 30м",
          "lessons": [
            {
              "lesson": "Инструменты деформации",
              "time": "05:28"
            },
            {
              "lesson": "Эффекты деформирования",
              "time": "14:01"
            },
            {
              "lesson": "Трансформирование объектов",
              "time": "05:44"
            },
            {
              "lesson": "Как создавать паттерны",
              "time": "04:50"
            }
          ]
        },
        {
          "id": 9,
          "number": "09",
          "title": "Бонус. Дополнительные проекты",
          "info": "4 лекции • 48м",
          "lessons": [
            {
              "lesson": "Создаем лого - 1",
              "time": "06:13"
            },
            {
              "lesson": "Создаем лого - 2",
              "time": "07:34"
            },
            {
              "lesson": "Как создавать интернет баннеры",
              "time": "30:31"
            },
            {
              "lesson": "Где искать вдохновение",
              "time": "03:46"
            }
          ]
        },
        {
          "id": 10,
          "number": "10",
          "title": "Экспорт из Adobe Illustrator",
          "info": "3 лекции • 17м",
          "lessons": [
            {
              "lesson": "Подготовка для печати",
              "time": "06:46"
            },
            {
              "lesson": "Подготовка к экспорту в цифровой вид",
              "time": "07:51"
            },
            {
              "lesson": "Что такое преобразование в кривые",
              "time": "02:42"
            }
          ]
        },
        {
          "id": 11,
          "number": "11",
          "title": "Что дальше?",
          "info": "1 лекция • 1м",
          "lessons": [
            {
              "lesson": "До новых встреч!",
              "time": "01:12"
            }
          ]
        }
      ]
    },
    "additionalCategories": [
      "С нуля"
    ]
  },
  {
    "id": 9,
    "slug": "javascript",
    "skillspaceCourses": [{ "courseId": "14497", "groupId": "23496" }],
    "title": "Курс по JavaScript!",
    "subtitle": "Со знанием HTML",
    "description": "В этом курсе вы найдете все о современном языке программирования JavaScript. Станьте Front-end разработчиком на JavaScript.",
    "fullDescription": "JavaScript — один из самых популярных языков программирования в мире. Он используется для создания интерактивных веб-сайтов, веб-приложений, мобильных приложений, игр и многого другого. ",
    "image": "/images/courses/javascript-paper-v2.webp",
    "promoVideo": "https://rutube.ru/play/embed/d91abfe92cd1b3d708f4b5e9c69a06fe",
    "price": 3390,
    "originalPrice": 5990,
    "discount": 43,
    "saleDiscount": 25,
    "category": "Веб разработка",
    "lessons": 191,
    "totalHours": 31.0,
    "duration": "4 месяца",
    "level": "Средний",
    "students": 2500,
    "rating": 4.9,
    "reviewPlatforms": {
      "udemy": { "url": "https://www.udemy.com/course/java-script/#reviews", "rating": 4.8, "count": 800 },
      "stepik": { "url": "https://stepik.org/course/130424/reviews", "rating": 5, "count": 350 }
    },
    "features": [
      "Интерактивность, общение с преподавателем",
      "Практические задания после каждого урока",
      "Реальные проекты для портфолио",
      "Пожизненный доступ к материалам"
    ],
    "stats": [
      {
        "value": "50K+",
        "label": "Просмотров"
      },
      {
        "value": "100K+",
        "label": "Студентов"
      },
      {
        "value": "150K+",
        "label": "Практических заданий"
      }
    ],
    "topics": [
      "Научитесь основам синтаксиса и логики JavaScript",
      "Научитесь работать с переменными, типами данных и операторами",
      "Узнаете, как взаимодействовать с HTML и CSS через JavaScript",
      "Изучите работу с функциями, замыканиями и областями видимости",
      "Освоите методы работы с DOM и событиями",
      "Поймёте основы асинхронного программирования и работы с API",
      "Изучите современные стандарты JavaScript (ES6+)",
      "Узнаете, что такое объектно-ориентированное и функциональное программирование",
      "Разберётесь с модулями, сборщиками и инструментами разработки"
    ],
    "testimonials": [
      {
        "name": "Иван",
        "role": "Студент курса",
        "text": "Курс понравился Все доходчиво объясняется. Единственный момент, который удивил - это ответ в комментариях Дмитрия в блоке про карты. (про установку VPN). Лучше конечно было бы изначально объяснять принципы работы с картами на Яндекс картах, а не предлагать установить vpn для того, чтобы получить возможность пройти урок. Но это, конечно, не сильно критично. При желании разобраться можно.",
        "rating": 5
      },
      {
        "name": "Дмитрий",
        "role": "Студент курса",
        "text": "Отличный курс от отличного преподавателя! Все рассказано простыми и понятными словами, что заметно облегчает процесс обучения. Достаточно большое количество практики. Последовательность и подача материла, как по мне, очень хорошо выстроены: ты узнаешь то, что нужно и то, что ты уже можешь понять практически без проблем на данном этапе",
        "rating": 5
      }
    ],
    "aboutSection": {
      "headline": "Интерактивность, общение с сервером, сложные веб-приложения разработка на разных платформах. Все это JavaScript",
      "highlightedText": "",
      "description": "JavaScript — один из самых популярных языков программирования в мире. Он используется для создания интерактивных веб-сайтов, веб-приложений, мобильных приложений, игр и многого другого. ",
      "featureCard": {
        "text": "JavaScript один из самых популярных языков программирования в мире"
      },
      "courseCard": {
        "title": "JavaScript!",
        "subtitle": "Со знанием HTML",
        "tagline": "В этом курсе вы найдете все о современном языке пр",
        "badge": "КУ"
      },
      "targetAudience": [
              {
                      "icon": "book",
                      "title": "Начинающий разработчик",
                      "description": "Хотите освоить JavaScript с нуля",
                      "color": "teal",
                      "benefits": [
                              "Основы программирования",
                              "Синтаксис JS"
                      ]
              },
              {
                      "icon": "palette",
                      "title": "Верстальщик",
                      "description": "Хотите добавить интерактивность",
                      "color": "purple",
                      "benefits": [
                              "DOM-манипуляции",
                              "Анимации"
                      ]
              },
              {
                      "icon": "briefcase",
                      "title": "Фронтенд-разработчик",
                      "description": "Хотите углубить знания JS",
                      "color": "orange",
                      "benefits": [
                              "ES6+",
                              "Асинхронность"
                      ]
              },
              {
                      "icon": "zap",
                      "title": "Карьерист",
                      "description": "Хотите стать веб-разработчиком",
                      "color": "emerald",
                      "benefits": [
                              "Востребованный навык",
                              "Высокие зарплаты"
                      ]
              }
      ]
    },
    "careerSection": {
          "title": "Сколько зарабатывают JavaScript-разработчики?",
          "description": "JavaScript — самый востребованный язык программирования в мире. Разработчики нужны везде",
          "vacancies": "12 000+",
          "growth": "+25%",
          "salaryLevels": [
                {
                      "title": "Junior (0-1 год)",
                      "salary": "70 000 ₽",
                      "progress": "25%"
                },
                {
                      "title": "Middle (1-3 года)",
                      "salary": "170 000 ₽",
                      "progress": "60%"
                },
                {
                      "title": "Senior (3+ лет)",
                      "salary": "300 000+ ₽",
                      "progress": "100%"
                }
          ],
          "source": "* По данным hh.ru и Хабр Карьера, 2025"
    },
    "skillsSection": {
          "skills": [
                {
                      "name": "JavaScript ES6+",
                      "level": "Продвинутый",
                      "progress": "90%"
                },
                {
                      "name": "DOM-манипуляции",
                      "level": "Продвинутый",
                      "progress": "85%"
                },
                {
                      "name": "Асинхронность (Promise, async/await)",
                      "level": "Уверенный",
                      "progress": "80%"
                },
                {
                      "name": "Работа с API",
                      "level": "Уверенный",
                      "progress": "75%"
                }
          ],
          "opportunities": [
                {
                      "icon": "freelance",
                      "title": "Брать frontend-заказы",
                      "description": "Создавать интерактивные веб-приложения"
                },
                {
                      "icon": "company",
                      "title": "Устроиться разработчиком",
                      "description": "На позицию Junior/Middle frontend"
                },
                {
                      "icon": "growth",
                      "title": "Развиваться дальше",
                      "description": "Освоить React, Vue или Node.js"
                }
          ]
    },
    "curriculum": {
      "headline": "Программа курса",
      "description": "В этом курсе вы найдете все о современном языке программирования JavaScript. Станьте Front-end разработчиком на JavaScript.",
      "modules": [
        {
          "id": 1,
          "number": "01",
          "title": "Подготовка",
          "info": "3 лекции • 18м",
          "lessons": [
            {
              "lesson": "Как проходить курс. Скачиваем материалы",
              "time": "05:58"
            },
            {
              "lesson": "Устанавливаем необходимое ПО",
              "time": "12:20"
            },
            {
              "lesson": "Оставайтесь со мной на связи",
              "time": "00:11"
            }
          ]
        },
        {
          "id": 2,
          "number": "02",
          "title": "Основы JavaScript",
          "info": "19 лекций • 2ч 36м",
          "lessons": [
            {
              "lesson": "Добро пожаловать в клуб! Hello world!",
              "time": "09:30"
            },
            {
              "lesson": "Как работает JavaScript",
              "time": "07:05"
            },
            {
              "lesson": "Важны ли точки с запятой? Как создавать комментарии",
              "time": "05:45"
            },
            {
              "lesson": "Что такое переменные",
              "time": "09:14"
            },
            {
              "lesson": "Подробнее о переменных",
              "time": "11:37"
            }
          ]
        },
        {
          "id": 3,
          "number": "03",
          "title": "Мини-курс по ChatGPT для обучения и работы (Опционально)",
          "info": "12 лекций • 1ч 11м",
          "lessons": [
            {
              "lesson": "Обзор нейросетей",
              "time": "11:24"
            },
            {
              "lesson": "Лучшие модели искусственного интеллекта на сегодня",
              "time": "04:56"
            },
            {
              "lesson": "Как оплатить подписку на Chat GPT",
              "time": "04:38"
            },
            {
              "lesson": "Обзор тарифов Chat GPT",
              "time": "05:48"
            },
            {
              "lesson": "Программа Chat GPT на разные операционные системы",
              "time": "02:56"
            }
          ]
        },
        {
          "id": 4,
          "number": "04",
          "title": "Углубление в основы JavaScript. Функции и Объекты",
          "info": "21 лекция • 3ч 39м",
          "lessons": [
            {
              "lesson": "Используйте ",
              "time": "04:36"
            },
            {
              "lesson": "Введение в функции",
              "time": "11:31"
            },
            {
              "lesson": "Function Expression и Function Declaration",
              "time": "07:06"
            },
            {
              "lesson": "Области видимости в JS",
              "time": "11:54"
            },
            {
              "lesson": "ПРОВЕРЬ СЕБЯ: Области видимости",
              "time": "1 question"
            }
          ]
        },
        {
          "id": 5,
          "number": "05",
          "title": "Основы работы с DOM",
          "info": "18 лекций • 2ч 56м",
          "lessons": [
            {
              "lesson": "Prettier и как работают ",
              "time": "09:11"
            },
            {
              "lesson": "Что такое DOM и Окружение JS",
              "time": "07:10"
            },
            {
              "lesson": "Получение HTML Элементов",
              "time": "10:18"
            },
            {
              "lesson": "Что такое HTML узлы и родство элементов",
              "time": "12:32"
            },
            {
              "lesson": "Что такое псевдомассив",
              "time": "04:34"
            }
          ]
        },
        {
          "id": 6,
          "number": "06",
          "title": "Углубленная работа с данными",
          "info": "13 лекций • 2ч 36м",
          "lessons": [
            {
              "lesson": "О чем этот блок",
              "time": "01:58"
            },
            {
              "lesson": "Как работает контекст вызова this",
              "time": "16:35"
            },
            {
              "lesson": "Деструктуризация массивов",
              "time": "14:06"
            },
            {
              "lesson": "Деструктуризация объектов",
              "time": "12:16"
            },
            {
              "lesson": "Как работает оператор spread",
              "time": "11:38"
            }
          ]
        },
        {
          "id": 7,
          "number": "07",
          "title": "Работа со строками",
          "info": "4 лекции • 44м",
          "lessons": [
            {
              "lesson": "Как работают строки. Методы slice",
              "time": "10:27"
            },
            {
              "lesson": "Методы строк ч. 2. (trim, toLowerCase, replace)",
              "time": "08:28"
            },
            {
              "lesson": "Методы строк ч. 3 (Split / Join)",
              "time": "12:40"
            },
            {
              "lesson": "ПРАКТИКА-11. Работа со строками",
              "time": "12:35"
            }
          ]
        },
        {
          "id": 8,
          "number": "08",
          "title": "Работа функций",
          "info": "6 лекций • 46м",
          "lessons": [
            {
              "lesson": "Параметры функций по умолчанию",
              "time": "07:05"
            },
            {
              "lesson": "Объекты как параметры функций",
              "time": "07:27"
            },
            {
              "lesson": "Функции высшего порядка и первого класса",
              "time": "10:10"
            },
            {
              "lesson": "Возврат функции из функции",
              "time": "04:08"
            },
            {
              "lesson": "Метод функций call",
              "time": "09:07"
            }
          ]
        },
        {
          "id": 9,
          "number": "09",
          "title": "Работа с массивами",
          "info": "21 лекция • 3ч 1м",
          "lessons": [
            {
              "lesson": "О чем этот блок",
              "time": "01:55"
            },
            {
              "lesson": "Базовые методы массивов",
              "time": "05:53"
            },
            {
              "lesson": "Как работает forEach",
              "time": "08:09"
            },
            {
              "lesson": "forEach на Map и Set",
              "time": "03:07"
            },
            {
              "lesson": "Начинаем создавать приложение",
              "time": "11:30"
            }
          ]
        },
        {
          "id": 10,
          "number": "10",
          "title": "Числа и даты",
          "info": "9 лекций • 1ч 39м",
          "lessons": [
            {
              "lesson": "Базовые методы чисел",
              "time": "09:43"
            },
            {
              "lesson": "Что такое BigInt",
              "time": "05:58"
            },
            {
              "lesson": "Как создать дату",
              "time": "12:03"
            },
            {
              "lesson": "Устанавливаем даты в банковском приложении",
              "time": "15:51"
            },
            {
              "lesson": "Выражения с датами",
              "time": "14:30"
            }
          ]
        },
        {
          "id": 11,
          "number": "11",
          "title": "Углубление в работу с DOM",
          "info": "14 лекций • 2ч 36м",
          "lessons": [
            {
              "lesson": "О чем этот блок",
              "time": "01:32"
            },
            {
              "lesson": "Живые VS статичные коллекции",
              "time": "08:22"
            },
            {
              "lesson": "Координаты элементов",
              "time": "11:27"
            },
            {
              "lesson": "Отмена и всплытие событий",
              "time": "15:47"
            },
            {
              "lesson": "Делегирование событий",
              "time": "10:32"
            }
          ]
        },
        {
          "id": 12,
          "number": "12",
          "title": "Объектно ориентированное программирование",
          "info": "21 лекция • 2ч 54м",
          "lessons": [
            {
              "lesson": "Скачайте заново материалы к курсу",
              "time": "00:06"
            },
            {
              "lesson": "Что такое функции конструкторы",
              "time": "19:35"
            },
            {
              "lesson": "Разница между prototype и __proto__",
              "time": "09:27"
            },
            {
              "lesson": "ПРАКТИКА-14. Создайте функции конструкторы",
              "time": "07:48"
            },
            {
              "lesson": "Разница между классами и функциями конструкторами",
              "time": "06:53"
            }
          ]
        },
        {
          "id": 13,
          "number": "13",
          "title": "Объектно ориентированное программирование - на практике",
          "info": "12 лекций • 2ч 18м",
          "lessons": [
            {
              "lesson": "О чем этот проект",
              "time": "02:47"
            },
            {
              "lesson": "Используем Geolocation API",
              "time": "07:48"
            },
            {
              "lesson": "Размещаем карту на сайте",
              "time": "09:52"
            },
            {
              "lesson": "Работаем с документацией",
              "time": "15:49"
            },
            {
              "lesson": "Отображение формы",
              "time": "12:06"
            }
          ]
        },
        {
          "id": 14,
          "number": "14",
          "title": "Асинхронный код",
          "info": "17 лекций • 3ч 31м",
          "lessons": [
            {
              "lesson": "Что такое асинхронный код",
              "time": "06:47"
            },
            {
              "lesson": "Как работает XMLHttpRequest",
              "time": "16:33"
            },
            {
              "lesson": "Подключаемся к API",
              "time": "21:54"
            },
            {
              "lesson": "Call-back hell",
              "time": "11:21"
            },
            {
              "lesson": "Введение в fetch & promise",
              "time": "14:17"
            }
          ]
        },
        {
          "id": 15,
          "number": "15",
          "title": "До встречи на уроках!",
          "info": "1 лекция • 4м",
          "lessons": [
            {
              "lesson": "Прощание",
              "time": "03:54"
            }
          ]
        }
      ]
    },
    "additionalCategories": [
      "Бестселлеры",
      "Продвинутый уровень"
    ]
  },
  {
    "id": 10,
    "slug": "photoshop",
    "skillspaceCourses": [{ "courseId": "15520", "groupId": "25113" }],
    "title": "Adobe Photoshop с нейросетями: с нуля до результата",
    "subtitle": "C нуля",
    "description": "Бестселлер-курс по Photoshop с нуля до результата — теперь в обновлённой версии с нейросетями. Курс для абсолютных новичков с основ до продвинутых работ.",
    "fullDescription": "Adobe Photoshop — это универсальный инструмент для обработки фотографий, создания графики и дизайна. В этом курсе вы изучите все основные инструменты программы и научитесь работать с цветокоррекцией, ретушью и слоями.",
    "image": "/images/courses/photoshop-paper-v2.webp",
    "promoVideo": "https://rutube.ru/play/embed/c3be29b8887e0463ac0bfd6a3d8ac6ee",
    "price": 2290,
    "originalPrice": 3990,
    "discount": 43,
    "saleDiscount": 25,
    "category": "Графический дизайн",
    "lessons": 80,
    "totalHours": 10.0,
    "duration": "1 месяц",
    "level": "С нуля",
    "students": 2500,
    "rating": 4.9,
    "reviewPlatforms": {
      "udemy": { "url": "https://www.udemy.com/course/photoshop-2021-f/#reviews", "rating": 4.8, "count": 900 },
      "stepik": { "url": "https://stepik.org/course/96072/reviews", "rating": 5, "count": 400 }
    },
    "features": [
      "Интерактивность, общение с преподавателем",
      "Практические задания после каждого урока",
      "Реальные проекты для портфолио",
      "Пожизненный доступ к материалам"
    ],
    "stats": [
      {
        "value": "50K+",
        "label": "Просмотров"
      },
      {
        "value": "100K+",
        "label": "Студентов"
      },
      {
        "value": "150K+",
        "label": "Практических заданий"
      }
    ],
    "topics": [
      "Научитесь удалять людей и предметы из изображений",
      "Научитесь вырезать людей и любые предметы из ваших изображений и переносить их на другие фото",
      "Научитесь делать идеальную фигуру у любого человека на фотографии",
      "Вы научитесь ретушировать лицо, удалять прыщи и веснушки и любые дефекты кожи",
      "Научитесь создавать популярные визуальные стили и эффекты",
      "Научитесь создавать рекламные плакаты",
      "Научитесь изменять цвет вещей на изображениях",
      "Научитесь создавать реалистичные тени",
      "Узнаете, как исправлять цвета на фотографиях"
    ],
    "testimonials": [
      {
        "name": "Алена",
        "role": "Студент курса",
        "text": "Хочу выразить огромную благодарность Дмитрию за интересные практические задания, подробные объяснения и описания инструментов фотошоп, хорошо продуманную структуру программы по изучению(от простого к сложному). Очень долго откладывала изучение этой программы. Не знала с чего начать и терялась в большом многообразии разных функций. Благодаря Вам поняла, что он не так страшен. Буду продолжать практиковаться и набираться опыта. СПАСИБО!",
        "rating": 5
      },
      {
        "name": "Наталья",
        "role": "Студент курса",
        "text": "Дмитрий, огромное спасибо за курс! Раньше Фотошоп виделся мне страшной неприступной крепостью, а с вами все оказалось достаточно просто для понимания и изучения. Даже захотелось попробовать себя в графическом дизайне, а вдруг получится.",
        "rating": 5
      }
    ],
    "aboutSection": {
      "headline": "Редактирование фотографий, ретушь, создание графики и коллажей. Все это Курс по Photoshop",
      "highlightedText": "",
      "description": "Adobe Photoshop — это универсальный инструмент для обработки фотографий, создания графики и дизайна. В этом курсе вы изучите все основные инструменты программы и научитесь работать с цветокоррекцией, ретушью и слоями.",
      "featureCard": {
        "text": "Adobe Photoshop — лидер среди программ для обработки фотографий и создания графики."
      },
      "courseCard": {
        "title": "Photoshop с нуля",
        "subtitle": "C нуля",
        "tagline": "Курс позволит вам быстро освоить все необходимые и",
        "badge": "КУ"
      },
      "targetAudience": [
              {
                      "icon": "book",
                      "title": "Новичок",
                      "description": "Хотите освоить Photoshop с нуля",
                      "color": "teal",
                      "benefits": [
                              "Пошаговое обучение",
                              "Основы редактирования"
                      ]
              },
              {
                      "icon": "palette",
                      "title": "Фотограф",
                      "description": "Хотите обрабатывать свои фото",
                      "color": "purple",
                      "benefits": [
                              "Ретушь портретов",
                              "Цветокоррекция"
                      ]
              },
              {
                      "icon": "briefcase",
                      "title": "SMM-специалист",
                      "description": "Создаёте визуалы для соцсетей",
                      "color": "orange",
                      "benefits": [
                              "Баннеры и посты",
                              "Обработка фото"
                      ]
              },
              {
                      "icon": "zap",
                      "title": "Предприниматель",
                      "description": "Делаете графику для бизнеса",
                      "color": "emerald",
                      "benefits": [
                              "Экономия на дизайнерах",
                              "Быстрые правки"
                      ]
              }
      ]
    },
    "careerSection": {
          "title": "Сколько зарабатывают дизайнеры Photoshop?",
          "description": "Photoshop — универсальный инструмент для ретуши, дизайна и обработки изображений",
          "vacancies": "4 300+",
          "growth": "+10%",
          "salaryLevels": [
                {
                      "title": "Начинающий (0-1 год)",
                      "salary": "45 000 ₽",
                      "progress": "30%"
                },
                {
                      "title": "Средний (1-3 года)",
                      "salary": "80 000 ₽",
                      "progress": "55%"
                },
                {
                      "title": "Профессионал",
                      "salary": "150 000+ ₽",
                      "progress": "100%"
                }
          ],
          "source": "* По данным hh.ru и Хабр Карьера, 2025"
    },
    "skillsSection": {
          "skills": [
                {
                      "name": "Обработка фотографий",
                      "level": "Продвинутый",
                      "progress": "90%"
                },
                {
                      "name": "Ретушь и цветокоррекция",
                      "level": "Уверенный",
                      "progress": "80%"
                },
                {
                      "name": "Работа со слоями",
                      "level": "Уверенный",
                      "progress": "85%"
                },
                {
                      "name": "Создание баннеров",
                      "level": "Уверенный",
                      "progress": "75%"
                }
          ],
          "opportunities": [
                {
                      "icon": "freelance",
                      "title": "Брать заказы на дизайн",
                      "description": "Обрабатывать фото, создавать баннеры"
                },
                {
                      "icon": "company",
                      "title": "Работать дизайнером",
                      "description": "В рекламном агентстве или студии"
                },
                {
                      "icon": "growth",
                      "title": "Развиваться дальше",
                      "description": "Освоить Illustrator и веб-дизайн"
                }
          ]
    },
    "curriculum": {
      "headline": "Программа курса",
      "description": "Бестселлер-курс по Photoshop с нуля до результата — теперь в обновлённой версии с нейросетями. Курс для абсолютных новичков с основ до продвинутых работ.",
      "modules": [
        {
          "id": 1,
          "number": "01",
          "title": "Введение",
          "info": "6 лекций",
          "lessons": [
            { "lesson": "О чем курс" },
            { "lesson": "Скачайте материалы к курсу" },
            { "lesson": "Как приобрести лицензионный Photoshop из РФ" },
            { "lesson": "Устанавливаем и настраиваем Photoshop" },
            { "lesson": "Стоковые площадки и поиск референсов" },
            { "lesson": "Оставайтесь со мной на связи" }
          ]
        },
        {
          "id": 2,
          "number": "02",
          "title": "Нейросети в Photoshop",
          "info": "8 лекций",
          "lessons": [
            { "lesson": "Как генерировать изображения с помощью ИИ" },
            { "lesson": "Как работают слои в Photoshop" },
            { "lesson": "Генерируем фон для чемодана" },
            { "lesson": "Как вращать изображение в 3D с помощью ИИ" },
            { "lesson": "Как гармонизировать изображения из разных фото" },
            { "lesson": "Как улучшать качество изображений" },
            { "lesson": "Как работают Generative Expand и Crop Tool" },
            { "lesson": "Как правильно сохранять проекты и изображения" }
          ]
        },
        {
          "id": 3,
          "number": "03",
          "title": "Корректирующие слои",
          "info": "4 лекции",
          "lessons": [
            { "lesson": "Как объединять слои" },
            { "lesson": "Как работает корректирующий слой «Уровни»" },
            { "lesson": "Как работает корректирующий слой «Цветовой тон / Насыщенность»" },
            { "lesson": "Как работает корректирующий слой Hue & Saturation" }
          ]
        },
        {
          "id": 4,
          "number": "04",
          "title": "Текст",
          "info": "3 лекции",
          "lessons": [
            { "lesson": "Как работать с текстом в Photoshop" },
            { "lesson": "Настройки текста и шрифта" },
            { "lesson": "Как создавать текст по контуру" }
          ]
        },
        {
          "id": 5,
          "number": "05",
          "title": "Фигуры",
          "info": "4 лекции",
          "lessons": [
            { "lesson": "Как создавать фигуры в Photoshop" },
            { "lesson": "Как работать с текстом и фигурами вместе" },
            { "lesson": "Как работает инструмент Pen Tool" },
            { "lesson": "Практика: завершаем работу с фигурами" }
          ]
        },
        {
          "id": 6,
          "number": "06",
          "title": "Стили слоя",
          "info": "4 лекции",
          "lessons": [
            { "lesson": "Как использовать стиль «Наложение градиента»" },
            { "lesson": "Как работать с тенями" },
            { "lesson": "Как работает стиль «Тиснение»" },
            { "lesson": "Как работают остальные стили слоя" }
          ]
        },
        {
          "id": 7,
          "number": "07",
          "title": "Выделения и маски",
          "info": "10 лекций",
          "lessons": [
            { "lesson": "Как поместить небо в чашку" },
            { "lesson": "Как работает инструмент «Быстрое выделение»" },
            { "lesson": "Автоматическое выделение объектов" },
            { "lesson": "Как работают маски в Photoshop" },
            { "lesson": "Как работать с выделением через маски" },
            { "lesson": "Как работает Clipping Mask (обтравочная маска)" },
            { "lesson": "Как заменить небо в Photoshop" },
            { "lesson": "Как аккуратно вырезать волосы" },
            { "lesson": "Как работать с выделением «Цветовой диапазон»" },
            { "lesson": "Финальная доработка карточки товара" }
          ]
        },
        {
          "id": 8,
          "number": "08",
          "title": "Фильтры",
          "info": "3 лекции",
          "lessons": [
            { "lesson": "Как работать с фильтрами" },
            { "lesson": "Работаем с фильтрами Lens Blur и Noise" },
            { "lesson": "Как работают Neural Filters" }
          ]
        },
        {
          "id": 9,
          "number": "09",
          "title": "Практика #1 — Карточка товара",
          "info": "1 лекция",
          "lessons": [
            { "lesson": "Создаём собственный дизайн карточки товара" }
          ]
        },
        {
          "id": 10,
          "number": "10",
          "title": "Смарт-объекты",
          "info": "2 лекции",
          "lessons": [
            { "lesson": "Как работают смарт-объекты" },
            { "lesson": "Как работать с мокапами" }
          ]
        },
        {
          "id": 11,
          "number": "11",
          "title": "Ретушь фотографий",
          "info": "13 лекций",
          "lessons": [
            { "lesson": "Как работает Adobe Bridge" },
            { "lesson": "Как работает модуль Camera Raw" },
            { "lesson": "Как удалять лишние объекты с изображения" },
            { "lesson": "Как удалять прыщи и дефекты кожи" },
            { "lesson": "Как работает корректирующий слой «Кривые»" },
            { "lesson": "Как работать с частотным разложением" },
            { "lesson": "Как работать с экшенами" },
            { "lesson": "Как работают инструменты осветления и затемнения" },
            { "lesson": "Профессиональные техники осветления и затемнения" },
            { "lesson": "Принципы работы с корректирующими слоями" },
            { "lesson": "Как работает корректирующий слой Color Balance" },
            { "lesson": "Как работает корректирующий слой Selective Color" },
            { "lesson": "Финальная цветокоррекция и корректировки" }
          ]
        },
        {
          "id": 12,
          "number": "12",
          "title": "Практика #2 — Ретушь фотографии",
          "info": "1 лекция",
          "lessons": [
            { "lesson": "Практика: ретушируем фотографию" }
          ]
        },
        {
          "id": 13,
          "number": "13",
          "title": "Трансформация и искажение",
          "info": "6 лекций",
          "lessons": [
            { "lesson": "Как деформировать объекты в Photoshop" },
            { "lesson": "Как выравнивать перспективу" },
            { "lesson": "Как использовать инструмент «Деформация перспективы»" },
            { "lesson": "Как работает инструмент Liquify" },
            { "lesson": "Как работает инструмент Puppet Warp" },
            { "lesson": "Практика: создаём Stretch Effect" }
          ]
        },
        {
          "id": 14,
          "number": "14",
          "title": "Необходимая теория",
          "info": "3 лекции",
          "lessons": [
            { "lesson": "Разница между RGB и CMYK" },
            { "lesson": "Разница между форматами PNG, JPG и SVG" },
            { "lesson": "Что такое DPI и PPI" }
          ]
        },
        {
          "id": 15,
          "number": "15",
          "title": "Обложка для YouTube-ролика — часть 1",
          "info": "9 лекций",
          "lessons": [
            { "lesson": "Подготавливаем портрет для обложки" },
            { "lesson": "Что такое Artboard в Photoshop" },
            { "lesson": "Как рисовать свет в стиле YouTube" },
            { "lesson": "Как работать с RGB-каналами в корректирующем слое «Кривые»" },
            { "lesson": "Как работают режимы наложения" },
            { "lesson": "Как использовать текстуры в работе" },
            { "lesson": "Дорабатываем заголовок обложки" },
            { "lesson": "Как работать с кистями в Photoshop" },
            { "lesson": "Дорабатываем обложку YouTube-видео" }
          ]
        },
        {
          "id": 16,
          "number": "16",
          "title": "Обложка для YouTube-ролика — часть 2",
          "info": "2 лекции",
          "lessons": [
            { "lesson": "Генерация и подготовка изображения" },
            { "lesson": "Создаём профессиональную обложку в стиле MrBeast" }
          ]
        },
        {
          "id": 17,
          "number": "17",
          "title": "Практика #3 — Создаём обложку для YouTube",
          "info": "1 лекция",
          "lessons": [
            { "lesson": "Практика создаём обложку для YouTube" }
          ]
        }
      ]
    },
    "additionalCategories": [
      "Бестселлеры",
      "С нуля"
    ]
  },
  {
    "id": 11,
    "slug": "photoshop-pro",
    "skillspaceCourses": [{ "courseId": "15658", "groupId": "25302" }],
    "title": "Курс Photoshop (Pro)",
    "subtitle": "Со знаниями Photoshop",
    "description": "Ищите продвинутых техник по работе в photoshop? В этом курсе, Вы изучите все чтобы стать настоящим ассом, в графическом редакторе Adobe Photoshop!",
    "fullDescription": "Photoshop Pro — это продвинутый курс, в котором вы научитесь профессионально ретушировать портреты, создавать сложные коллажи, работать с цветом и использовать нестандартные техники обработки изображений.",
    "image": "/images/courses/photoshop-pro-paper-v3.webp",
    "promoVideo": "https://rutube.ru/play/embed/025e012883819bbc0b0689be55787b88",
    "price": 2290,
    "originalPrice": 3990,
    "discount": 43,
    "saleDiscount": 25,
    "category": "Графический дизайн",
    "lessons": 76,
    "totalHours": 9.5,
    "duration": "1 месяц",
    "level": "Средний",
    "students": 2500,
    "rating": 4.9,
    "reviewPlatforms": {
      "udemy": { "url": "https://www.udemy.com/course/adobe-photoshop-2021/#reviews", "rating": 4.8, "count": 550 },
      "stepik": { "url": "https://stepik.org/course/106836/reviews", "rating": 5, "count": 220 }
    },
    "features": [
      "Интерактивность, общение с преподавателем",
      "Практические задания после каждого урока",
      "Реальные проекты для портфолио",
      "Пожизненный доступ к материалам"
    ],
    "stats": [
      {
        "value": "50K+",
        "label": "Просмотров"
      },
      {
        "value": "100K+",
        "label": "Студентов"
      },
      {
        "value": "150K+",
        "label": "Практических заданий"
      }
    ],
    "topics": [
      "Вы изучите лучшие и самые современные техники по выделения объектов",
      "Вы детально изучите то, как работают корректирующие слои",
      "Вы начнете использовать в работе Гистограмму и круг HSL",
      "Вы изучите продвинутые техники по ретуши ваших портретов",
      "Вы научитесь обработке RAW фото в Photoshop",
      "Вы научитесь крутым техникам ретуши глаз, зубов, тона кожи и работе со свето - теневым рисунком",
      "Вы научитесь продвинутым техникам наращивания границ изображений и расширению кадра",
      "Вы научитесь бесследно удалять любые объекты из изображений",
      "Вы научитесь выравнивать и деформировать любые объекты и элементы фото"
    ],
    "testimonials": [
      {
        "name": "Татьяна",
        "role": "Студент курса",
        "text": "Прошла курс за 2 недели ,научилась еще большему)Конечно есть вид работ ,который так с первого раза полностью не запомнишь ,нужно больше практики,чтобы все было на автомате )Но по курсу все задачи сделать удалось) Теперь действительно видя в интернете какие-то работы уже представляешь,как можно было бы их повторить - это здорово и придает уверенности)",
        "rating": 5
      },
      {
        "name": "Мария",
        "role": "Студент курса",
        "text": "Отличный курс, 10/10! Рекомендую. Подача понятная и интересная, практические задания не скучно выполнять. Понравилось, что видео по каждой теме в среднем укладываются в 10-20 минут, нет воды. Осталось еще немного, чтобы пройти курс целиком, но я уже подцепила много полезных фишек, горячих клавиш, которые сразу же начала применять в своей работе. Курс оказался очень и очень полезным! За такую стоимость это просто находка!",
        "rating": 5
      }
    ],
    "aboutSection": {
      "headline": "Редактирование фотографий, ретушь, создание графики и коллажей. Все это Курс по Photoshop",
      "highlightedText": "",
      "description": "Photoshop Pro — это продвинутый курс, в котором вы научитесь профессионально ретушировать портреты, создавать сложные коллажи, работать с цветом и использовать нестандартные техники обработки изображений.",
      "featureCard": {
        "text": "Photoshop Pro помогает достичь высокого уровня в ретуши, цветокоррекции и создании коллажей."
      },
      "courseCard": {
        "title": "Photoshop (Pro)",
        "subtitle": "Со знаниями Photoshop",
        "tagline": "Ищите продвинутых техник по работе в photoshop? В ",
        "badge": "КУ"
      },
      "targetAudience": [
              {
                      "icon": "book",
                      "title": "Пользователь Photoshop",
                      "description": "Знаете основы, хотите большего",
                      "color": "teal",
                      "benefits": [
                              "Продвинутые техники",
                              "Профессиональная ретушь"
                      ]
              },
              {
                      "icon": "palette",
                      "title": "Дизайнер",
                      "description": "Хотите создавать сложную графику",
                      "color": "purple",
                      "benefits": [
                              "Коллажи",
                              "Фотоманипуляции"
                      ]
              },
              {
                      "icon": "briefcase",
                      "title": "Ретушёр",
                      "description": "Хотите работать профессионально",
                      "color": "orange",
                      "benefits": [
                              "Коммерческая ретушь",
                              "Быстрые техники"
                      ]
              },
              {
                      "icon": "zap",
                      "title": "Контент-криейтор",
                      "description": "Создаёте уникальный контент",
                      "color": "emerald",
                      "benefits": [
                              "Авторский стиль",
                              "Креативные эффекты"
                      ]
              }
      ]
    },
    "careerSection": {
          "title": "Сколько зарабатывают профессиональные ретушёры?",
          "description": "Продвинутые навыки Photoshop открывают путь к работе с крупными брендами и рекламными агентствами",
          "vacancies": "1 800+",
          "growth": "+15%",
          "salaryLevels": [
                {
                      "title": "Ретушёр (0-1 год)",
                      "salary": "55 000 ₽",
                      "progress": "30%"
                },
                {
                      "title": "Опытный ретушёр",
                      "salary": "100 000 ₽",
                      "progress": "55%"
                },
                {
                      "title": "Эксперт",
                      "salary": "180 000+ ₽",
                      "progress": "100%"
                }
          ],
          "source": "* По данным hh.ru и Хабр Карьера, 2025"
    },
    "skillsSection": {
          "skills": [
                {
                      "name": "Профессиональная ретушь",
                      "level": "Продвинутый",
                      "progress": "95%"
                },
                {
                      "name": "Фотоманипуляции",
                      "level": "Продвинутый",
                      "progress": "90%"
                },
                {
                      "name": "Коллажирование",
                      "level": "Уверенный",
                      "progress": "85%"
                },
                {
                      "name": "Коммерческая обработка",
                      "level": "Уверенный",
                      "progress": "80%"
                }
          ],
          "opportunities": [
                {
                      "icon": "freelance",
                      "title": "Работать с брендами",
                      "description": "Обрабатывать рекламные и fashion-съёмки"
                },
                {
                      "icon": "company",
                      "title": "Устроиться ретушёром",
                      "description": "В рекламное агентство или продакшн"
                },
                {
                      "icon": "growth",
                      "title": "Развиваться дальше",
                      "description": "Создать свой авторский стиль"
                }
          ]
    },
    "curriculum": {
      "headline": "Программа курса",
      "description": "Ищите продвинутых техник по работе в photoshop? В этом курсе, Вы изучите все чтобы стать настоящим ассом, в графическом редакторе Adobe Photoshop!",
      "modules": [
        {
          "id": 1,
          "number": "01",
          "title": "Введение",
          "info": "5 лекций • 16м",
          "lessons": [
            {
              "lesson": "О чем курс",
              "time": "03:16"
            },
            {
              "lesson": "Как приобрести лицензионный Photoshop",
              "time": "02:15"
            },
            {
              "lesson": "Как проходить этот курс",
              "time": "03:03"
            },
            {
              "lesson": "Настройка Adobe Photoshop",
              "time": "06:58"
            },
            {
              "lesson": "Оставайтесь со мной на связи",
              "time": "00:11"
            }
          ]
        },
        {
          "id": 2,
          "number": "02",
          "title": "Выделение и маски",
          "info": "7 лекций • 1ч 2м",
          "lessons": [
            {
              "lesson": "О чем этот блок?",
              "time": "00:38"
            },
            {
              "lesson": "Основные инструменты выделения объектов",
              "time": "24:21"
            },
            {
              "lesson": "Практика по выделению объектов",
              "time": "1 question"
            },
            {
              "lesson": "Как выделять объекты используя цветовой диапазон",
              "time": "10:00"
            },
            {
              "lesson": "Улучшение цвета с помощью цветового диапазона",
              "time": "05:17"
            }
          ]
        },
        {
          "id": 3,
          "number": "03",
          "title": "Коррекция изображений",
          "info": "8 лекций • 54м",
          "lessons": [
            {
              "lesson": "О чем этот блок?",
              "time": "00:44"
            },
            {
              "lesson": "Что такое гистограмма и уровни",
              "time": "08:55"
            },
            {
              "lesson": "Как работают кривые",
              "time": "05:48"
            },
            {
              "lesson": "Знакомство с кругом HSL",
              "time": "04:44"
            },
            {
              "lesson": "Базовая цвето-коррекция",
              "time": "05:33"
            }
          ]
        },
        {
          "id": 4,
          "number": "04",
          "title": "Настройки и рабочий процесс",
          "info": "8 лекций • 59м",
          "lessons": [
            {
              "lesson": "О чем этот блок?",
              "time": "00:35"
            },
            {
              "lesson": "Как увеличить производительность программы",
              "time": "06:41"
            },
            {
              "lesson": "Как настроить интерфейс Photoshop для себя",
              "time": "12:47"
            },
            {
              "lesson": "Настройка цветовых профилей",
              "time": "02:42"
            },
            {
              "lesson": "Горячие клавиши и хаки",
              "time": "14:04"
            }
          ]
        },
        {
          "id": 5,
          "number": "05",
          "title": "Обрезка и искажение",
          "info": "8 лекций • 49м",
          "lessons": [
            {
              "lesson": "О чем этот блок?",
              "time": "00:26"
            },
            {
              "lesson": "Расширяем изображение с помощью масштаба с учетом содержимого",
              "time": "10:39"
            },
            {
              "lesson": "Используем заливку с учетом содержимого для увеличения пространства",
              "time": "07:55"
            },
            {
              "lesson": "Перемещаем объекты с инструментом ",
              "time": "05:55"
            },
            {
              "lesson": "Пора удалить всех птиц!",
              "time": "02:42"
            }
          ]
        },
        {
          "id": 6,
          "number": "06",
          "title": "Библиотеки",
          "info": "1 лекция • 18м",
          "lessons": [
            {
              "lesson": "Как использовать библиотеки",
              "time": "18:10"
            }
          ]
        },
        {
          "id": 7,
          "number": "07",
          "title": "Ретушь",
          "info": "11 лекций • 1ч",
          "lessons": [
            {
              "lesson": "О чем этот блок?",
              "time": "00:25"
            },
            {
              "lesson": "Используем восстанавливающую кисть + штамп",
              "time": "07:59"
            },
            {
              "lesson": "Как работает частотное разложение",
              "time": "08:05"
            },
            {
              "lesson": "Используем инструмент ",
              "time": "02:30"
            },
            {
              "lesson": "Как использовать инструмент ",
              "time": "06:17"
            }
          ]
        },
        {
          "id": 8,
          "number": "08",
          "title": "Монтажные области",
          "info": "4 лекции • 40м",
          "lessons": [
            {
              "lesson": "О чем этот блок?",
              "time": "00:33"
            },
            {
              "lesson": "Введение в монтажные области",
              "time": "10:55"
            },
            {
              "lesson": "Связи изображений в Photoshop",
              "time": "21:36"
            },
            {
              "lesson": "Экспорт монтажных областей",
              "time": "06:46"
            }
          ]
        },
        {
          "id": 9,
          "number": "09",
          "title": "Монтаж видео в Photoshop",
          "info": "4 лекции • 40м",
          "lessons": [
            {
              "lesson": "О чем этот блок?",
              "time": "00:29"
            },
            {
              "lesson": "Как монтировать видео в Photoshop",
              "time": "21:55"
            },
            {
              "lesson": "Создаем ",
              "time": "08:43"
            },
            {
              "lesson": "Создайте собственную синемаграфию",
              "time": "1 question"
            },
            {
              "lesson": "Как оживить фото",
              "time": "08:47"
            }
          ]
        },
        {
          "id": 10,
          "number": "10",
          "title": "Коллажирование",
          "info": "6 лекций • 1ч 9м",
          "lessons": [
            {
              "lesson": "О чем этот блок?",
              "time": "00:31"
            },
            {
              "lesson": "Создаем коллаж - часть 1",
              "time": "17:26"
            },
            {
              "lesson": "Создаем коллаж - часть 2",
              "time": "17:41"
            },
            {
              "lesson": "Как рисовать магию",
              "time": "16:07"
            },
            {
              "lesson": "Создайте собственную магию",
              "time": "1 question"
            }
          ]
        },
        {
          "id": 11,
          "number": "11",
          "title": "Текст и шрифт",
          "info": "3 лекции • 25м",
          "lessons": [
            {
              "lesson": "О чем этот блок?",
              "time": "00:24"
            },
            {
              "lesson": "Продвинутая работа с текстом",
              "time": "13:41"
            },
            {
              "lesson": "Создаем силуэт из текста",
              "time": "11:07"
            },
            {
              "lesson": "Создайте собственный эффект силуэта из текста",
              "time": "1 question"
            }
          ]
        },
        {
          "id": 12,
          "number": "12",
          "title": "Работа с 3D",
          "info": "4 лекции • 26м",
          "lessons": [
            {
              "lesson": "О чем этот блок?",
              "time": "00:27"
            },
            {
              "lesson": "Навигация в 3D среде",
              "time": "13:30"
            },
            {
              "lesson": "Материалы объектов 3D и рендеринг",
              "time": "08:28"
            },
            {
              "lesson": "Экспорт 3D файла",
              "time": "03:11"
            }
          ]
        },
        {
          "id": 13,
          "number": "13",
          "title": "Шаблоны",
          "info": "3 лекции • 20м",
          "lessons": [
            {
              "lesson": "Что такое шаблоны",
              "time": "09:39"
            },
            {
              "lesson": "Как создать собственный шаблон",
              "time": "03:10"
            },
            {
              "lesson": "Как оформить работу",
              "time": "07:36"
            }
          ]
        },
        {
          "id": 14,
          "number": "14",
          "title": "Обновления 2023-2024",
          "info": "3 лекции • 21м",
          "lessons": [
            {
              "lesson": "New Remove tool",
              "time": "06:59"
            },
            {
              "lesson": "Generative fill. Нейросети в Photoshop",
              "time": "11:28"
            },
            {
              "lesson": "Новые меню Gradient & Adjustments",
              "time": "02:54"
            }
          ]
        },
        {
          "id": 15,
          "number": "15",
          "title": "Что дальше?",
          "info": "1 лекция • 2м",
          "lessons": [
            {
              "lesson": "До новых встреч!",
              "time": "01:47"
            }
          ]
        }
      ]
    },
    "additionalCategories": [
      "Продвинутый уровень"
    ]
  },
  {
    "id": 12,
    "slug": "premiere-pro",
    "skillspaceCourses": [{ "courseId": "15651", "groupId": "25291" }],
    "title": "Курс Adobe Premiere Pro",
    "subtitle": "C нуля",
    "description": "В этом курсе вы найдете все необходимое, чтобы начать создавать по настоящему творческие видео. Освойте современные методы видеомонтажа в программе Premiere Pro",
    "fullDescription": "Adobe Premiere Pro — это программа для монтажа видео и создания видеопроектов. В этом курсе вы научитесь монтировать видео, добавлять спецэффекты, работать со звуком и создавать профессиональные видеоролики.",
    "image": "/images/courses/premiere-pro-paper-v2.webp",
    "promoVideo": "https://rutube.ru/play/embed/ac4a53b409cdc5ab17d894b515fd056b",
    "price": 2290,
    "originalPrice": 3990,
    "discount": 43,
    "saleDiscount": 25,
    "category": "Видеомонтаж",
    "lessons": 88,
    "totalHours": 9.0,
    "duration": "1 месяц",
    "level": "С нуля",
    "students": 2500,
    "rating": 4.9,
    "reviewPlatforms": {
      "udemy": { "url": "https://www.udemy.com/course/premiere-pro-2022/#reviews", "rating": 4.8, "count": 650 },
      "stepik": { "url": "https://stepik.org/course/122287/reviews", "rating": 5, "count": 280 }
    },
    "features": [
      "Интерактивность, общение с преподавателем",
      "Практические задания после каждого урока",
      "Реальные проекты для портфолио",
      "Пожизненный доступ к материалам"
    ],
    "stats": [
      {
        "value": "50K+",
        "label": "Просмотров"
      },
      {
        "value": "100K+",
        "label": "Студентов"
      },
      {
        "value": "150K+",
        "label": "Практических заданий"
      }
    ],
    "topics": [
      "Научитесь монтажу видео в Adobe Premiere Pro с нуля",
      "Изучите самые важные инструменты программы Premiere Pro",
      "Узнаете, как работать с цвето-коррекцией видео",
      "Научитесь использовать пресеты в своих видео",
      "Научитесь ускорять или замедлять видео",
      "Узнаете, как создавать видео переходы",
      "Начнете создавать собственную графику движения в видео",
      "Научитесь применять сторонние графические шаблоны в своих видео",
      "Научитесь очищать звук и делать голос сильнее"
    ],
    "testimonials": [
      {
        "name": "Евгений",
        "role": "Студент курса",
        "text": "Отличный, понятный и приятный курс. Сначала купил курс по After Effects у этого преподавателя, затем решил освоить сначала Premier Pro. Раньше монтаж роликов делал в Sony Vegas и считал её гораздо более удобной программой для монтажа. Сейчас моё мнение поменялось. Спасибо за уроки, думаю приобрету и другие курсы.",
        "rating": 5
      },
      {
        "name": "Надежда",
        "role": "Студент курса",
        "text": "Очень полезный и удобный курс! Автор подробно, но без лишней воды, объясняет все детали и нюансы. Очень приятная подача. До этого курса пробовала самостоятельно изучать, сложно было систематизировать найденную информацию. А в данном курсе отличная систематизация и последовательность занятий. Среди курсов искала такой, чтобы не был ",
        "rating": 5
      }
    ],
    "aboutSection": {
      "headline": "Монтаж видео, работа с аудио, создание анимаций и спецэффектов. Все это Курс по Premiere Pro",
      "highlightedText": "",
      "description": "Adobe Premiere Pro — это программа для монтажа видео и создания видеопроектов. В этом курсе вы научитесь монтировать видео, добавлять спецэффекты, работать со звуком и создавать профессиональные видеоролики.",
      "featureCard": {
        "text": "Adobe Premiere Pro — программа для профессионального монтажа и создания видеопроектов."
      },
      "courseCard": {
        "title": "Adobe Premiere Pro",
        "subtitle": "C нуля",
        "tagline": "В этом курсе вы найдете все необходимое, чтобы нач",
        "badge": "КУ"
      },
      "targetAudience": [
              {
                      "icon": "book",
                      "title": "Начинающий видеомейкер",
                      "description": "Хотите научиться монтировать видео",
                      "color": "teal",
                      "benefits": [
                              "Основы монтажа",
                              "Интерфейс программы"
                      ]
              },
              {
                      "icon": "palette",
                      "title": "Контент-криейтор",
                      "description": "Создаёте видео для YouTube",
                      "color": "purple",
                      "benefits": [
                              "Динамичный монтаж",
                              "Эффекты и переходы"
                      ]
              },
              {
                      "icon": "briefcase",
                      "title": "Видеограф",
                      "description": "Снимаете видео на заказ",
                      "color": "orange",
                      "benefits": [
                              "Профессиональный монтаж",
                              "Цветокоррекция"
                      ]
              },
              {
                      "icon": "zap",
                      "title": "Маркетолог",
                      "description": "Делаете видео для рекламы",
                      "color": "emerald",
                      "benefits": [
                              "Продающие ролики",
                              "Быстрая работа"
                      ]
              }
      ]
    },
    "careerSection": {
          "title": "Сколько зарабатывают видеомонтажёры?",
          "description": "Видеоконтент растёт на 80% в год. Монтажёры нужны блогерам, агентствам и продакшн-студиям",
          "vacancies": "2 500+",
          "growth": "+34%",
          "salaryLevels": [
                {
                      "title": "Начинающий (0-1 год)",
                      "salary": "50 000 ₽",
                      "progress": "30%"
                },
                {
                      "title": "Средний (1-3 года)",
                      "salary": "100 000 ₽",
                      "progress": "55%"
                },
                {
                      "title": "Профессионал",
                      "salary": "180 000+ ₽",
                      "progress": "100%"
                }
          ],
          "source": "* По данным hh.ru и Хабр Карьера, 2025"
    },
    "skillsSection": {
          "skills": [
                {
                      "name": "Видеомонтаж",
                      "level": "Продвинутый",
                      "progress": "90%"
                },
                {
                      "name": "Цветокоррекция",
                      "level": "Уверенный",
                      "progress": "80%"
                },
                {
                      "name": "Работа со звуком",
                      "level": "Уверенный",
                      "progress": "75%"
                },
                {
                      "name": "Эффекты и переходы",
                      "level": "Уверенный",
                      "progress": "80%"
                }
          ],
          "opportunities": [
                {
                      "icon": "freelance",
                      "title": "Брать заказы на монтаж",
                      "description": "Монтировать ролики для YouTube и рекламу"
                },
                {
                      "icon": "company",
                      "title": "Работать монтажёром",
                      "description": "В продакшн-студии или агентстве"
                },
                {
                      "icon": "growth",
                      "title": "Развиваться дальше",
                      "description": "Освоить After Effects для эффектов"
                }
          ]
    },
    "curriculum": {
      "headline": "Программа курса",
      "description": "В этом курсе вы найдете все необходимое, чтобы начать создавать по настоящему творческие видео. Освойте современные методы видеомонтажа в программе Premiere Pro",
      "modules": [
        {
          "id": 1,
          "number": "01",
          "title": "Введение",
          "info": "4 лекции • 10м",
          "lessons": [
            {
              "lesson": "О чем курс",
              "time": "02:50"
            },
            {
              "lesson": "Подготовка к курсу. Скачайте материалы для курса",
              "time": "04:44"
            },
            {
              "lesson": "Как купить лицензионный Premiere Pro",
              "time": "02:15"
            },
            {
              "lesson": "Оставайтесь со мной на связи!",
              "time": "00:16"
            }
          ]
        },
        {
          "id": 2,
          "number": "02",
          "title": "Основы Premiere Pro",
          "info": "16 лекций • 2ч 21м",
          "lessons": [
            {
              "lesson": "Знакомство с интерфейсом программы ч.1",
              "time": "17:34"
            },
            {
              "lesson": "Разница старого и нового интерфейса Premiere Pro",
              "time": "06:43"
            },
            {
              "lesson": "Знакомство с интерфейсом программы ч.2",
              "time": "12:49"
            },
            {
              "lesson": "Как работать со звуком",
              "time": "09:54"
            },
            {
              "lesson": "Как добавить визуальный маркер",
              "time": "08:48"
            }
          ]
        },
        {
          "id": 3,
          "number": "03",
          "title": "Углубление в монтаж. Создаем фильм",
          "info": "19 лекций • 2ч 15м",
          "lessons": [
            {
              "lesson": "О чем этот блок",
              "time": "01:19"
            },
            {
              "lesson": "Где взять сырой материал фильма для практики",
              "time": "08:10"
            },
            {
              "lesson": "Как организовать папку с проектом",
              "time": "04:21"
            },
            {
              "lesson": "Работа с папками в PremierePro",
              "time": "07:42"
            },
            {
              "lesson": "Как сохранять рабочую область под себя",
              "time": "03:10"
            }
          ]
        },
        {
          "id": 4,
          "number": "04",
          "title": "Небольшое ускорение Premiere Pro",
          "info": "3 лекции • 16м",
          "lessons": [
            {
              "lesson": "Как ускорить работу PremierePro",
              "time": "04:26"
            },
            {
              "lesson": "Как запускать рендер таймлайна в самом PremierePro",
              "time": "05:47"
            },
            {
              "lesson": "Пара горячих клавиш которые помогут вам ускориться",
              "time": "05:59"
            }
          ]
        },
        {
          "id": 5,
          "number": "05",
          "title": "Работа со звуком",
          "info": "10 лекций • 50м",
          "lessons": [
            {
              "lesson": "О чем этот блок",
              "time": "01:19"
            },
            {
              "lesson": "Необходимое оборудование для монтажа и записи аудио",
              "time": "04:51"
            },
            {
              "lesson": "Как синхронизировать 2 аудио дорожки",
              "time": "07:05"
            },
            {
              "lesson": "Системные настройки звука",
              "time": "02:23"
            },
            {
              "lesson": "Как убрать фоновый шум из аудио",
              "time": "07:47"
            }
          ]
        },
        {
          "id": 6,
          "number": "06",
          "title": "Технические вещи",
          "info": "8 лекций • 41м",
          "lessons": [
            {
              "lesson": "Что такое разрешение у видео",
              "time": "04:45"
            },
            {
              "lesson": "Разрешение футажа и последовательности",
              "time": "08:00"
            },
            {
              "lesson": "Как создать кастомную последовательность",
              "time": "03:45"
            },
            {
              "lesson": "Как работают кадры в секунду. Эффект ",
              "time": "05:45"
            },
            {
              "lesson": "Разница между fps в последовательности и fps в видео",
              "time": "02:39"
            }
          ]
        },
        {
          "id": 7,
          "number": "07",
          "title": "Работа с KeyFrames",
          "info": "12 лекций • 1ч 9м",
          "lessons": [
            {
              "lesson": "О чем этот блок",
              "time": "01:48"
            },
            {
              "lesson": "Что такое соотношение сторон, необходимые требования для видео",
              "time": "08:04"
            },
            {
              "lesson": "Используем keyframe для движения видео в кадре",
              "time": "09:24"
            },
            {
              "lesson": "Используем keyframe с текстом",
              "time": "09:01"
            },
            {
              "lesson": "Как добавить плавности и естественности нашим анимациям",
              "time": "04:06"
            }
          ]
        },
        {
          "id": 8,
          "number": "08",
          "title": "Работа с масками",
          "info": "9 лекций • 48м",
          "lessons": [
            {
              "lesson": "Как работают маски в PremierePro",
              "time": "06:44"
            },
            {
              "lesson": "Разбираемся с настройками масок",
              "time": "05:19"
            },
            {
              "lesson": "Автоматический и ручной трекинг масок",
              "time": "04:53"
            },
            {
              "lesson": "Как создать несколько масок",
              "time": "04:57"
            },
            {
              "lesson": "ПРАКТИКА: Цвето-кор с помощью масок",
              "time": "01:36"
            }
          ]
        },
        {
          "id": 9,
          "number": "09",
          "title": "Screen cast",
          "info": "6 лекций • 31м",
          "lessons": [
            {
              "lesson": "Как записать screen cast",
              "time": "07:42"
            },
            {
              "lesson": "Как обрезать видео в несколько раз быстрее",
              "time": "08:22"
            },
            {
              "lesson": "Как ускорить воспроизведение видео",
              "time": "02:29"
            },
            {
              "lesson": "Как быстрее ускорять или замедлять видео",
              "time": "02:39"
            },
            {
              "lesson": "Динамичный zoom видео",
              "time": "06:31"
            }
          ]
        },
        {
          "id": 10,
          "number": "10",
          "title": "Заключение",
          "info": "1 лекция • 6м",
          "lessons": [
            {
              "lesson": "Что дальше и поиск вдохновения",
              "time": "05:52"
            }
          ]
        }
      ]
    },
    "additionalCategories": [
      "С нуля"
    ]
  },
  {
    "id": 13,
    "slug": "video-montage-program",
    "skillspaceCourses": [
      { "courseId": "15556", "groupId": "25159" },
      { "courseId": "15651", "groupId": "25291" }
    ],
    "title": "Программа: Видеомантаж + Создание графики в Ae",
    "subtitle": "C нуля",
    "description": "В этом курсе вы узнаете всё о создании современной графики и эффектной анимации в After Effects, а также освоите современные методы видеомонтажа в программе Premiere Pro, чтобы создавать по-настоящему творческие видео!",
    "fullDescription": "Adobe Premiere Pro и After Effects — программы для монтажа видео, создания анимации и спецэффектов. В этом курсе вы научитесь монтировать видео, добавлять визуальные эффекты, работать со звуком, создавать профессиональные видеоролики, а также осваивать анимацию и графику для видеопроектов на разных платформах.",
    "image": "/images/courses/video-montage-program-paper-v2.webp",
    "promoVideo": "https://rutube.ru/play/embed/6a828f388620a5dad1f56c342cb1c2d4",
    "price": 3690,
    "originalPrice": 6990,
    "discount": 47,
    "saleDiscount": 20,
    "category": "Пакеты курсов",
    "lessons": 161,
    "totalHours": 20.5,
    "duration": "3 месяца",
    "level": "С нуля",
    "students": 2500,
    "rating": 4.9,
    "features": [
      "Интерактивность, общение с преподавателем",
      "Практические задания после каждого урока",
      "Реальные проекты для портфолио",
      "Пожизненный доступ к материалам"
    ],
    "stats": [
      {
        "value": "50K+",
        "label": "Просмотров"
      },
      {
        "value": "100K+",
        "label": "Студентов"
      },
      {
        "value": "150K+",
        "label": "Практических заданий"
      }
    ],
    "topics": [
      "Научитесь монтажу видео в Adobe Premiere Pro с нуля",
      "Изучите самые важные инструменты программы Premiere Pro",
      "Узнаете как работать с цвето-коррекцией видео",
      "Научитесь использовать пресеты в своих видео",
      "Научитесь ускорять или замедлять видео",
      "Узнаете как создавать видео переходы",
      "Начнете создавать собственную графику движения в видео",
      "Научитесь применять сторонние графические шаблоны в своих видео",
      "Научитесь отчищать звук и делать голос сильнее"
    ],
    "testimonials": [
      {
        "name": "Иван",
        "role": "Студент курса",
        "text": "Замечательный курс, уже третий, который прохожу у Дмитрия. Как всегда, очень доступное и понятное изложение, прекрасная логика и удобная подача материала со всеми нужными ссылками, сервисами, презентациями. Объем материла тщательно отфильтрован, ничего лишнего.",
        "rating": 5
      },
      {
        "name": "Мария",
        "role": "Студент курса",
        "text": "Замечательный курс, уже третий, который прохожу у Дмитрия. Как всегда, очень доступное и понятное изложение, прекрасная логика и удобная подача материала со всеми нужными ссылками, сервисами, презентациями. Объем материла тщательно отфильтрован, ничего лишнего.",
        "rating": 5
      }
    ],
    "aboutSection": {
      "headline": "Монтаж видео, работа с аудио, создание анимаций и спецэффектов, создание сложных анимаций, работа с визуальными эффектами, композиция видео и подготовка графики для различных платформ — всё это вы найдете в курсах по Premiere Pro и After Effects",
      "highlightedText": "",
      "description": "Adobe Premiere Pro и After Effects — программы для монтажа видео, создания анимации и спецэффектов. В этом курсе вы научитесь монтировать видео, добавлять визуальные эффекты, работать со звуком, создавать профессиональные видеоролики, а также осваивать анимацию и графику для видеопроектов на разных платформах.",
      "featureCard": {
        "text": "Adobe Premiere Pro и After Effects — профессиональные программы для видеомонтажа, создания графики и анимации, которые являются стандартом индустрии для работы с видеопроектами"
      },
      "courseCard": {
        "title": "Программа: Видеомантаж + Создание графики в Ae",
        "subtitle": "C нуля",
        "tagline": "В этом курсе вы узнаете всё о создании современной",
        "badge": "ПР"
      },
      "targetAudience": [
              {
                      "icon": "book",
                      "title": "Новичок в видео",
                      "description": "Хотите освоить видеопроизводство",
                      "color": "teal",
                      "benefits": [
                              "Premiere + After Effects",
                              "Комплексное обучение"
                      ]
              },
              {
                      "icon": "palette",
                      "title": "Контент-мейкер",
                      "description": "Хотите создавать профессионально",
                      "color": "purple",
                      "benefits": [
                              "Монтаж и эффекты",
                              "Анимированная графика"
                      ]
              },
              {
                      "icon": "briefcase",
                      "title": "Видеограф",
                      "description": "Хотите расширить услуги",
                      "color": "orange",
                      "benefits": [
                              "Полный цикл",
                              "Больше заказов"
                      ]
              },
              {
                      "icon": "zap",
                      "title": "Предприниматель",
                      "description": "Делаете видео для бизнеса",
                      "color": "emerald",
                      "benefits": [
                              "Свой контент",
                              "Экономия бюджета"
                      ]
              }
      ]
    },
    "careerSection": {
          "title": "Сколько зарабатывают видеоспециалисты?",
          "description": "Комплексные навыки монтажа и эффектов позволяют работать над полным циклом видеопроизводства",
          "vacancies": "3 200+",
          "growth": "+38%",
          "salaryLevels": [
                {
                      "title": "Начинающий",
                      "salary": "60 000 ₽",
                      "progress": "25%"
                },
                {
                      "title": "Видеоспециалист",
                      "salary": "130 000 ₽",
                      "progress": "55%"
                },
                {
                      "title": "Видеопродюсер",
                      "salary": "220 000+ ₽",
                      "progress": "100%"
                }
          ],
          "source": "* По данным hh.ru и Хабр Карьера, 2025"
    },
    "skillsSection": {
          "skills": [
                {
                      "name": "Premiere Pro монтаж",
                      "level": "Продвинутый",
                      "progress": "90%"
                },
                {
                      "name": "After Effects эффекты",
                      "level": "Уверенный",
                      "progress": "80%"
                },
                {
                      "name": "Цветокоррекция",
                      "level": "Уверенный",
                      "progress": "75%"
                },
                {
                      "name": "Моушн-графика",
                      "level": "Базовый",
                      "progress": "65%"
                }
          ],
          "opportunities": [
                {
                      "icon": "freelance",
                      "title": "Брать сложные проекты",
                      "description": "Полный цикл видеопроизводства"
                },
                {
                      "icon": "company",
                      "title": "Работать в продакшне",
                      "description": "На позицию видеоспециалиста"
                },
                {
                      "icon": "growth",
                      "title": "Развиваться дальше",
                      "description": "Освоить 3D и Cinema 4D"
                }
          ]
    }
  },
  {
    "id": 14,
    "slug": "web-designer-program",
    "skillspaceCourses": [
      { "courseId": "14500", "groupId": "23501" },
      { "courseId": "15574", "groupId": "25181" }
    ],
    "title": "Программа: Веб дизайнер с нуля. Веб дизайн + Figma анимации",
    "subtitle": "C нуля",
    "description": "В этом пакете из 2-х курсов, вы найдете все, для того чтобы стать настоящим асом в веб дизайне. Старт карьеры UX/Ui Дизайнера. Цена на пакет курсов ниже на 20%, чем если бы вы приобретали курсы отдельно.",
    "fullDescription": "Веб-дизайн в Figma — это курс, где вы изучите UX/UI, освоите работу с типографикой, цветами и сетками, а также научитесь создавать адаптивные макеты для веб-проектов. Анимация в Figma — это ключ к современному дизайну, в рамках курса вы научитесь создавать впечатляющие анимации, микровзаимодействия и сложные интерфейсы, которые сделают ваши проекты динамичными и привлекательными.",
    "image": "/images/courses/web-designer-program-paper-v2.webp",
    "promoVideo": "https://rutube.ru/play/embed/3f2e1ae645892492085f1f040cc89f6d",
    "price": 4290,
    "originalPrice": 8980,
    "discount": 52,
    "saleDiscount": 20,
    "category": "Пакеты курсов",
    "lessons": 182,
    "totalHours": 23.0,
    "duration": "3 месяца",
    "level": "С нуля",
    "students": 2500,
    "rating": 4.9,
    "features": [
      "Интерактивность, общение с преподавателем",
      "Практические задания после каждого урока",
      "Реальные проекты для портфолио",
      "Пожизненный доступ к материалам"
    ],
    "stats": [
      {
        "value": "50K+",
        "label": "Просмотров"
      },
      {
        "value": "100K+",
        "label": "Студентов"
      },
      {
        "value": "150K+",
        "label": "Практических заданий"
      }
    ],
    "topics": [
      "Изучите все инструменты Figma",
      "Изучите современные техники и приемы дизайна",
      "Научитесь азам работы в Photoshop",
      "Узнаете больше про профессию UX/UI дизайнера",
      "Узнаете что такое web design на практике",
      "Научитесь работать с изображениями в Figma",
      "Научитесь подбирать правильные цвета для ваших сайтов",
      "Научитесь подбирать правильные шрифты для ваших сайтов",
      "Узнаете как работать с контрастом на веб-страницах"
    ],
    "testimonials": [
      {
        "name": "Иван",
        "role": "Студент курса",
        "text": "Замечательный курс, уже третий, который прохожу у Дмитрия. Как всегда, очень доступное и понятное изложение, прекрасная логика и удобная подача материала со всеми нужными ссылками, сервисами, презентациями. Объем материла тщательно отфильтрован, ничего лишнего.",
        "rating": 5
      },
      {
        "name": "Мария",
        "role": "Студент курса",
        "text": "Замечательный курс, уже третий, который прохожу у Дмитрия. Как всегда, очень доступное и понятное изложение, прекрасная логика и удобная подача материала со всеми нужными ссылками, сервисами, презентациями. Объем материла тщательно отфильтрован, ничего лишнего.",
        "rating": 5
      }
    ],
    "aboutSection": {
      "headline": "UX/UI-дизайн, адаптивность, цвет, типографика, прототипы и анимации — всё это курсы по веб-дизайну и анимации в Figma",
      "highlightedText": "",
      "description": "Веб-дизайн в Figma — это курс, где вы изучите UX/UI, освоите работу с типографикой, цветами и сетками, а также научитесь создавать адаптивные макеты для веб-проектов. Анимация в Figma — это ключ к современному дизайну, в рамках курса вы научитесь создавать впечатляющие анимации, микровзаимодействия и сложные интерфейсы, которые сделают ваши проекты динамичными и привлекательными.",
      "featureCard": {
        "text": "Веб-дизайн и анимация в Figma — это создание современных UX/UI макетов, интерактивных и впечатляющих интерфейсов для веб-проектов"
      },
      "courseCard": {
        "title": "Программа: Веб дизайнер с нуля. Веб дизайн + Figma анимации",
        "subtitle": "C нуля",
        "tagline": "В этом пакете из 2-х курсов, вы найдете все, для т",
        "badge": "ПР"
      },
      "targetAudience": [
              {
                      "icon": "book",
                      "title": "Новичок в дизайне",
                      "description": "Хотите стать веб-дизайнером",
                      "color": "teal",
                      "benefits": [
                              "Figma + Теория",
                              "Полный курс профессии"
                      ]
              },
              {
                      "icon": "palette",
                      "title": "Графический дизайнер",
                      "description": "Хотите перейти в веб-дизайн",
                      "color": "purple",
                      "benefits": [
                              "UI/UX навыки",
                              "Работа с интерфейсами"
                      ]
              },
              {
                      "icon": "briefcase",
                      "title": "Фрилансер",
                      "description": "Хотите брать проекты под ключ",
                      "color": "orange",
                      "benefits": [
                              "От концепта до макета",
                              "Полный цикл"
                      ]
              },
              {
                      "icon": "zap",
                      "title": "Карьерист",
                      "description": "Хотите устроиться дизайнером",
                      "color": "emerald",
                      "benefits": [
                              "Востребованная профессия",
                              "Портфолио"
                      ]
              }
      ]
    },
    "careerSection": {
          "title": "Сколько зарабатывают веб-дизайнеры?",
          "description": "Веб-дизайнер — востребованная профессия на стыке творчества и технологий",
          "vacancies": "5 800+",
          "growth": "+32%",
          "salaryLevels": [
                {
                      "title": "Junior (0-1 год)",
                      "salary": "60 000 ₽",
                      "progress": "30%"
                },
                {
                      "title": "Middle (1-3 года)",
                      "salary": "120 000 ₽",
                      "progress": "60%"
                },
                {
                      "title": "Senior / Lead",
                      "salary": "200 000+ ₽",
                      "progress": "100%"
                }
          ],
          "source": "* По данным hh.ru и Хабр Карьера, 2025"
    },
    "skillsSection": {
          "skills": [
                {
                      "name": "UI/UX дизайн в Figma",
                      "level": "Продвинутый",
                      "progress": "90%"
                },
                {
                      "name": "Теория дизайна",
                      "level": "Уверенный",
                      "progress": "85%"
                },
                {
                      "name": "Прототипирование",
                      "level": "Уверенный",
                      "progress": "80%"
                },
                {
                      "name": "Работа с заказчиком",
                      "level": "Уверенный",
                      "progress": "75%"
                }
          ],
          "opportunities": [
                {
                      "icon": "freelance",
                      "title": "Брать проекты под ключ",
                      "description": "От концепта до готового макета"
                },
                {
                      "icon": "company",
                      "title": "Устроиться дизайнером",
                      "description": "В IT-компанию или digital-агентство"
                },
                {
                      "icon": "growth",
                      "title": "Развиваться дальше",
                      "description": "Освоить вёрстку или продуктовый дизайн"
                }
          ]
    }
  },
  {
    "id": 15,
    "slug": "html-htmlPro-program",
    "skillspaceCourses": [
      { "courseId": "15551", "groupId": "25151" },
      { "courseId": "15583", "groupId": "25193" }
    ],
    "title": "Программа: Верстка сайтов Pro Level",
    "subtitle": "C нуля",
    "description": "В этом пакете из 2-х курсов, вы найдете все о современной верстке сайтов.Быстрый старт в профессию веб разработчик! Цена на пакет курсов ниже на 20% чем если бы вы приобретали курсы отдельно",
    "fullDescription": "HTML — это основа всех веб-страниц. В этом курсе вы изучите структуру HTML-документов, основы верстки и научитесь создавать семантически правильные и доступные сайты. HTML Pro — это курс для тех, кто хочет углубить знания в верстке, изучить семантику, современные стандарты HTML5 и научиться создавать сложные и адаптивные структуры веб-страниц",
    "image": "/images/courses/html-htmlPro-program-paper-v2.webp",
    "promoVideo": "https://rutube.ru/play/embed/069086ef7a5f33205b3cdb9ed432c361",
    "price": 4690,
    "originalPrice": 9990,
    "discount": 53,
    "saleDiscount": 20,
    "category": "Пакеты курсов",
    "lessons": 263,
    "totalHours": 38.5,
    "duration": "4 месяца",
    "level": "С нуля",
    "students": 2500,
    "rating": 4.9,
    "features": [
      "Интерактивность, общение с преподавателем",
      "Практические задания после каждого урока",
      "Реальные проекты для портфолио",
      "Пожизненный доступ к материалам"
    ],
    "stats": [
      {
        "value": "50K+",
        "label": "Просмотров"
      },
      {
        "value": "100K+",
        "label": "Студентов"
      },
      {
        "value": "150K+",
        "label": "Практических заданий"
      }
    ],
    "topics": [
      "Вы узнаете, как создавать сайты на языках HTML и CSS",
      "Научитесь размещать свой сайт в сети интернет",
      "Получите необходимые знания для использования библиотеки Bootstrap",
      "Научитесь работать с препроцессором SASS/SCSS",
      "Изучите методологию БЭМ",
      "Научитесь создавать адаптивные сайты, которые будут выглядеть отлично на любом устройстве",
      "Научитесь создавать дизайн сайтов",
      "Изучите базу программы Figma",
      "Научитесь работать в программе VS Code"
    ],
    "testimonials": [
      {
        "name": "Иван",
        "role": "Студент курса",
        "text": "Замечательный курс, уже третий, который прохожу у Дмитрия. Как всегда, очень доступное и понятное изложение, прекрасная логика и удобная подача материала со всеми нужными ссылками, сервисами, презентациями. Объем материла тщательно отфильтрован, ничего лишнего.",
        "rating": 5
      },
      {
        "name": "Мария",
        "role": "Студент курса",
        "text": "Замечательный курс, уже третий, который прохожу у Дмитрия. Как всегда, очень доступное и понятное изложение, прекрасная логика и удобная подача материала со всеми нужными ссылками, сервисами, презентациями. Объем материла тщательно отфильтрован, ничего лишнего.",
        "rating": 5
      }
    ],
    "aboutSection": {
      "headline": "Основы HTML, структура веб-страниц, вёрстка и семантика. Все это Курс по HTML. Углубленное изучение, современные стандарты HTML5 и семантика — все это Курс HTML Pro",
      "highlightedText": "",
      "description": "HTML — это основа всех веб-страниц. В этом курсе вы изучите структуру HTML-документов, основы верстки и научитесь создавать семантически правильные и доступные сайты. HTML Pro — это курс для тех, кто хочет углубить знания в верстке, изучить семантику, современные стандарты HTML5 и научиться создавать сложные и адаптивные структуры веб-страниц",
      "featureCard": {
        "text": "HTML — основа всех веб-страниц, а HTML Pro — это семантическая верстка и современные стандарты HTML5"
      },
      "courseCard": {
        "title": "Программа: Верстка сайтов Pro Level",
        "subtitle": "C нуля",
        "tagline": "В этом пакете из 2-х курсов, вы найдете все о совр",
        "badge": "ПР"
      },
      "targetAudience": [
              {
                      "icon": "book",
                      "title": "Новичок в вёрстке",
                      "description": "Хотите стать верстальщиком",
                      "color": "teal",
                      "benefits": [
                              "От основ до продвинутого",
                              "Полный путь"
                      ]
              },
              {
                      "icon": "palette",
                      "title": "Дизайнер",
                      "description": "Хотите сами верстать макеты",
                      "color": "purple",
                      "benefits": [
                              "Дизайн → Код",
                              "Полный контроль"
                      ]
              },
              {
                      "icon": "briefcase",
                      "title": "Фрилансер",
                      "description": "Хотите брать проекты на вёрстку",
                      "color": "orange",
                      "benefits": [
                              "Сложные проекты",
                              "Высокий чек"
                      ]
              },
              {
                      "icon": "zap",
                      "title": "Карьерист",
                      "description": "Хотите стать фронтендером",
                      "color": "emerald",
                      "benefits": [
                              "Первый шаг в IT",
                              "База для JavaScript"
                      ]
              }
      ]
    },
    "careerSection": {
          "title": "Сколько зарабатывают верстальщики?",
          "description": "Профессиональная вёрстка — первый шаг к карьере frontend-разработчика",
          "vacancies": "3 800+",
          "growth": "+20%",
          "salaryLevels": [
                {
                      "title": "Junior верстальщик",
                      "salary": "50 000 ₽",
                      "progress": "30%"
                },
                {
                      "title": "Middle верстальщик",
                      "salary": "90 000 ₽",
                      "progress": "55%"
                },
                {
                      "title": "Senior / Frontend",
                      "salary": "160 000+ ₽",
                      "progress": "100%"
                }
          ],
          "source": "* По данным hh.ru и Хабр Карьера, 2025"
    },
    "skillsSection": {
          "skills": [
                {
                      "name": "HTML5 & CSS3",
                      "level": "Продвинутый",
                      "progress": "95%"
                },
                {
                      "name": "SASS/SCSS",
                      "level": "Продвинутый",
                      "progress": "90%"
                },
                {
                      "name": "CSS Grid & Flexbox",
                      "level": "Уверенный",
                      "progress": "85%"
                },
                {
                      "name": "Адаптивная вёрстка",
                      "level": "Продвинутый",
                      "progress": "90%"
                }
          ],
          "opportunities": [
                {
                      "icon": "freelance",
                      "title": "Брать любые заказы",
                      "description": "Верстать проекты любой сложности"
                },
                {
                      "icon": "company",
                      "title": "Устроиться верстальщиком",
                      "description": "На позицию Middle/Senior"
                },
                {
                      "icon": "growth",
                      "title": "Развиваться дальше",
                      "description": "Перейти к JavaScript и React"
                }
          ]
    }
  },
  {
    "id": 16,
    "slug": "js-html-program",
    "skillspaceCourses": [
      { "courseId": "14497", "groupId": "23496" },
      { "courseId": "15551", "groupId": "25151" }
    ],
    "title": "Программа: Верстка + Js",
    "subtitle": "C нуля",
    "description": "В этом пакете из 2-х курсов, вы найдете все для старка карьеры в IT в качестве Front-end web разработчика. Быстрый старт в IT! Цена на пакет курсов ниже на 20% чем если бы вы приобретали курсы отдельно",
    "fullDescription": "HTML — это фундамент создания веб-страниц, обеспечивающий структуру и основу для верстки. JavaScript — мощный инструмент для добавления интерактивности и функциональности в веб-приложениях, играх и мобильных приложениях.",
    "image": "/images/courses/js-html-program-paper-v2.webp",
    "promoVideo": "https://rutube.ru/play/embed/ae4b8e3f7636e56216b5a6508d78103c",
    "price": 5290,
    "originalPrice": 9990,
    "discount": 47,
    "saleDiscount": 20,
    "category": "Пакеты курсов",
    "lessons": 324,
    "totalHours": 49.5,
    "duration": "6 месяцев",
    "level": "С нуля",
    "students": 2500,
    "rating": 4.9,
    "features": [
      "Интерактивность, общение с преподавателем",
      "Практические задания после каждого урока",
      "Реальные проекты для портфолио",
      "Пожизненный доступ к материалам"
    ],
    "stats": [
      {
        "value": "50K+",
        "label": "Просмотров"
      },
      {
        "value": "100K+",
        "label": "Студентов"
      },
      {
        "value": "150K+",
        "label": "Практических заданий"
      }
    ],
    "topics": [
      "Вы узнаете, как создавать сайты на языках HTML и CSS",
      "Научитесь размещать свой сайт в сети интернет",
      "Получите необходимые знания для использования библиотеки Bootstrap",
      "Научитесь работать с препроцессором SASS/SCSS",
      "Изучите методологию БЭМ",
      "Научитесь создавать адаптивные сайты, которые будут выглядеть отлично на любом устройстве",
      "Научитесь создавать дизайн сайтов",
      "Изучите базу программы Figma",
      "Научитесь работать в программе VS Code"
    ],
    "testimonials": [
      {
        "name": "Иван",
        "role": "Студент курса",
        "text": "Замечательный курс, уже третий, который прохожу у Дмитрия. Как всегда, очень доступное и понятное изложение, прекрасная логика и удобная подача материала со всеми нужными ссылками, сервисами, презентациями. Объем материла тщательно отфильтрован, ничего лишнего.",
        "rating": 5
      },
      {
        "name": "Мария",
        "role": "Студент курса",
        "text": "Замечательный курс, уже третий, который прохожу у Дмитрия. Как всегда, очень доступное и понятное изложение, прекрасная логика и удобная подача материала со всеми нужными ссылками, сервисами, презентациями. Объем материла тщательно отфильтрован, ничего лишнего.",
        "rating": 5
      }
    ],
    "aboutSection": {
      "headline": "HTML — основа структуры веб-страниц, JavaScript — интерактивность и работа с сервером",
      "highlightedText": "",
      "description": "HTML — это фундамент создания веб-страниц, обеспечивающий структуру и основу для верстки. JavaScript — мощный инструмент для добавления интерактивности и функциональности в веб-приложениях, играх и мобильных приложениях.",
      "featureCard": {
        "text": "HTML — основа веб-структуры, JavaScript — динамика и интерактивность"
      },
      "courseCard": {
        "title": "Программа: Верстка + Js",
        "subtitle": "C нуля",
        "tagline": "В этом пакете из 2-х курсов, вы найдете все для ст",
        "badge": "ПР"
      },
      "targetAudience": [
              {
                      "icon": "book",
                      "title": "Новичок в разработке",
                      "description": "Хотите стать фронтенд-разработчиком",
                      "color": "teal",
                      "benefits": [
                              "HTML + CSS + JS",
                              "Полный путь"
                      ]
              },
              {
                      "icon": "palette",
                      "title": "Верстальщик",
                      "description": "Хотите освоить JavaScript",
                      "color": "purple",
                      "benefits": [
                              "Следующий уровень",
                              "Интерактивность"
                      ]
              },
              {
                      "icon": "briefcase",
                      "title": "Фрилансер",
                      "description": "Хотите брать сложные проекты",
                      "color": "orange",
                      "benefits": [
                              "Полный цикл",
                              "Выше чек"
                      ]
              },
              {
                      "icon": "zap",
                      "title": "Карьерист",
                      "description": "Хотите в IT с хорошей зарплатой",
                      "color": "emerald",
                      "benefits": [
                              "Востребованная профессия",
                              "Рост дохода"
                      ]
              }
      ]
    },
    "careerSection": {
          "title": "Сколько зарабатывают frontend-разработчики?",
          "description": "Frontend-разработка — одно из самых востребованных и высокооплачиваемых направлений в IT",
          "vacancies": "9 500+",
          "growth": "+27%",
          "salaryLevels": [
                {
                      "title": "Junior (0-1 год)",
                      "salary": "70 000 ₽",
                      "progress": "25%"
                },
                {
                      "title": "Middle (1-3 года)",
                      "salary": "160 000 ₽",
                      "progress": "55%"
                },
                {
                      "title": "Senior (3+ лет)",
                      "salary": "280 000+ ₽",
                      "progress": "100%"
                }
          ],
          "source": "* По данным hh.ru и Хабр Карьера, 2025"
    },
    "skillsSection": {
          "skills": [
                {
                      "name": "HTML & CSS",
                      "level": "Продвинутый",
                      "progress": "90%"
                },
                {
                      "name": "JavaScript ES6+",
                      "level": "Продвинутый",
                      "progress": "85%"
                },
                {
                      "name": "Работа с API",
                      "level": "Уверенный",
                      "progress": "80%"
                },
                {
                      "name": "Адаптивная вёрстка",
                      "level": "Уверенный",
                      "progress": "85%"
                }
          ],
          "opportunities": [
                {
                      "icon": "freelance",
                      "title": "Брать frontend-проекты",
                      "description": "Создавать интерактивные веб-сайты"
                },
                {
                      "icon": "company",
                      "title": "Устроиться frontend-ом",
                      "description": "На позицию Junior/Middle разработчика"
                },
                {
                      "icon": "growth",
                      "title": "Развиваться дальше",
                      "description": "Освоить React или Vue.js"
                }
          ]
    }
  },
  {
    "id": 17,
    "slug": "ps-ai-program",
    "skillspaceCourses": [
      { "courseId": "15520", "groupId": "25113" },
      { "courseId": "15527", "groupId": "25123" }
    ],
    "title": "Программа: Инструменты веб дизайнера Ps + Ai",
    "subtitle": "C нуля",
    "description": "В этом пакете из 2-х курсов, вы найдете все необходимые инструменты графического дизайнера! Полное погружение в 2 программы: Adobe Illustrator и Adobe Photoshop. Цена на пакет курсов ниже на 20% чем если бы вы приобретали курсы отдельно",
    "fullDescription": "Adobe Photoshop — программа для обработки фотографий и создания графики. В курсе вы изучите ретушь, цветокоррекцию и работу со слоями. Adobe Illustrator — инструмент для создания векторной графики, логотипов и иллюстраций. В курсе вы освоите работу с векторными инструментами",
    "image": "/images/courses/ps-ai-program-paper-v2.webp",
    "price": 3690,
    "originalPrice": 7990,
    "discount": 54,
    "saleDiscount": 20,
    "category": "Пакеты курсов",
    "lessons": 128,
    "totalHours": 16.5,
    "duration": "2 месяца",
    "level": "С нуля",
    "students": 2500,
    "rating": 4.9,
    "promoVideo": "https://rutube.ru/play/embed/d69b6cfdabd2ad0e7de7e4aab57497f6",
    "features": [
      "Интерактивность, общение с преподавателем",
      "Практические задания после каждого урока",
      "Реальные проекты для портфолио",
      "Пожизненный доступ к материалам"
    ],
    "stats": [
      {
        "value": "50K+",
        "label": "Просмотров"
      },
      {
        "value": "100K+",
        "label": "Студентов"
      },
      {
        "value": "150K+",
        "label": "Практических заданий"
      }
    ],
    "topics": [
      "Научитесь удалять людей и предметы из изображений",
      "Научитесь вырезать людей и любые предметы из ваших изображений и переносить их на другие фото",
      "Научитесь делать идеальную фигуру у любого человека на фотографии",
      "Вы научитесь ретушировать лицо, удалять прыщи и веснушки и любые дефекты кожи",
      "Научитесь создавать популярные визуальные стили и эффекты",
      "Научитесь создавать рекламные плакаты",
      "Научитесь изменять цвет вещей на изображениях",
      "Научитесь создавать реалистичные тени",
      "Узнаете, как исправлять цвета на фотографиях"
    ],
    "testimonials": [
      {
        "name": "Иван",
        "role": "Студент курса",
        "text": "Замечательный курс, уже третий, который прохожу у Дмитрия. Как всегда, очень доступное и понятное изложение, прекрасная логика и удобная подача материала со всеми нужными ссылками, сервисами, презентациями. Объем материла тщательно отфильтрован, ничего лишнего.",
        "rating": 5
      },
      {
        "name": "Мария",
        "role": "Студент курса",
        "text": "Замечательный курс, уже третий, который прохожу у Дмитрия. Как всегда, очень доступное и понятное изложение, прекрасная логика и удобная подача материала со всеми нужными ссылками, сервисами, презентациями. Объем материла тщательно отфильтрован, ничего лишнего.",
        "rating": 5
      }
    ],
    "aboutSection": {
      "headline": "Редактирование фото, ретушь и графика — всё это курс по Photoshop. Векторная графика, иллюстрации и логотипы — всё это курс по Illustrator.",
      "highlightedText": "",
      "description": "Adobe Photoshop — программа для обработки фотографий и создания графики. В курсе вы изучите ретушь, цветокоррекцию и работу со слоями. Adobe Illustrator — инструмент для создания векторной графики, логотипов и иллюстраций. В курсе вы освоите работу с векторными инструментами",
      "featureCard": {
        "text": "Photoshop — лидер в обработке фото и создании графики. Illustrator — мощный инструмент для векторной графики и логотипов."
      },
      "courseCard": {
        "title": "Программа: Инструменты веб дизайнера Ps + Ai",
        "subtitle": "C нуля",
        "tagline": "В этом пакете из 2-х курсов, вы найдете все необхо",
        "badge": "ПР"
      },
      "targetAudience": [
              {
                      "icon": "book",
                      "title": "Новичок в графике",
                      "description": "Хотите освоить графический дизайн",
                      "color": "teal",
                      "benefits": [
                              "Photoshop + Illustrator",
                              "Растр и вектор"
                      ]
              },
              {
                      "icon": "palette",
                      "title": "Дизайнер",
                      "description": "Хотите полный набор инструментов",
                      "color": "purple",
                      "benefits": [
                              "Все виды графики",
                              "Универсальность"
                      ]
              },
              {
                      "icon": "briefcase",
                      "title": "Фрилансер",
                      "description": "Хотите брать любые заказы",
                      "color": "orange",
                      "benefits": [
                              "Широкий спектр услуг",
                              "Больше клиентов"
                      ]
              },
              {
                      "icon": "zap",
                      "title": "SMM-специалист",
                      "description": "Создаёте контент для соцсетей",
                      "color": "emerald",
                      "benefits": [
                              "Фото + графика",
                              "Свой контент"
                      ]
              }
      ]
    },
    "careerSection": {
          "title": "Сколько зарабатывают графические дизайнеры?",
          "description": "Photoshop + Illustrator — универсальный набор для работы с любым визуальным контентом",
          "vacancies": "6 200+",
          "growth": "+18%",
          "salaryLevels": [
                {
                      "title": "Начинающий (0-1 год)",
                      "salary": "50 000 ₽",
                      "progress": "30%"
                },
                {
                      "title": "Средний (1-3 года)",
                      "salary": "95 000 ₽",
                      "progress": "55%"
                },
                {
                      "title": "Профессионал",
                      "salary": "170 000+ ₽",
                      "progress": "100%"
                }
          ],
          "source": "* По данным hh.ru и Хабр Карьера, 2025"
    },
    "skillsSection": {
          "skills": [
                {
                      "name": "Adobe Photoshop",
                      "level": "Продвинутый",
                      "progress": "90%"
                },
                {
                      "name": "Adobe Illustrator",
                      "level": "Продвинутый",
                      "progress": "85%"
                },
                {
                      "name": "Ретушь и обработка",
                      "level": "Уверенный",
                      "progress": "80%"
                },
                {
                      "name": "Векторная графика",
                      "level": "Уверенный",
                      "progress": "80%"
                }
          ],
          "opportunities": [
                {
                      "icon": "freelance",
                      "title": "Брать любые заказы",
                      "description": "Растровая и векторная графика"
                },
                {
                      "icon": "company",
                      "title": "Работать дизайнером",
                      "description": "Универсальный специалист для агентства"
                },
                {
                      "icon": "growth",
                      "title": "Развиваться дальше",
                      "description": "Освоить UI/UX или веб-дизайн"
                }
          ]
    }
  },
  {
    "id": 18,
    "slug": "react",
    "skillspaceCourses": [{ "courseId": "65374", "groupId": "116486" }],
    "title": "Курс React JS",
    "subtitle": "Со знанием JS и HTML",
    "description": "Ультимативный курс по React JS + Полное изучение библиотек экосистемы React ( Redux / Router ) Бонус - полный курс по Tailwind CSS",
    "fullDescription": "React JS — это популярная библиотека для разработки веб-приложений. В этом курсе вы изучите основы работы с компонентами, хуками, состоянием и маршрутизацией для создания современных интерактивных приложений.",
    "image": "/images/courses/react-paper-v2.webp",
    "promoVideo": "https://rutube.ru/play/embed/8c94cdc5d2056bd3f3d507e6e1ab39ca",
    "price": 3390,
    "originalPrice": 5990,
    "discount": 43,
    "saleDiscount": 25,
    "category": "Веб разработка",
    "lessons": 214,
    "totalHours": 31.0,
    "duration": "4 месяца",
    "level": "Средний",
    "students": 2500,
    "rating": 4.9,
    "reviewPlatforms": {
      "udemy": { "url": "https://www.udemy.com/course/react-js-redux-router-tailwind-css/#reviews", "rating": 4.8, "count": 400 },
      "stepik": { "url": "https://stepik.org/course/221235/reviews", "rating": 5, "count": 150 }
    },
    "features": [
      "Интерактивность, общение с преподавателем",
      "Практические задания после каждого урока",
      "Реальные проекты для портфолио",
      "Пожизненный доступ к материалам"
    ],
    "stats": [
      {
        "value": "50K+",
        "label": "Просмотров"
      },
      {
        "value": "100K+",
        "label": "Студентов"
      },
      {
        "value": "150K+",
        "label": "Практических заданий"
      }
    ],
    "topics": [
      "Изучите все аспекты библиотеки React JS",
      "Изучите библиотеку для управления маршрутами — React Router",
      "Изучите библиотеку для управления состояниями — React Redux",
      "Освойте современный синтаксис Redux Toolkit",
      "Освойте современный синтаксис React Router 6.4+",
      "Узнайте о последних обновлениях библиотеки React и современных методах разработки",
      "Научитесь создавать веб-приложения любой сложности",
      "Изучите фреймворк для стилизации веб-приложений — Tailwind CSS",
      "Создайте несколько приложений, включая планировщик задач и интернет-магазин"
    ],
    "testimonials": [
      {
        "name": "Илья",
        "role": "Студент курса",
        "text": "Дмитрий всегда очень хорошо объясняет, хоть уже и знаю реакт, уверен найду в курсе для себя много полезного, за pdf Workbook отдельное спасибо, часто приходится освежать знания по определенной теме, уверен теперь делать это будеть намного удобнее и приятнее!",
        "rating": 5
      }
    ],
    "aboutSection": {
      "headline": "Компоненты, хуки, состояние, маршрутизация, а также современная разработка. Все это Курс по React JS",
      "highlightedText": "",
      "description": "React JS — это популярная библиотека для разработки веб-приложений. В этом курсе вы изучите основы работы с компонентами, хуками, состоянием и маршрутизацией для создания современных интерактивных приложений.",
      "featureCard": {
        "text": "React JS — популярная библиотека для создания современных интерактивных веб-приложений."
      },
      "courseCard": {
        "title": "React JS",
        "subtitle": "Со знанием JS и HTML",
        "tagline": "Ультимативный курс по React JS + Полное изучение б",
        "badge": "КУ"
      },
      "targetAudience": [
              {
                      "icon": "book",
                      "title": "JS-разработчик",
                      "description": "Хотите освоить React",
                      "color": "teal",
                      "benefits": [
                              "Современный фреймворк",
                              "Компонентный подход"
                      ]
              },
              {
                      "icon": "palette",
                      "title": "Верстальщик",
                      "description": "Хотите перейти во фронтенд",
                      "color": "purple",
                      "benefits": [
                              "Следующий уровень",
                              "Больше возможностей"
                      ]
              },
              {
                      "icon": "briefcase",
                      "title": "Фрилансер",
                      "description": "Хотите брать проекты на React",
                      "color": "orange",
                      "benefits": [
                              "Востребованный стек",
                              "Высокие чеки"
                      ]
              },
              {
                      "icon": "zap",
                      "title": "Карьерист",
                      "description": "Хотите работать в IT-компании",
                      "color": "emerald",
                      "benefits": [
                              "Топовые вакансии",
                              "Высокие зарплаты"
                      ]
              }
      ]
    },
    "careerSection": {
          "title": "Сколько зарабатывают React-разработчики?",
          "description": "React — самый популярный фреймворк для создания интерфейсов. Разработчики нужны в каждом IT-проекте",
          "vacancies": "7 800+",
          "growth": "+35%",
          "salaryLevels": [
                {
                      "title": "Junior (0-1 год)",
                      "salary": "80 000 ₽",
                      "progress": "25%"
                },
                {
                      "title": "Middle (1-3 года)",
                      "salary": "190 000 ₽",
                      "progress": "55%"
                },
                {
                      "title": "Senior (3+ лет)",
                      "salary": "350 000+ ₽",
                      "progress": "100%"
                }
          ],
          "source": "* По данным hh.ru и Хабр Карьера, 2025"
    },
    "skillsSection": {
          "skills": [
                {
                      "name": "React компоненты",
                      "level": "Продвинутый",
                      "progress": "90%"
                },
                {
                      "name": "React Hooks",
                      "level": "Продвинутый",
                      "progress": "85%"
                },
                {
                      "name": "State Management",
                      "level": "Уверенный",
                      "progress": "80%"
                },
                {
                      "name": "REST API интеграция",
                      "level": "Уверенный",
                      "progress": "80%"
                }
          ],
          "opportunities": [
                {
                      "icon": "freelance",
                      "title": "Брать React-проекты",
                      "description": "Создавать SPA и веб-приложения"
                },
                {
                      "icon": "company",
                      "title": "Устроиться в IT",
                      "description": "На позицию Middle React-разработчика"
                },
                {
                      "icon": "growth",
                      "title": "Развиваться дальше",
                      "description": "Освоить Next.js или TypeScript"
                }
          ]
    },
    "curriculum": {
      "headline": "Программа курса",
      "description": "Ультимативный курс по React JS + Полное изучение библиотек экосистемы React ( Redux / Router ) Бонус - полный курс по Tailwind CSS",
      "modules": [
        {
          "id": 1,
          "number": "01",
          "title": "Подготовка",
          "info": "5 лекций • 33м",
          "lessons": [
            {
              "lesson": "Добро пожаловать на курс",
              "time": "00:31"
            },
            {
              "lesson": "Скачиваем материалы к курсу",
              "time": "00:16"
            },
            {
              "lesson": "Подготовка и проверка ПО",
              "time": "07:28"
            },
            {
              "lesson": "Настройка VS Code для курса",
              "time": "11:39"
            },
            {
              "lesson": "Как проходить курс",
              "time": "12:42"
            }
          ]
        },
        {
          "id": 2,
          "number": "02",
          "title": "Вспоминаем основное из JS (Опционально)",
          "info": "14 лекций • 1ч 51м",
          "lessons": [
            {
              "lesson": "Как работают функции. Типы функций в JS",
              "time": "13:19"
            },
            {
              "lesson": "Вспоминаем метод find()",
              "time": "04:25"
            },
            {
              "lesson": "Деструктуризация массивов и объектов",
              "time": "09:06"
            },
            {
              "lesson": "Операторы Rest & Spread",
              "time": "14:57"
            },
            {
              "lesson": "`${Template Literals}` - шаблонные строки",
              "time": "04:01"
            }
          ]
        },
        {
          "id": 3,
          "number": "03",
          "title": "Мини-курс по ChatGPT для обучения и работы (Опционально)",
          "info": "12 лекций • 1ч 11м",
          "lessons": [
            {
              "lesson": "Обзор нейросетей",
              "time": "11:24"
            },
            {
              "lesson": "Лучшие модели искусственного интеллекта на сегодня",
              "time": "04:56"
            },
            {
              "lesson": "Как оплатить подписку на Chat GPT",
              "time": "04:38"
            },
            {
              "lesson": "Обзор тарифов Chat GPT",
              "time": "05:48"
            },
            {
              "lesson": "Программа Chat GPT на разные операционные системы",
              "time": "02:56"
            }
          ]
        },
        {
          "id": 4,
          "number": "04",
          "title": "Введение в React. (Props / Components / JSX)",
          "info": "18 лекций • 2ч 36м",
          "lessons": [
            {
              "lesson": "Как создать новый проект React",
              "time": "13:56"
            },
            {
              "lesson": "Hello React! Структура приложения React",
              "time": "09:15"
            },
            {
              "lesson": "Знакомство с компонентами",
              "time": "10:17"
            },
            {
              "lesson": "Как создается компонент ",
              "time": "04:12"
            },
            {
              "lesson": "Как работает JSX",
              "time": "09:27"
            }
          ]
        },
        {
          "id": 5,
          "number": "05",
          "title": "Углубление в основы React (useState & Events)",
          "info": "10 лекций • 1ч 24м",
          "lessons": [
            {
              "lesson": "Как работают события в React",
              "time": "08:33"
            },
            {
              "lesson": "Первый Хук - useState()",
              "time": "05:30"
            },
            {
              "lesson": "Обновление состояния на основе прошлого состояния",
              "time": "09:06"
            },
            {
              "lesson": "Разница state и переменных",
              "time": "02:49"
            },
            {
              "lesson": "Что значат декларативный и императивный подход",
              "time": "02:44"
            }
          ]
        },
        {
          "id": 6,
          "number": "06",
          "title": "#01-PROJECT - TaskList - (Level 3)",
          "info": "7 лекций • 1ч 44м",
          "lessons": [
            {
              "lesson": "Обзор проекта",
              "time": "04:17"
            },
            {
              "lesson": "Создаем структуру приложения",
              "time": "21:03"
            },
            {
              "lesson": "Условный рендеринг для открытия и закрытия окон",
              "time": "11:07"
            },
            {
              "lesson": "Создаем массив с задачами",
              "time": "18:37"
            },
            {
              "lesson": "Делим массив задач на активные и выполненные",
              "time": "11:03"
            }
          ]
        },
        {
          "id": 7,
          "number": "07",
          "title": "Важные возможности Props",
          "info": "10 лекций • 1ч 56м",
          "lessons": [
            {
              "lesson": "Структура файлов React приложения",
              "time": "16:44"
            },
            {
              "lesson": "Как создать универсальный компонент",
              "time": "12:53"
            },
            {
              "lesson": "Что такое PropTypes и как их использовать",
              "time": "08:29"
            },
            {
              "lesson": "Как работает {children} prop",
              "time": "07:16"
            },
            {
              "lesson": "Что такое проброс Props (Props drilling)",
              "time": "06:50"
            }
          ]
        },
        {
          "id": 8,
          "number": "08",
          "title": "UseEffect хук",
          "info": "17 лекций • 2ч 35м",
          "lessons": [
            {
              "lesson": "Подключаемся к Weather API",
              "time": "04:49"
            },
            {
              "lesson": "Используем useState в логике рендера функции",
              "time": "08:46"
            },
            {
              "lesson": "Знакомство с useEffect() хуком",
              "time": "12:21"
            },
            {
              "lesson": "Подробнее про useEffect()",
              "time": "09:41"
            },
            {
              "lesson": "Обработка ошибок часть 1",
              "time": "13:08"
            }
          ]
        },
        {
          "id": 9,
          "number": "09",
          "title": "#02-PROJECT-Калькулятор обмена валют",
          "info": "4 лекции • 28м",
          "lessons": [
            {
              "lesson": "Обзор проекта",
              "time": "04:49"
            },
            {
              "lesson": "Создаем калькулятор валют часть 1",
              "time": "09:46"
            },
            {
              "lesson": "Создаем калькулятор валют часть 2",
              "time": "05:58"
            },
            {
              "lesson": "Создаем калькулятор валют часть 3",
              "time": "07:46"
            }
          ]
        },
        {
          "id": 10,
          "number": "10",
          "title": "Необходимая теория работы React",
          "info": "13 лекций • 1ч 19м",
          "lessons": [
            {
              "lesson": "Обзор секции",
              "time": "02:10"
            },
            {
              "lesson": "Классовые VS Функциональные компоненты",
              "time": "05:13"
            },
            {
              "lesson": "Компоненты, копии компонентов, элементы",
              "time": "05:47"
            },
            {
              "lesson": "Что такое ",
              "time": "06:17"
            },
            {
              "lesson": "Что такое виртуальный DOM",
              "time": "05:17"
            }
          ]
        },
        {
          "id": 11,
          "number": "11",
          "title": "useRef хук и создание своего хука",
          "info": "4 лекции • 36м",
          "lessons": [
            {
              "lesson": "Переменные vs useState vs useRef",
              "time": "08:45"
            },
            {
              "lesson": "Используем useRef для доступа к элементам",
              "time": "08:53"
            },
            {
              "lesson": "Итог: useRef",
              "time": "03:07"
            },
            {
              "lesson": "Как создать свой собственный хук",
              "time": "15:11"
            },
            {
              "lesson": "Тест по блоку useRef хук и создание своего хука - (Level 2)",
              "time": "5 questions"
            }
          ]
        },
        {
          "id": 12,
          "number": "12",
          "title": "React Router 6.4+ (Без подгрузки данных)",
          "info": "20 лекций • 2ч 53м",
          "lessons": [
            {
              "lesson": "Настраиваем проект",
              "time": "04:01"
            },
            {
              "lesson": "Создаем страницы с помощью React Router",
              "time": "12:37"
            },
            {
              "lesson": "Как создать ссылки в React Router с помощью <Link/>",
              "time": "05:12"
            },
            {
              "lesson": "Как создать навигационное меню с помощью <NavLink/>",
              "time": "03:34"
            },
            {
              "lesson": "Разница между компонентами и страницами",
              "time": "05:50"
            }
          ]
        },
        {
          "id": 13,
          "number": "13",
          "title": "Tailwind course & CSS Modules (Опциональный блок)",
          "info": "24 лекции • 2ч 32м",
          "lessons": [
            {
              "lesson": "Обзор блока курса",
              "time": "01:18"
            },
            {
              "lesson": "Как работают CSS модули",
              "time": "09:45"
            },
            {
              "lesson": "Настраиваем Tailwind",
              "time": "12:35"
            },
            {
              "lesson": "Работа с цветами в Tailwind",
              "time": "04:33"
            },
            {
              "lesson": "Как создавать собственные палитры цветов",
              "time": "03:55"
            }
          ]
        },
        {
          "id": 14,
          "number": "14",
          "title": "React Router 6.4+ (С подгрузкой данных)",
          "info": "8 лекций • 1ч 14м",
          "lessons": [
            {
              "lesson": "Как происходила работа с API в React Router до версии 6.4.",
              "time": "19:10"
            },
            {
              "lesson": "Современный способ загрузки данных параметром loader",
              "time": "07:24"
            },
            {
              "lesson": "Современный способ обработки ошибок React Router 6.4+",
              "time": "05:32"
            },
            {
              "lesson": "Хук useNavigation для получения данных компонентом",
              "time": "10:43"
            },
            {
              "lesson": "Отправка данных параметром маршрута action",
              "time": "07:42"
            }
          ]
        },
        {
          "id": 15,
          "number": "15",
          "title": "Управление state через Context API",
          "info": "6 лекций • 54м",
          "lessons": [
            {
              "lesson": "Подводим итоги всего курса",
              "time": "06:14"
            },
            {
              "lesson": "Как работает Context API",
              "time": "09:51"
            },
            {
              "lesson": "#11-PRACTICE-Context API на проекте Task List (Level-2)",
              "time": "09:37"
            },
            {
              "lesson": "Context API + Children prop",
              "time": "18:33"
            },
            {
              "lesson": "Небольшая ошибка которую вы могли допустить",
              "time": "04:39"
            }
          ]
        },
        {
          "id": 16,
          "number": "16",
          "title": "Продвинутое управление состоянием - useReducer hook",
          "info": "13 лекций • 1ч 45м",
          "lessons": [
            {
              "lesson": "Как работает оператор switch",
              "time": "06:40"
            },
            {
              "lesson": "Варианты использования useState",
              "time": "05:16"
            },
            {
              "lesson": "Знакомство с useReducer Hook",
              "time": "09:46"
            },
            {
              "lesson": "Работа useReducer шаг за шагом",
              "time": "05:25"
            },
            {
              "lesson": "Как работает функция dispatch",
              "time": "05:29"
            }
          ]
        },
        {
          "id": 17,
          "number": "17",
          "title": "Библиотека Redux With Thunks",
          "info": "9 лекций • 1ч 18м",
          "lessons": [
            {
              "lesson": "Обзор проекта",
              "time": "08:45"
            },
            {
              "lesson": "Создаем initialState и функцию reducer",
              "time": "08:54"
            },
            {
              "lesson": "Как работает функция createStore и компонент Provider",
              "time": "05:51"
            },
            {
              "lesson": "Как работает функция dispatch",
              "time": "07:02"
            },
            {
              "lesson": "Получения state с помощью useSelector hook",
              "time": "09:19"
            }
          ]
        },
        {
          "id": 18,
          "number": "18",
          "title": "RTK (Redux ToolKit) Современный Redux",
          "info": "10 лекций • 1ч 23м",
          "lessons": [
            {
              "lesson": "Устанавливаем RTK в проект",
              "time": "03:03"
            },
            {
              "lesson": "Создаем файл store",
              "time": "05:03"
            },
            {
              "lesson": "Создаем ",
              "time": "11:36"
            },
            {
              "lesson": "Используем ",
              "time": "10:29"
            },
            {
              "lesson": "#13-Practice-Добавьте функционал-(Level-2)",
              "time": "08:27"
            }
          ]
        },
        {
          "id": 19,
          "number": "19",
          "title": "Оптимизация проекта",
          "info": "6 лекций • 45м",
          "lessons": [
            {
              "lesson": "Вкладка profiler в devTools",
              "time": "07:55"
            },
            {
              "lesson": "Как работает хук useMemo()",
              "time": "10:09"
            },
            {
              "lesson": "Как работает хук useCallBack()",
              "time": "05:20"
            },
            {
              "lesson": "Использование children вместо мемоизации",
              "time": "04:49"
            },
            {
              "lesson": "Ленивая загрузка компонентов",
              "time": "06:55"
            }
          ]
        },
        {
          "id": 20,
          "number": "20",
          "title": "Деплой проекта",
          "info": "3 лекции • 19м",
          "lessons": [
            {
              "lesson": "Хэширование изображений",
              "time": "05:42"
            },
            {
              "lesson": "Запускаем npm run build",
              "time": "08:39"
            },
            {
              "lesson": "Размещение проекта на хостинге",
              "time": "04:59"
            }
          ]
        },
        {
          "id": 21,
          "number": "21",
          "title": "До новых встреч!",
          "info": "1 лекция • 1м",
          "lessons": [
            {
              "lesson": "До встречи на уроках!",
              "time": "00:56"
            }
          ]
        }
      ]
    },
    "additionalCategories": [
      "Продвинутый уровень"
    ]
  },
  {
    "id": 19,
    "slug": "tilda",
    "skillspaceCourses": [{ "courseId": "17890", "groupId": "28659" }],
    "title": "Курс создание сайтов в Tilda",
    "subtitle": "C нуля",
    "description": "Научитесь создавать полноценные адаптивные сайты, с использованием современных анимаций и принципов веб дизайна в Tilda, без знания кода с нуля.",
    "fullDescription": "Tilda — это платформа для создания сайтов без кода. В этом курсе вы научитесь создавать сайты любой сложности, работать с ZeroBlock, подключать анимации и адаптировать дизайн под любые устройства.",
    "image": "/images/courses/tilda-paper-v2.webp",
    "promoVideo": "https://rutube.ru/play/embed/6eced95acfa7d2de61afc08a7987eb4e",
    "price": 2790,
    "originalPrice": 4990,
    "discount": 44,
    "saleDiscount": 25,
    "category": "CMS и Конструкторы",
    "lessons": 107,
    "totalHours": 14.5,
    "duration": "2 месяца",
    "level": "С нуля",
    "students": 2500,
    "rating": 4.9,
    "reviewPlatforms": {
      "udemy": { "url": "https://www.udemy.com/course/tilda-essential/#reviews", "rating": 4.8, "count": 500 },
      "stepik": { "url": "https://stepik.org/course/183709/reviews", "rating": 5, "count": 200 }
    },
    "features": [
      "Интерактивность, общение с преподавателем",
      "Практические задания после каждого урока",
      "Реальные проекты для портфолио",
      "Пожизненный доступ к материалам"
    ],
    "stats": [
      {
        "value": "50K+",
        "label": "Просмотров"
      },
      {
        "value": "100K+",
        "label": "Студентов"
      },
      {
        "value": "150K+",
        "label": "Практических заданий"
      }
    ],
    "topics": [
      "Научитесь создавать сайты из стандартных блоков Tilda",
      "Научитесь всем тонкостям работы с ZeroBlock (Свой собственный дизайн блока)",
      "Научитесь основам веб-дизайна (Работа с типографикой, цветом, разметкой)",
      "Научитесь основам SEO (Настройки для поднятия сайта в топ Google/Yandex)",
      "Узнаете, как создать онлайн-школу в Tilda",
      "Узнаете, как создавать блоги в Tilda",
      "Узнаете, как создать онлайн-магазины",
      "Узнаете, как принимать оплату на вашем сайте",
      "Создадите большой и современный проект в портфолио"
    ],
    "testimonials": [
      {
        "name": "Арина",
        "role": "Студент курса",
        "text": "Спасибо за курс, Дмитрий! Мне очень нравится подача материала. Всё понятно и доступно. Не напрягает прохождение курса из-за разделения на небольшие видео. Вы очень классный преподаватель! Это мой 2 курс от Дмитрия, но я однозначно пройду ещё курсы по разработке сайтов. Все материалы доступны, домашние задания по желанию. Это супер. Я всё равно их проходила, но очень радует такой подход. Огромное спасибо.",
        "rating": 5
      },
      {
        "name": "Илона",
        "role": "Студент курса",
        "text": "В процессе обучения, часто в голову приходили мысли, как мне повезло наткнуться на Дмитрия, на его такой информативный и легкий в восприятии курс, да еще и за такую символическую стоимость. Очень двовольна поставила бы все 10 звездочек",
        "rating": 5
      }
    ],
    "aboutSection": {
      "headline": "Создание сайтов на базе готовых блоков, ZeroBlock и настройка дизайна. Все это Курс по Tilda",
      "highlightedText": "",
      "description": "Tilda — это платформа для создания сайтов без кода. В этом курсе вы научитесь создавать сайты любой сложности, работать с ZeroBlock, подключать анимации и адаптировать дизайн под любые устройства.",
      "featureCard": {
        "text": "Tilda — это платформа, позволяющая создавать сайты без знаний программирования."
      },
      "courseCard": {
        "title": "создание сайтов в Tilda",
        "subtitle": "C нуля",
        "tagline": "Научитесь создавать полноценные адаптивные сайты, ",
        "badge": "КУ"
      },
      "targetAudience": [
              {
                      "icon": "book",
                      "title": "Новичок",
                      "description": "Хотите создавать сайты без кода",
                      "color": "teal",
                      "benefits": [
                              "Zero-code платформа",
                              "Быстрый старт"
                      ]
              },
              {
                      "icon": "palette",
                      "title": "Дизайнер",
                      "description": "Хотите сами делать сайты",
                      "color": "purple",
                      "benefits": [
                              "Дизайн → Сайт",
                              "Без разработчика"
                      ]
              },
              {
                      "icon": "briefcase",
                      "title": "Маркетолог",
                      "description": "Хотите делать лендинги сами",
                      "color": "orange",
                      "benefits": [
                              "Быстрые лендинги",
                              "A/B тесты"
                      ]
              },
              {
                      "icon": "zap",
                      "title": "Предприниматель",
                      "description": "Нужен сайт для бизнеса",
                      "color": "emerald",
                      "benefits": [
                              "Сайт за день",
                              "Экономия бюджета"
                      ]
              }
      ]
    },
    "careerSection": {
          "title": "Сколько зарабатывают Tilda-специалисты?",
          "description": "Создание сайтов на Tilda — быстрый способ начать зарабатывать на фрилансе",
          "vacancies": "1 200+",
          "growth": "+45%",
          "salaryLevels": [
                {
                      "title": "Начинающий",
                      "salary": "40 000 ₽",
                      "progress": "30%"
                },
                {
                      "title": "Специалист",
                      "salary": "70 000 ₽",
                      "progress": "55%"
                },
                {
                      "title": "Эксперт / Агентство",
                      "salary": "120 000+ ₽",
                      "progress": "100%"
                }
          ],
          "source": "* По данным hh.ru и Хабр Карьера, 2025"
    },
    "skillsSection": {
          "skills": [
                {
                      "name": "Создание сайтов на Tilda",
                      "level": "Продвинутый",
                      "progress": "90%"
                },
                {
                      "name": "Zero Block",
                      "level": "Уверенный",
                      "progress": "80%"
                },
                {
                      "name": "SEO и аналитика",
                      "level": "Уверенный",
                      "progress": "75%"
                },
                {
                      "name": "Интеграции и формы",
                      "level": "Уверенный",
                      "progress": "75%"
                }
          ],
          "opportunities": [
                {
                      "icon": "freelance",
                      "title": "Делать сайты на заказ",
                      "description": "Создавать лендинги за 1-2 дня"
                },
                {
                      "icon": "company",
                      "title": "Работать маркетологом",
                      "description": "С навыком создания посадочных страниц"
                },
                {
                      "icon": "growth",
                      "title": "Развиваться дальше",
                      "description": "Освоить Webflow или вёрстку"
                }
          ]
    },
    "curriculum": {
      "headline": "Программа курса",
      "description": "Научитесь создавать полноценные адаптивные сайты, с использованием современных анимаций и принципов веб дизайна в Tilda, без знания кода с нуля.",
      "modules": [
        {
          "id": 1,
          "number": "01",
          "title": "Подготовка",
          "info": "4 лекции • 14м",
          "lessons": [
            {
              "lesson": "О чем курс",
              "time": "03:29"
            },
            {
              "lesson": "Скачиваем материалы к курсу",
              "time": "09:41"
            },
            {
              "lesson": "Реферальная ссылка с бонусом для Tilda",
              "time": "00:11"
            },
            {
              "lesson": "Оставайтесь со мной на связи",
              "time": "00:11"
            }
          ]
        },
        {
          "id": 2,
          "number": "02",
          "title": "Основы Tilda. Стандартные блоки. Концепция работы.",
          "info": "10 лекций • 1ч 27м",
          "lessons": [
            {
              "lesson": "О чем этот блок",
              "time": "01:50"
            },
            {
              "lesson": "Создаем первую страницу из стандартных блоков",
              "time": "09:00"
            },
            {
              "lesson": "Как менять контент стандартных блоков",
              "time": "09:34"
            },
            {
              "lesson": "Как настраивать стили стандартных блоков",
              "time": "12:39"
            },
            {
              "lesson": "Введение в адаптивный дизайн. Сетки, консоль разработчика",
              "time": "08:20"
            }
          ]
        },
        {
          "id": 3,
          "number": "03",
          "title": "Трюки веб-дизайна",
          "info": "13 лекций • 1ч 22м",
          "lessons": [
            {
              "lesson": "О чем этот блок",
              "time": "01:34"
            },
            {
              "lesson": "Обзор программ - инструментов веб-дизайнера",
              "time": "10:03"
            },
            {
              "lesson": "Как приобрести лицензионные программы от Adobe",
              "time": "02:15"
            },
            {
              "lesson": "Лучшие стоковые площадки цифровой графики",
              "time": "05:47"
            },
            {
              "lesson": "Как подбирать цвета для своего сайта",
              "time": "08:24"
            }
          ]
        },
        {
          "id": 4,
          "number": "04",
          "title": "Подготовка к проекту ",
          "info": "3 лекции • 26м",
          "lessons": [
            {
              "lesson": "Что такое бриф с заказчиком",
              "time": "06:15"
            },
            {
              "lesson": "Что такое ",
              "time": "04:53"
            },
            {
              "lesson": "Что такое Wireframe сайта",
              "time": "14:41"
            }
          ]
        },
        {
          "id": 5,
          "number": "05",
          "title": "Работа в Zero block. Проект портфолио",
          "info": "11 лекций • 2ч 3м",
          "lessons": [
            {
              "lesson": "О чем этот и следующие несколько блоков",
              "time": "02:57"
            },
            {
              "lesson": "Знакомимся с Zero Block",
              "time": "13:14"
            },
            {
              "lesson": "Как настраивать свойства элементов в Zero",
              "time": "17:03"
            },
            {
              "lesson": "Настройки цвета в Zero",
              "time": "15:17"
            },
            {
              "lesson": "Создаем независимые переиспользуемые блоки",
              "time": "12:34"
            }
          ]
        },
        {
          "id": 6,
          "number": "06",
          "title": "Анимации в Zero Block",
          "info": "13 лекций • 2ч",
          "lessons": [
            {
              "lesson": "Как работают базовые анимации",
              "time": "10:45"
            },
            {
              "lesson": "Как работают модификаторы. Плавный скролл",
              "time": "05:27"
            },
            {
              "lesson": "Создаем эффект печатной машинки",
              "time": "08:33"
            },
            {
              "lesson": "Эффекты изображений",
              "time": "09:16"
            },
            {
              "lesson": "Создаем Parallax эффект ",
              "time": "09:13"
            }
          ]
        },
        {
          "id": 7,
          "number": "07",
          "title": "Использование своего кода",
          "info": "9 лекций • 1ч 40м",
          "lessons": [
            {
              "lesson": "Создаем стандартные табы",
              "time": "10:28"
            },
            {
              "lesson": "Триггерная анимация на практике",
              "time": "04:11"
            },
            {
              "lesson": "Как использовать сторонний код",
              "time": "08:08"
            },
            {
              "lesson": "Как писать CSS код",
              "time": "16:03"
            },
            {
              "lesson": "Как писать JavaScript код",
              "time": "10:00"
            }
          ]
        },
        {
          "id": 8,
          "number": "08",
          "title": "Адаптивный дизайн сайта",
          "info": "9 лекций • 1ч 28м",
          "lessons": [
            {
              "lesson": "Адаптируем первую секцию",
              "time": "06:02"
            },
            {
              "lesson": "Адаптируем навигационное меню",
              "time": "12:52"
            },
            {
              "lesson": "Используем гамбургер вместо кнопки меню",
              "time": "11:48"
            },
            {
              "lesson": "Анимируем закрытие гамбургера",
              "time": "13:09"
            },
            {
              "lesson": "Включаем и настраиваем анимации на мобильном устройстве",
              "time": "04:22"
            }
          ]
        },
        {
          "id": 9,
          "number": "09",
          "title": "SEO настройки сайта",
          "info": "9 лекций • 58м",
          "lessons": [
            {
              "lesson": "Как настроить свое имя сайта. Покупаем домен для сайта",
              "time": "05:26"
            },
            {
              "lesson": "Что такое SEO. О чем этот блок",
              "time": "07:31"
            },
            {
              "lesson": "Настраиваем заголовок H1 и Alt у изображений",
              "time": "11:48"
            },
            {
              "lesson": "Настраиваем Title & Description сайта",
              "time": "08:16"
            },
            {
              "lesson": "Что такое Бейдж для соц сетей",
              "time": "04:54"
            }
          ]
        },
        {
          "id": 10,
          "number": "10",
          "title": "Работа с формами на сайте",
          "info": "3 лекции • 23м",
          "lessons": [
            {
              "lesson": "Создание форм в Zero Block",
              "time": "07:30"
            },
            {
              "lesson": "Как получать данные из форм",
              "time": "08:05"
            },
            {
              "lesson": "Что такое политика конфиденциальности",
              "time": "06:56"
            }
          ]
        },
        {
          "id": 11,
          "number": "11",
          "title": "Сайт Блог",
          "info": "7 лекций • 40м",
          "lessons": [
            {
              "lesson": "О чем этот блок",
              "time": "01:30"
            },
            {
              "lesson": "Создаем Блог из базовых блоков Tilda или блог из Zero",
              "time": "09:18"
            },
            {
              "lesson": "Знакомимся с ",
              "time": "05:33"
            },
            {
              "lesson": "Как менять контент в ",
              "time": "08:36"
            },
            {
              "lesson": "Разбираемся с настройками поста",
              "time": "06:33"
            }
          ]
        },
        {
          "id": 12,
          "number": "12",
          "title": "Онлайн школа",
          "info": "7 лекций • 1ч",
          "lessons": [
            {
              "lesson": "О чем этот блок",
              "time": "00:44"
            },
            {
              "lesson": "Как работает личный кабинет Tilda",
              "time": "08:10"
            },
            {
              "lesson": "Как добавить пользователя в личный кабинет через формы",
              "time": "07:53"
            },
            {
              "lesson": "Как создавать урок в конструкторе курса Tilda",
              "time": "11:53"
            },
            {
              "lesson": "Как создавать домашние задания в конструкторе курса Tilda",
              "time": "10:41"
            }
          ]
        },
        {
          "id": 13,
          "number": "13",
          "title": "Онлайн магазин",
          "info": "8 лекций • 49м",
          "lessons": [
            {
              "lesson": "О чем этот блок",
              "time": "00:54"
            },
            {
              "lesson": "Способы создания карточки товара",
              "time": "10:45"
            },
            {
              "lesson": "Как создать промо код и настроить параметры товара",
              "time": "06:53"
            },
            {
              "lesson": "Как создать каталог товаров",
              "time": "05:38"
            },
            {
              "lesson": "Как добавлять разные варианты одного товара",
              "time": "09:47"
            }
          ]
        },
        {
          "id": 14,
          "number": "14",
          "title": "Заключение",
          "info": "1 лекция • 3м",
          "lessons": [
            {
              "lesson": "До встречи на уроках!",
              "time": "03:16"
            }
          ]
        }
      ]
    },
    "additionalCategories": [
      "Бестселлеры",
      "С нуля"
    ]
  },
  {
    "id": 20,
    "slug": "ux-research",
    "skillspaceCourses": [{ "courseId": "83319", "groupId": "" }],
    "title": "Курс по UX Исследованиям для дизайнеров",
    "subtitle": "Cо знаниями Figma",
    "description": "Всё о пользовательском опыте и профессии UX-исследователя для дизайнеров и создателей IT-продуктов Изучите UX-дизайн и профессию UX-исследователя",
    "fullDescription": "UX-исследования — одна из самых востребованных методологий для понимания потребностей пользователей и проектирования удобных и интуитивных интерфейсов. Они применяются при создании мобильных приложений, веб-сайтов, сервисов электронной коммерции, корпоративных систем, голосовых ассистентов и многого другого",
    "image": "/images/courses/ux-research-paper-v2.webp",
    "promoVideo": "https://rutube.ru/play/embed/cde677ae487527cb1f710f21081c325a/?p=hd_QF_ZO1c0R4DMgSJ1Aug",
    "price": 2790,
    "originalPrice": 4990,
    "discount": 44,
    "saleDiscount": 25,
    "category": "Веб Дизайн",
    "lessons": 110,
    "totalHours": 12.5,
    "duration": "2 месяца обучения",
    "level": "Средний",
    "students": 2500,
    "rating": 4.9,
    "reviewPlatforms": {
      "udemy": { "url": "https://www.udemy.com/course/ux-design-foundation/#reviews", "rating": 4.8, "count": 300 },
      "stepik": { "url": "https://stepik.org/course/239215/promo#reviews", "rating": 5, "count": 120 }
    },
    "features": [
      "Интерактивность, общение с преподавателем",
      "Практические задания после каждого урока",
      "Реальные проекты для портфолио",
      "Пожизненный доступ к материалам"
    ],
    "stats": [
      {
        "value": "50K+",
        "label": "Просмотров"
      },
      {
        "value": "100K+",
        "label": "Студентов"
      },
      {
        "value": "150K+",
        "label": "Практических заданий"
      }
    ],
    "topics": [
      "Узнайте современные методы и подходы к UX-исследованиям с помощью нейросетей.",
      "Изучите наиболее востребованные виды UX-исследований.",
      "Научитесь проводить юзабилити-тесты любых IT-продуктов.",
      "Научитесь проводить интервью с пользователями ваших IT-продуктов.",
      "Научитесь проводить онлайн-опросы пользователей.",
      "Научитесь проводить кабинетные исследования IT-продуктов.",
      "Научитесь составлять CJM (Customer Journey Map).",
      "Изучите, как работать по фреймворку Jobs To Be Done.",
      "Узнайте, как создавать пользовательские сценарии."
    ],
    "testimonials": [
      {
        "name": "Виктория",
        "role": "Студент курса",
        "text": "Этот курс полностью изменил моё представление о работе с пользователями. От глубинных интервью до картирования пути — каждый модуль продуман до мелочей. Практические задания помогли сразу применить знания. Рекомендую всем, кто хочет стать профи в UX-исследованиях!",
        "rating": 5
      },
      {
        "name": "Павел",
        "role": "Студент курса",
        "text": "Подача материала отлично структурирована: сначала теория, потом реальные кейсы, а в конце — тесты и отчёты. Научился проводить A/B-тесты и First Click Test, а главное — грамотно формулировать гипотезы. Спасибо автору за чёткий и полезный курс!",
        "rating": 5
      }
    ],
    "aboutSection": {
      "headline": "От глубинных интервью и опросов до юзабилити-тестов, картирования пути пользователя и анализа данных — Курс UX-исследований",
      "highlightedText": "",
      "description": "UX-исследования — одна из самых востребованных методологий для понимания потребностей пользователей и проектирования удобных и интуитивных интерфейсов. Они применяются при создании мобильных приложений, веб-сайтов, сервисов электронной коммерции, корпоративных систем, голосовых ассистентов и многого другого",
      "featureCard": {
        "text": "UX - изучает опыт взаимодействия пользователей с нашими IT продуктами"
      },
      "courseCard": {
        "title": "UX Исследованиям для дизайнеров",
        "subtitle": "Cо знаниями Figma",
        "tagline": "Всё о пользовательском опыте и профессии UX-исслед",
        "badge": "КУ"
      },
      "targetAudience": [
              {
                      "icon": "book",
                      "title": "Начинающий UX-дизайнер",
                      "description": "Хотите освоить исследования",
                      "color": "teal",
                      "benefits": [
                              "Методы исследований",
                              "Работа с данными"
                      ]
              },
              {
                      "icon": "palette",
                      "title": "UI-дизайнер",
                      "description": "Хотите добавить UX-навыки",
                      "color": "purple",
                      "benefits": [
                              "Обоснованные решения",
                              "Рост в профессии"
                      ]
              },
              {
                      "icon": "briefcase",
                      "title": "Продакт-менеджер",
                      "description": "Хотите понимать пользователей",
                      "color": "orange",
                      "benefits": [
                              "User research",
                              "Принятие решений"
                      ]
              },
              {
                      "icon": "zap",
                      "title": "Карьерист",
                      "description": "Хотите стать UX-исследователем",
                      "color": "emerald",
                      "benefits": [
                              "Востребованная специализация",
                              "Рост зарплаты"
                      ]
              }
      ]
    },
    "careerSection": {
          "title": "Сколько зарабатывают UX-исследователи?",
          "description": "UX-исследования — одна из самых быстрорастущих специализаций в продуктовом дизайне",
          "vacancies": "800+",
          "growth": "+52%",
          "salaryLevels": [
                {
                      "title": "Junior (0-1 год)",
                      "salary": "80 000 ₽",
                      "progress": "30%"
                },
                {
                      "title": "Middle (1-3 года)",
                      "salary": "150 000 ₽",
                      "progress": "55%"
                },
                {
                      "title": "Senior / Lead",
                      "salary": "250 000+ ₽",
                      "progress": "100%"
                }
          ],
          "source": "* По данным hh.ru и Хабр Карьера, 2025"
    },
    "skillsSection": {
          "skills": [
                {
                      "name": "Пользовательские интервью",
                      "level": "Продвинутый",
                      "progress": "90%"
                },
                {
                      "name": "Юзабилити-тестирование",
                      "level": "Уверенный",
                      "progress": "85%"
                },
                {
                      "name": "Анализ данных",
                      "level": "Уверенный",
                      "progress": "80%"
                },
                {
                      "name": "Персоны и CJM",
                      "level": "Уверенный",
                      "progress": "80%"
                }
          ],
          "opportunities": [
                {
                      "icon": "freelance",
                      "title": "Проводить исследования",
                      "description": "Консультировать по UX для стартапов"
                },
                {
                      "icon": "company",
                      "title": "Устроиться исследователем",
                      "description": "В продуктовую компанию или агентство"
                },
                {
                      "icon": "growth",
                      "title": "Развиваться дальше",
                      "description": "Стать продакт-менеджером или UX-лидом"
                }
          ]
    },
    "curriculum": {
      "headline": "Программа курса",
      "description": "Всё о пользовательском опыте и профессии UX-исследователя для дизайнеров и создателей IT-продуктов Изучите UX-дизайн и профессию UX-исследователя",
      "modules": [
        {
          "id": 1,
          "number": "01",
          "title": "Введение",
          "info": "4 лекции • 21м",
          "lessons": [
            {
              "lesson": "Добро пожаловать на курс!",
              "time": "02:13"
            },
            {
              "lesson": "Скачиваем материалы к курсу",
              "time": "08:01"
            },
            {
              "lesson": "О формате курса",
              "time": "08:15"
            },
            {
              "lesson": "Как проходить курс. О проекте курса",
              "time": "11:12"
            }
          ]
        },
        {
          "id": 2,
          "number": "02",
          "title": "Для чего нужны UX Исследования",
          "info": "4 лекции • 32м",
          "lessons": [
            {
              "lesson": "Развеем заблуждения о UX. Что такое UX исследования вообще.",
              "time": "09:18"
            },
            {
              "lesson": "Пара примеров применения UX",
              "time": "13:33"
            },
            {
              "lesson": "Какие основные проблемы решают UX исследования",
              "time": "05:38"
            },
            {
              "lesson": "Обзор рынка цен на UX Исследователей",
              "time": "05:29"
            }
          ]
        },
        {
          "id": 3,
          "number": "03",
          "title": "Кабинетные исследования. Взгляни вокруг",
          "info": "7 лекций • 1ч 46м",
          "lessons": [
            {
              "lesson": "Что такое продуктовые исследования",
              "time": "06:17"
            },
            {
              "lesson": " Что такое сигнал",
              "time": "05:12"
            },
            {
              "lesson": "О Stepik и брифе",
              "time": "09:54"
            },
            {
              "lesson": "Практика #1 - Соберите сигналы",
              "time": "07:51"
            },
            {
              "lesson": "Что такое кабинетные исследования",
              "time": "16:49"
            }
          ]
        },
        {
          "id": 4,
          "number": "04",
          "title": "Используйте нейросети",
          "info": "2 лекции • 15м",
          "lessons": [
            {
              "lesson": "Как нейросети помогают исследователям",
              "time": "10:08"
            },
            {
              "lesson": "Как оплатить chat GPT из РФ",
              "time": "05:00"
            }
          ]
        },
        {
          "id": 5,
          "number": "05",
          "title": "Основы + терминология UX.",
          "info": "7 лекции • 37м",
          "lessons": [
            {
              "lesson": "Типы (Категории) исследований",
              "time": "10:51"
            },
            {
              "lesson": "Что такое цели исследования",
              "time": "07:57"
            },
            {
              "lesson": "Что такое задачи исследования",
              "time": "04:14"
            },
            {
              "lesson": "Что такое гипотезы",
              "time": "07:08"
            },
            {
              "lesson": "Что такое вопросы исследований",
              "time": "07:08"
            }
          ]
        },
        {
          "id": 6,
          "number": "06",
          "title": "Основные принципы UX исследований",
          "info": "8 лекций • 53м",
          "lessons": [
            {
              "lesson": "Кагда нужно и когда не нужно проводить исследования",
              "time": "05:48"
            },
            {
              "lesson": "Когда нужны исследования нового продукта?",
              "time": "07:57"
            },
            {
              "lesson": "Когда нужны исследования работающего продукта?",
              "time": "04:31"
            },
            {
              "lesson": "Основные принципы UX исследований",
              "time": "13:36"
            },
            {
              "lesson": "Шаги проведения исследования",
              "time": "08:36"
            }
          ]
        },
        {
          "id": 7,
          "number": "07",
          "title": "Глубинное интервью (Качественное исследование)",
          "info": "18 лекций • 02ч 08м",
          "lessons": [
            {
              "lesson": "Что такое глубинное интервью",
              "time": "11:10"
            },
            {
              "lesson": "Цели, гипотезы, задачи и вопросы интервью",
              "time": "06:10"
            },
            {
              "lesson": "Практика #3 - Сформулируйте цели, задачи, гипотезы",
              "time": "16:10"
            },
            {
              "lesson": "Выборка и поиск респондентов",
              "time": "07:10"
            },
            {
              "lesson": "Практика #4 - Определите выборку респондентов",
              "time": "02:10"
            }
          ]
        },
        {
          "id": 8,
          "number": "08",
          "title": " JTBD, Пользовательский сценарий, CJM, ",
          "info": "9 лекций • 1ч 16м",
          "lessons": [
            {
              "lesson": "Напоминание про нейросети",
              "time": "05:39"
            },
            {
              "lesson": "Про персон",
              "time": "05:39"
            },
            {
              "lesson": "Фреймаорк Jobs to Be Done (JTBD)",
              "time": "08:39"
            },
            {
              "lesson": "Как углубиться в анализе JTBD",
              "time": "10:06"
            },
            {
              "lesson": "Методический приём Пользовательские сценарии ч.1",
              "time": "21:46"
            }
          ]
        },
        {
          "id": 9,
          "number": "09",
          "title": "Еще качественные исследования",
          "info": "5 лекции • 34м",
          "lessons": [
            {
              "lesson": "Дневниковые исследования",
              "time": "11:32"
            },
            {
              "lesson": "Карточная сортировка",
              "time": "08:08"
            },
            {
              "lesson": "Карта эмпатии",
              "time": "05:16"
            },
            {
              "lesson": "Какие еще бывают качественные исследования",
              "time": "05:51"
            },
            {
              "lesson": "Ресурсы по качественным исследованиям",
              "time": "05:31"
            }
          ]
        },
        {
          "id": 10,
          "number": "10",
          "title": "Онлайн опросы (Количественные исследования)",
          "info": "16 лекция • 2ч 10м",
          "lessons": [
            {
              "lesson": "Количественные vs качественные исследования",
              "time": "07:06"
            },
            {
              "lesson": "Что такое онлайн‑опросы",
              "time": "13:08"
            },
            {
              "lesson": "Что такое генеральная совокупность",
              "time": "16:08"
            },
            {
              "lesson": "Сколько человек нужно опросить",
              "time": "11:16"
            },
            {
              "lesson": "Практика #9. Сформулируйте задачи и гипотезы для онлайн опроса.",
              "time": "05:51"
            }
          ]
        },
        {
          "id": 11,
          "number": "11",
          "title": "Варианты количественных исследований",
          "info": "5 лекций • 0ч 25м",
          "lessons": [
            {
              "lesson": "Отзывы, комментарии и обратная связь",
              "time": "03:18"
            },
            {
              "lesson": "A/B-тесты (сплит-тестирование)",
              "time": "06:50"
            },
            {
              "lesson": "Eye-tracking и кликовые тепловые карты (heatmaps)",
              "time": "05:22"
            },
            {
              "lesson": "Веб аналитика",
              "time": "04:33"
            },
            {
              "lesson": "Клиентские метрики и индексы",
              "time": "05:17"
            }
          ]
        },
        {
          "id": 12,
          "number": "12",
          "title": "Юзабилити тестирование",
          "info": "18 лекций • 1ч 49м",
          "lessons": [
            {
              "lesson": "Что такое юзабилити тестирование",
              "time": "07:08"
            },
            {
              "lesson": "Юзабилити-тестирование с количественной сборкой",
              "time": "05:43"
            },
            {
              "lesson": "Модерируемое юзабилити-тестирование",
              "time": "08:52"
            },
            {
              "lesson": "Цели, задачи и гипотезы юзабилити-тестирования",
              "time": "03:16"
            },
            {
              "lesson": "PRACTICE #13 - Цели, задачи и гипотезы тестирования",
              "time": "05:34"
            }
          ]
        },
        {
          "id": 13,
          "number": "13",
          "title": "Другие виды тестирования прототипа",
          "info": "3 лекции • 20м",
          "lessons": [
            {
              "lesson": "Коридорный тест",
              "time": "07:23"
            },
            {
              "lesson": "First Click Test",
              "time": "03:31"
            },
            {
              "lesson": "Side-by-Side Test",
              "time": "9:32"
            }
          ]
        },
        {
          "id": 14,
          "number": "14",
          "title": "Презентация результатов исследования",
          "info": "1 лекция • 30м",
          "lessons": [
            {
              "lesson": "PRACTICE #18. Подготовьте финальную презентацию",
              "time": "08:48"
            }
          ]
        },
        {
          "id": 15,
          "number": "15",
          "title": "Финал",
          "info": "1 лекция • 3м",
          "lessons": [
            {
              "lesson": "До встречи на уроках!",
              "time": "03:48"
            }
          ]
        }
      ]
    },
    "additionalCategories": [
      "Продвинутый уровень"
    ]
  },
  {
    "id": 21,
    "slug": "figma",
    "skillspaceCourses": [{ "courseId": "14500", "groupId": "23501" }],
    "title": "Курс UI веб дизайн в Figma",
    "subtitle": "C нуля",
    "description": "В этом курсе, вы найдете все для успешного старта карьеры в UX/UI. Быстрый старт в профессию веб дизайнер.",
    "fullDescription": "Веб-дизайн в Figma — это курс, в котором вы изучите UX/UI, основы работы с типографикой, цветами, сетками и научитесь создавать адаптивные макеты для веб-проектов.",
    "image": "/images/courses/figma-paper-v2.webp",
    "promoVideo": "https://rutube.ru/play/embed/ddef244c06b1d49c7fb510641b044bf3",
    "price": 2790,
    "originalPrice": 4990,
    "discount": 44,
    "saleDiscount": 25,
    "category": "Веб Дизайн",
    "lessons": 121,
    "totalHours": 16.5,
    "duration": "2 месяца",
    "level": "С нуля",
    "students": 2500,
    "rating": 4.9,
    "reviewPlatforms": {
      "udemy": { "url": "https://www.udemy.com/course/web-figma-ui/#reviews", "rating": 4.8, "count": 1000 },
      "stepik": { "url": "https://stepik.org/course/102520/reviews", "rating": 5, "count": 450 }
    },
    "features": [
      "Интерактивность, общение с преподавателем",
      "Практические задания после каждого урока",
      "Реальные проекты для портфолио",
      "Пожизненный доступ к материалам"
    ],
    "stats": [
      {
        "value": "50K+",
        "label": "Просмотров"
      },
      {
        "value": "100K+",
        "label": "Студентов"
      },
      {
        "value": "150K+",
        "label": "Практических заданий"
      }
    ],
    "topics": [
      "Изучите все инструменты Figma",
      "Изучите современные техники и приемы дизайна",
      "Научитесь азам работы в Photoshop",
      "Узнаете больше про профессии UX/UI дизайнера",
      "Узнаете, что такое web design на практике",
      "Научитесь работать с изображениями в Figma",
      "Научитесь подбирать правильные цвета для ваших сайтов",
      "Научитесь подбирать правильные шрифты для ваших сайтов",
      "Узнаете, как работать с контрастом на веб-страницах"
    ],
    "testimonials": [
      {
        "name": "Антон",
        "role": "Студент курса",
        "text": "Огромная благодарность за ваш курс! Я только начинаю свой путь в дизайне и IT, так как решила кардинально сменить профиль деятельности. Этот курс, для меня настоящее открытие! То, что я создала с вами на курсе, мне очень понравилось и теперь я с вами надолго )",
        "rating": 5
      },
      {
        "name": "Анна",
        "role": "Студент курса",
        "text": "Я самоучка в Figma и мне было важно найти курс с хорошей базой, чтобы заполнить свои пробелы, где шаг за шагом можно узнать, как это все работает и взаимосвязано между собой. Дмитрий объясняет все очень доступно, много примеров и есть обратная связь! Очень радует, что нет обязательных домашних работ. Так как некоторые темы я знала и могла просто еще раз прослушать теорию, а больше времени уделить изучению новой информации. Очень понравился раздел с прототипированием, даже и не думала, что это все можно реализовать в программе. Благодаря этому обучение было не скучным, а очень продуктивным! Отдельно хочется отметить доступную цену за курс. Я видела много различных курсов, где цена была очень высокой, а информации давали мало либо в целом некачественно её доносили. Я осталась очень довольна обучением, благодарю)",
        "rating": 5
      }
    ],
    "aboutSection": {
      "headline": "UI, адаптивность, цвет и типографика, а также создание прототипов. Все это Курс по Веб-дизайну в Figma",
      "highlightedText": "",
      "description": "Веб-дизайн в Figma — это курс, в котором вы изучите UX/UI, основы работы с типографикой, цветами, сетками и научитесь создавать адаптивные макеты для веб-проектов.",
      "featureCard": {
        "text": "Веб-дизайн в Figma — это создание современных UI макетов и дизайнов для веб-проектов."
      },
      "courseCard": {
        "title": "UI веб дизайн в Figma",
        "subtitle": "C нуля",
        "tagline": "В этом курсе, вы найдете все для успешного старта ",
        "badge": "КУ"
      },
      "targetAudience": [
              {
                      "icon": "book",
                      "title": "Новичок в дизайне",
                      "description": "Хотите освоить Figma с нуля",
                      "color": "teal",
                      "benefits": [
                              "Основы интерфейса",
                              "Первые макеты"
                      ]
              },
              {
                      "icon": "palette",
                      "title": "Графический дизайнер",
                      "description": "Хотите перейти в UI/UX",
                      "color": "purple",
                      "benefits": [
                              "Веб-дизайн",
                              "Новое направление"
                      ]
              },
              {
                      "icon": "briefcase",
                      "title": "Фрилансер",
                      "description": "Хотите брать заказы на дизайн",
                      "color": "orange",
                      "benefits": [
                              "Востребованный навык",
                              "Больше заказов"
                      ]
              },
              {
                      "icon": "zap",
                      "title": "Разработчик",
                      "description": "Хотите понимать дизайн-макеты",
                      "color": "emerald",
                      "benefits": [
                              "Работа с дизайнерами",
                              "Dev Mode"
                      ]
              }
      ]
    },
    "careerSection": {
          "title": "Сколько зарабатывают UI/UX дизайнеры?",
          "description": "Figma — главный инструмент современного дизайнера интерфейсов",
          "vacancies": "5 200+",
          "growth": "+42%",
          "salaryLevels": [
                {
                      "title": "Начинающий (0-1 год)",
                      "salary": "55 000 ₽",
                      "progress": "30%"
                },
                {
                      "title": "Средний (1-3 года)",
                      "salary": "110 000 ₽",
                      "progress": "55%"
                },
                {
                      "title": "Senior-дизайнер",
                      "salary": "180 000+ ₽",
                      "progress": "100%"
                }
          ],
          "source": "* По данным hh.ru и Хабр Карьера, 2025"
    },
    "skillsSection": {
          "skills": [
                {
                      "name": "Интерфейс Figma",
                      "level": "Продвинутый",
                      "progress": "90%"
                },
                {
                      "name": "Компоненты",
                      "level": "Уверенный",
                      "progress": "80%"
                },
                {
                      "name": "Прототипирование",
                      "level": "Уверенный",
                      "progress": "75%"
                },
                {
                      "name": "Экспорт и Dev Mode",
                      "level": "Базовый",
                      "progress": "65%"
                }
          ],
          "opportunities": [
                {
                      "icon": "freelance",
                      "title": "Начать брать заказы",
                      "description": "Создавать макеты сайтов и приложений"
                },
                {
                      "icon": "company",
                      "title": "Устроиться дизайнером",
                      "description": "На позицию Junior UI/UX"
                },
                {
                      "icon": "growth",
                      "title": "Развиваться дальше",
                      "description": "Освоить продвинутые техники Figma"
                }
          ]
    },
    "curriculum": {
      "headline": "Программа курса",
      "description": "В этом курсе, вы найдете все для успешного старта карьеры в UX/UI. Быстрый старт в профессию веб дизайнер.",
      "modules": [
        {
          "id": 1,
          "number": "01",
          "title": "Введение",
          "info": "3 лекции • 12м",
          "lessons": [
            {
              "lesson": "Скачиваем материалы",
              "time": "07:02"
            },
            {
              "lesson": "Как проходить курс",
              "time": "04:33"
            },
            {
              "lesson": "Оставайтесь со мной на связи",
              "time": "00:11"
            }
          ]
        },
        {
          "id": 2,
          "number": "02",
          "title": "Основы Figma",
          "info": "9 лекций • 1ч 24м",
          "lessons": [
            {
              "lesson": "Об обновлении Figma",
              "time": "12:49"
            },
            {
              "lesson": "Какие размеры у сайта",
              "time": "08:12"
            },
            {
              "lesson": "Создаем frame сайта",
              "time": "08:38"
            },
            {
              "lesson": "Что такое сетка grid",
              "time": "08:03"
            },
            {
              "lesson": "Основы работы с Фигурами \\\\ Изображениями \\\\ Слоями",
              "time": "09:32"
            }
          ]
        },
        {
          "id": 3,
          "number": "03",
          "title": "Работа с цветом",
          "info": "6 лекций • 37м",
          "lessons": [
            {
              "lesson": "Подбор цвета из изображений",
              "time": "02:39"
            },
            {
              "lesson": "ПРАКТИКА. Подберите цвет из изображения",
              "time": "09:31"
            },
            {
              "lesson": "Что такое HSB. Точная настройка цвета",
              "time": "04:42"
            },
            {
              "lesson": "Инструменты подбора цвета для проекта",
              "time": "08:40"
            },
            {
              "lesson": "Как работать с градиентом",
              "time": "05:05"
            }
          ]
        },
        {
          "id": 4,
          "number": "04",
          "title": "Работа с изображениями",
          "info": "8 лекций • 1ч 12м",
          "lessons": [
            {
              "lesson": "Разница растровой и векторной графики",
              "time": "03:47"
            },
            {
              "lesson": "Выбирайте качественные изображения",
              "time": "07:32"
            },
            {
              "lesson": "Как тонировать изображения",
              "time": "09:52"
            },
            {
              "lesson": "Техника экстремальной обрезки",
              "time": "15:21"
            },
            {
              "lesson": "Техника мягкой обрезки",
              "time": "07:51"
            }
          ]
        },
        {
          "id": 5,
          "number": "05",
          "title": "Основы AutoLayOut",
          "info": "3 лекции • 21м",
          "lessons": [
            {
              "lesson": "Отличия нового интерфейса и старого",
              "time": "00:06"
            },
            {
              "lesson": "Основы работы с AutoLayout",
              "time": "12:58"
            },
            {
              "lesson": "ПРАКТИКА. AutoLayOut",
              "time": "08:12"
            }
          ]
        },
        {
          "id": 6,
          "number": "06",
          "title": "Продвинутая работа с фигурами",
          "info": "4 лекции • 37м",
          "lessons": [
            {
              "lesson": "Как работает инструмент ",
              "time": "10:24"
            },
            {
              "lesson": "ПРАКТИКА. ",
              "time": "08:42"
            },
            {
              "lesson": "Делаем следующую секцию сайта",
              "time": "09:48"
            },
            {
              "lesson": "Разница фреймов и групп",
              "time": "08:05"
            }
          ]
        },
        {
          "id": 7,
          "number": "07",
          "title": "Отступы в веб-дизайне",
          "info": "3 лекции • 33м",
          "lessons": [
            {
              "lesson": "Правила отступов в веб-дизайне",
              "time": "10:35"
            },
            {
              "lesson": "ПРАКТИКА. Отступы в веб-дизайне",
              "time": "10:09"
            },
            {
              "lesson": "4px сетка vs 8px сетка",
              "time": "12:07"
            }
          ]
        },
        {
          "id": 8,
          "number": "08",
          "title": "Эффекты и стили",
          "info": "2 лекции • 26м",
          "lessons": [
            {
              "lesson": "Как работают эффекты",
              "time": "15:47"
            },
            {
              "lesson": "Как работают стили",
              "time": "10:03"
            }
          ]
        },
        {
          "id": 9,
          "number": "09",
          "title": "Маски и плагины",
          "info": "7 лекций • 45м",
          "lessons": [
            {
              "lesson": "Обновление интерфейса Figma",
              "time": "00:03"
            },
            {
              "lesson": "Как работают маски",
              "time": "09:38"
            },
            {
              "lesson": "Если маска в режиме презентации полупрозрачная.",
              "time": "00:09"
            },
            {
              "lesson": "Дополнительная практика по маскам",
              "time": "07:14"
            },
            {
              "lesson": "Фигура с изображением",
              "time": "05:11"
            }
          ]
        },
        {
          "id": 10,
          "number": "10",
          "title": "Работа со шрифтами",
          "info": "7 лекций • 55м",
          "lessons": [
            {
              "lesson": "Важность шрифтов",
              "time": "03:11"
            },
            {
              "lesson": "Типы шрифтов",
              "time": "05:59"
            },
            {
              "lesson": "Где брать новые шрифты",
              "time": "05:39"
            },
            {
              "lesson": "Как подбирать шрифты",
              "time": "05:45"
            },
            {
              "lesson": "ПРАКТИКА. Подберите шрифты",
              "time": "11:04"
            }
          ]
        },
        {
          "id": 11,
          "number": "11",
          "title": "Подготовка к новому проекту",
          "info": "5 лекций • 40м",
          "lessons": [
            {
              "lesson": "Как создавать страницы в проекте",
              "time": "04:53"
            },
            {
              "lesson": "Бриф с заказчиком",
              "time": "07:36"
            },
            {
              "lesson": "Как создавать mood board",
              "time": "07:18"
            },
            {
              "lesson": "Что такое Wireframe сайта",
              "time": "13:57"
            },
            {
              "lesson": "ПРАКТИКА. Создайте собственный mood board и wireframe",
              "time": "05:54"
            }
          ]
        },
        {
          "id": 12,
          "number": "12",
          "title": "Дизайн система",
          "info": "6 лекций • 47м",
          "lessons": [
            {
              "lesson": "Нужен ли дизайнеру Photoshop",
              "time": "15:41"
            },
            {
              "lesson": "Как приобрести лицензионный фотошоп из России",
              "time": "02:15"
            },
            {
              "lesson": "Что такое дизайн система",
              "time": "12:06"
            },
            {
              "lesson": "Делаем лист стилей для типографики",
              "time": "10:15"
            },
            {
              "lesson": "Доделываем карту стилей",
              "time": "05:16"
            }
          ]
        },
        {
          "id": 13,
          "number": "13",
          "title": "Компоненты и варианты в Figma",
          "info": "5 лекций • 55м",
          "lessons": [
            {
              "lesson": "Делаем следующую секцию сайта",
              "time": "11:20"
            },
            {
              "lesson": "Как работают компоненты",
              "time": "13:49"
            },
            {
              "lesson": "Организация и хранение компонентов",
              "time": "07:58"
            },
            {
              "lesson": "Как работают варианты",
              "time": "20:06"
            },
            {
              "lesson": "ПРАКТИКА. Создайте собственные варианты",
              "time": "01:27"
            }
          ]
        },
        {
          "id": 14,
          "number": "14",
          "title": "Углублённая работа с AutoLayOut",
          "info": "11 лекций • 1ч 37м",
          "lessons": [
            {
              "lesson": "Обновление интерфейса Figma. Constraints",
              "time": "00:03"
            },
            {
              "lesson": "Как создать подкатегории стилей",
              "time": "14:24"
            },
            {
              "lesson": "Создаем следующую секцию сайта",
              "time": "05:58"
            },
            {
              "lesson": "Как создавать многоуровневый AutoLayOut",
              "time": "14:11"
            },
            {
              "lesson": "Используйте готовые элементы из других макетов",
              "time": "04:47"
            }
          ]
        },
        {
          "id": 15,
          "number": "15",
          "title": "Адаптивный дизайн",
          "info": "7 лекций • 1ч 39м",
          "lessons": [
            {
              "lesson": "Основы constraints",
              "time": "07:35"
            },
            {
              "lesson": "Как работают constraints с grid",
              "time": "07:01"
            },
            {
              "lesson": "ПРАКТИКА. Constraints",
              "time": "06:55"
            },
            {
              "lesson": "Что такое адаптивный дизайн",
              "time": "16:57"
            },
            {
              "lesson": "Что такое DPI и PPI",
              "time": "06:12"
            }
          ]
        },
        {
          "id": 16,
          "number": "16",
          "title": "Ускорение работы",
          "info": "2 лекции • 24м",
          "lessons": [
            {
              "lesson": "Полезные горячие клавиши",
              "time": "14:50"
            },
            {
              "lesson": "Полезные плагины",
              "time": "09:10"
            }
          ]
        },
        {
          "id": 17,
          "number": "17",
          "title": "Прототипирование",
          "info": "12 лекций • 1ч 20м",
          "lessons": [
            {
              "lesson": "Режим презентация макета",
              "time": "09:03"
            },
            {
              "lesson": "Углубленные настройки прототипов",
              "time": "09:18"
            },
            {
              "lesson": "Базовая анимация в Figma",
              "time": "07:28"
            },
            {
              "lesson": "Как работают кривые Безье",
              "time": "07:59"
            },
            {
              "lesson": "Работа open overlay & scroll to",
              "time": "07:25"
            }
          ]
        },
        {
          "id": 18,
          "number": "18",
          "title": "Платная или бесплатная Figma?",
          "info": "1 лекция • 13м",
          "lessons": [
            {
              "lesson": "Отличия платной и бесплатной Figma",
              "time": "12:52"
            }
          ]
        },
        {
          "id": 19,
          "number": "19",
          "title": "Экспорт",
          "info": "2 лекции • 10м",
          "lessons": [
            {
              "lesson": "Экспорт изображений",
              "time": "06:03"
            },
            {
              "lesson": "Как работать в команде",
              "time": "04:20"
            }
          ]
        },
        {
          "id": 20,
          "number": "20",
          "title": "Бонус! Дизайнерские трюки",
          "info": "6 лекций • 23м",
          "lessons": [
            {
              "lesson": "Трюки с наложением элементов друг на друга",
              "time": "04:04"
            },
            {
              "lesson": "Одинаковые элементы на странице",
              "time": "06:25"
            },
            {
              "lesson": "Трюки с повторениями",
              "time": "02:15"
            },
            {
              "lesson": "Трюки с контрастом",
              "time": "02:53"
            },
            {
              "lesson": "Трюки с пустым пространством",
              "time": "03:45"
            }
          ]
        },
        {
          "id": 21,
          "number": "21",
          "title": "Бонус! Figma Jam",
          "info": "2 лекции • 20м",
          "lessons": [
            {
              "lesson": "Что такое Figma Jam",
              "time": "12:09"
            },
            {
              "lesson": "Недавние обновления Figma Jam",
              "time": "07:32"
            }
          ]
        },
        {
          "id": 22,
          "number": "22",
          "title": "Бонус! Работа в Photoshop",
          "info": "9 лекций • 55м",
          "lessons": [
            {
              "lesson": "Как приобрести лицензионный Photoshop",
              "time": "02:15"
            },
            {
              "lesson": "Подготовка программы",
              "time": "04:38"
            },
            {
              "lesson": "Работа со слоями в Photoshop",
              "time": "08:08"
            },
            {
              "lesson": "Расширяем границы изображений",
              "time": "10:21"
            },
            {
              "lesson": "Удаляем ненужное из фото",
              "time": "07:42"
            }
          ]
        },
        {
          "id": 23,
          "number": "23",
          "title": "Что дальше?",
          "info": "1 лекция • 4м",
          "lessons": [
            {
              "lesson": "До свидания!",
              "time": "03:34"
            }
          ]
        }
      ]
    },
    "additionalCategories": [
      "Бестселлеры",
      "С нуля"
    ]
  },
  {
    "id": 22,
    "slug": "webflow",
    "skillspaceCourses": [{ "courseId": "30470", "groupId": "45914" }],
    "title": "Курс верстка сайтов в Webflow",
    "subtitle": "C нуля",
    "description": "Научитесь создавать удивительные сайты любой сложности на no-code платформе Webflow с нуля, без программирования.",
    "fullDescription": "Webflow — это инструмент для создания сайтов с возможностью гибкой анимации и адаптации. В этом курсе вы научитесь создавать уникальные проекты, разрабатывать анимации и эффективно использовать возможности Webflow.",
    "image": "/images/courses/webflow-paper-v2.webp",
    "promoVideo": "https://rutube.ru/play/embed/68f0b58a4c766704f8a794e847559691",
    "price": 2790,
    "originalPrice": 4990,
    "discount": 44,
    "saleDiscount": 25,
    "category": "CMS и Конструкторы",
    "lessons": 123,
    "totalHours": 18.5,
    "duration": "2 месяца",
    "level": "С нуля",
    "students": 2500,
    "rating": 4.9,
    "reviewPlatforms": {
      "udemy": { "url": "https://www.udemy.com/course/webflow-s/#reviews", "rating": 4.8, "count": 350 },
      "stepik": { "url": "https://stepik.org/course/199492/reviews", "rating": 5, "count": 130 }
    },
    "features": [
      "Интерактивность, общение с преподавателем",
      "Практические задания после каждого урока",
      "Реальные проекты для портфолио",
      "Пожизненный доступ к материалам"
    ],
    "stats": [
      {
        "value": "50K+",
        "label": "Просмотров"
      },
      {
        "value": "100K+",
        "label": "Студентов"
      },
      {
        "value": "150K+",
        "label": "Практических заданий"
      }
    ],
    "topics": [
      "Научитесь создавать сайты любой сложности",
      "Научитесь создавать анимации на сайтах",
      "Разберитесь во всех тонкостях Webflow",
      "Научитесь продвигать ваш сайт в Google и Yandex",
      "Узнаете основные правила верстки сайтов",
      "Изучите методы ускорения создания сайтов",
      "Узнаете, как создать мультиязычный сайт",
      "Научитесь подключать оплату на ваш сайт",
      "Узнаете, как создать интернет-магазин"
    ],
    "testimonials": [
      {
        "name": "Артем",
        "role": "Студент курса",
        "text": "Отличный курс все просто и по делу для ознокомления с софтом самое то, да ему не хватает объяснения некоторых различий между вебфлоу и нативной версткой например я задавал вопрос в коментарии про наличие псевдоэлементов в вебфлоу. впорочем для базового понимания это наверное и не нужно. я бы расширил тему передачи проекта например есть ли встроеная опция указать себя автором сайта и передать его на аккаунт заказчика как в тильда. к сожалению нету опции поставить 4.5! поэтому опишу свой опыт так: этот курс я смотрел на скорости х1.25, хотя обычно делаю это на х2 думаю это многое говорит о его наполнености важным контентом.",
        "rating": 5
      },
      {
        "name": "Мария",
        "role": "Студент курса",
        "text": "Замечательный курс, уже третий, который прохожу у Дмитрия. Как всегда, очень доступное и понятное изложение, прекрасная логика и удобная подача материала со всеми нужными ссылками, сервисами, презентациями. Объем материла тщательно отфильтрован, ничего лишнего.",
        "rating": 5
      }
    ],
    "aboutSection": {
      "headline": "Создание сайтов с анимацией, сложная адаптация и верстка. Все это Курс по Webflow",
      "highlightedText": "",
      "description": "Webflow — это инструмент для создания сайтов с возможностью гибкой анимации и адаптации. В этом курсе вы научитесь создавать уникальные проекты, разрабатывать анимации и эффективно использовать возможности Webflow.",
      "featureCard": {
        "text": "Webflow — инструмент для создания сайтов с визуальным редактированием и анимацией."
      },
      "courseCard": {
        "title": "верстка сайтов в Webflow",
        "subtitle": "C нуля",
        "tagline": "Научитесь создавать удивительные сайты любой сложн",
        "badge": "КУ"
      },
      "targetAudience": [
              {
                      "icon": "book",
                      "title": "Дизайнер без кода",
                      "description": "Хотите создавать сайты визуально",
                      "color": "teal",
                      "benefits": [
                              "No-code платформа",
                              "Визуальный редактор"
                      ]
              },
              {
                      "icon": "palette",
                      "title": "Веб-дизайнер",
                      "description": "Хотите воплощать макеты в жизнь",
                      "color": "purple",
                      "benefits": [
                              "От Figma к Webflow",
                              "Без разработчика"
                      ]
              },
              {
                      "icon": "briefcase",
                      "title": "Фрилансер",
                      "description": "Хотите делать сайты под ключ",
                      "color": "orange",
                      "benefits": [
                              "Полный цикл",
                              "Выше чек"
                      ]
              },
              {
                      "icon": "zap",
                      "title": "Агентство",
                      "description": "Хотите быстро делать сайты",
                      "color": "emerald",
                      "benefits": [
                              "Скорость разработки",
                              "Масштабирование"
                      ]
              }
      ]
    },
    "careerSection": {
          "title": "Сколько зарабатывают Webflow-разработчики?",
          "description": "Webflow — премиум no-code платформа. Специалисты работают с крупными клиентами по всему миру",
          "vacancies": "600+",
          "growth": "+65%",
          "salaryLevels": [
                {
                      "title": "Начинающий",
                      "salary": "60 000 ₽",
                      "progress": "25%"
                },
                {
                      "title": "Специалист",
                      "salary": "120 000 ₽",
                      "progress": "50%"
                },
                {
                      "title": "Эксперт ($ клиенты)",
                      "salary": "250 000+ ₽",
                      "progress": "100%"
                }
          ],
          "source": "* По данным hh.ru и Upwork, 2025"
    },
    "skillsSection": {
          "skills": [
                {
                      "name": "Webflow Designer",
                      "level": "Продвинутый",
                      "progress": "90%"
                },
                {
                      "name": "CMS и коллекции",
                      "level": "Уверенный",
                      "progress": "80%"
                },
                {
                      "name": "Анимации и интеракции",
                      "level": "Уверенный",
                      "progress": "75%"
                },
                {
                      "name": "Responsive дизайн",
                      "level": "Уверенный",
                      "progress": "80%"
                }
          ],
          "opportunities": [
                {
                      "icon": "freelance",
                      "title": "Делать сайты под ключ",
                      "description": "Создавать премиум-сайты без кода"
                },
                {
                      "icon": "company",
                      "title": "Работать в агентстве",
                      "description": "Как Webflow-специалист"
                },
                {
                      "icon": "growth",
                      "title": "Развиваться дальше",
                      "description": "Брать международных клиентов на Upwork"
                }
          ]
    },
    "curriculum": {
      "headline": "Программа курса",
      "description": "Научитесь создавать удивительные сайты любой сложности на no-code платформе Webflow с нуля, без программирования.",
      "modules": [
        {
          "id": 1,
          "number": "01",
          "title": "Введение",
          "info": "6 лекций • 50м",
          "lessons": [
            {
              "lesson": "Скачиваем материалы. Как проходить курс",
              "time": "17:37"
            },
            {
              "lesson": "Оставайтесь со мной на связи",
              "time": "00:11"
            },
            {
              "lesson": "Знакомство с интерфейсом Webflow",
              "time": "11:24"
            },
            {
              "lesson": "Как работает Webflow под капотом",
              "time": "10:43"
            },
            {
              "lesson": "Как делиться своим проектом",
              "time": "07:46"
            }
          ]
        },
        {
          "id": 2,
          "number": "02",
          "title": "Основы Webflow",
          "info": "21 лекция • 3ч 17м",
          "lessons": [
            {
              "lesson": "Процесс создания сайта",
              "time": "07:48"
            },
            {
              "lesson": "Скачиваем Figma",
              "time": "09:09"
            },
            {
              "lesson": "Как верстают сайты",
              "time": "12:28"
            },
            {
              "lesson": "Создаем изображение через элемент Image",
              "time": "11:23"
            },
            {
              "lesson": "Создаем изображение через Background",
              "time": "11:10"
            }
          ]
        },
        {
          "id": 3,
          "number": "03",
          "title": "Классы & система flexbox",
          "info": "8 лекций • 1ч 27м",
          "lessons": [
            {
              "lesson": "Знакомимся с системой flex-box",
              "time": "15:25"
            },
            {
              "lesson": "Как работает дочерний элемент во Flex Box контейнере",
              "time": "08:31"
            },
            {
              "lesson": "Как работают комбо классы",
              "time": "06:21"
            },
            {
              "lesson": "Как работают глобальные классы",
              "time": "06:54"
            },
            {
              "lesson": "Создаем глобальные классы отступов",
              "time": "14:08"
            }
          ]
        },
        {
          "id": 4,
          "number": "04",
          "title": "Система Grid CSS",
          "info": "7 лекций • 1ч 16м",
          "lessons": [
            {
              "lesson": "Что такое CSS Grid",
              "time": "12:02"
            },
            {
              "lesson": "Как работают дочерние элементы Grid",
              "time": "10:07"
            },
            {
              "lesson": "Размеры Grid CSS сеток",
              "time": "08:41"
            },
            {
              "lesson": "Как создать галерею с помощью Grid CSS",
              "time": "06:13"
            },
            {
              "lesson": "Используйте Div внутри ячейки Grid",
              "time": "16:14"
            }
          ]
        },
        {
          "id": 5,
          "number": "05",
          "title": "Абсолютное позиционирование и фильтры",
          "info": "11 лекций • 2ч 9м",
          "lessons": [
            {
              "lesson": "Создаем разметку следующей секции",
              "time": "18:44"
            },
            {
              "lesson": "Используем Grid CSS на карточках",
              "time": "12:24"
            },
            {
              "lesson": "Как работает свойство filter",
              "time": "09:11"
            },
            {
              "lesson": "Img Vs Background",
              "time": "12:36"
            },
            {
              "lesson": "Свойства вкладки filters",
              "time": "14:19"
            }
          ]
        },
        {
          "id": 6,
          "number": "06",
          "title": "Работа с табами",
          "info": "4 лекции • 48м",
          "lessons": [
            {
              "lesson": "Создаем карточку таба",
              "time": "24:27"
            },
            {
              "lesson": "Как модифицировать табы",
              "time": "12:07"
            },
            {
              "lesson": "Как работает свойство overflow",
              "time": "07:31"
            },
            {
              "lesson": "Как задать скорость анимации табов",
              "time": "03:41"
            }
          ]
        },
        {
          "id": 7,
          "number": "07",
          "title": "Формы",
          "info": "7 лекций • 56м",
          "lessons": [
            {
              "lesson": "Создаем структуру следующей секции",
              "time": "08:51"
            },
            {
              "lesson": "Как отправить форму на почту",
              "time": "07:41"
            },
            {
              "lesson": "Настройка элементов формы",
              "time": "10:13"
            },
            {
              "lesson": "Checkboxes, radio buttons, text fields",
              "time": "06:30"
            },
            {
              "lesson": "Как стилизовать формы",
              "time": "11:56"
            }
          ]
        },
        {
          "id": 8,
          "number": "08",
          "title": "Особенности и настройки webflow",
          "info": "8 лекций • 1ч 2м",
          "lessons": [
            {
              "lesson": "Обзор тарифов webflow",
              "time": "15:27"
            },
            {
              "lesson": "Как оплатить Webflow из России",
              "time": "03:16"
            },
            {
              "lesson": "Что такое HDPI Img",
              "time": "12:40"
            },
            {
              "lesson": "Какие размеры у изображений",
              "time": "08:10"
            },
            {
              "lesson": "Как добавить fav-icon",
              "time": "04:02"
            }
          ]
        },
        {
          "id": 9,
          "number": "09",
          "title": "Ускорение работы",
          "info": "6 лекций • 58м",
          "lessons": [
            {
              "lesson": "Горячие клавиши",
              "time": "13:11"
            },
            {
              "lesson": "Как создавать страницы и компоненты",
              "time": "07:18"
            },
            {
              "lesson": "Независимый элемент компонента",
              "time": "07:34"
            },
            {
              "lesson": "Как отвязать компонент",
              "time": "10:00"
            },
            {
              "lesson": "Что такое переменные",
              "time": "11:17"
            }
          ]
        },
        {
          "id": 10,
          "number": "10",
          "title": "Анимации",
          "info": "11 лекций • 1ч 30м",
          "lessons": [
            {
              "lesson": "Создаем плавный скролл до секции",
              "time": "04:48"
            },
            {
              "lesson": "Знакомимся с готовыми анимациями webflow",
              "time": "08:51"
            },
            {
              "lesson": "Введение в кастомные анимации",
              "time": "07:27"
            },
            {
              "lesson": "Настройки анимаций",
              "time": "05:57"
            },
            {
              "lesson": "Настройки влияния анимаций",
              "time": "13:19"
            }
          ]
        },
        {
          "id": 11,
          "number": "11",
          "title": "Адаптивный дизайн",
          "info": "11 лекций • 2ч",
          "lessons": [
            {
              "lesson": "Что такое адаптивный дизайн",
              "time": "09:04"
            },
            {
              "lesson": "Как работают breakpoints в webflow",
              "time": "06:35"
            },
            {
              "lesson": "Настраиваем универсальные размеры элементов",
              "time": "15:05"
            },
            {
              "lesson": "Универсальный отступ для секций",
              "time": "08:41"
            },
            {
              "lesson": "Универсальные настройки margin",
              "time": "02:55"
            }
          ]
        },
        {
          "id": 12,
          "number": "12",
          "title": "SEO",
          "info": "10 лекций • 1ч 2м",
          "lessons": [
            {
              "lesson": "Как подключить домен к сайту",
              "time": "14:08"
            },
            {
              "lesson": "Как настроить H1 \\\\ H2 и Alt text",
              "time": "08:37"
            },
            {
              "lesson": "Ter Title и Description",
              "time": "06:41"
            },
            {
              "lesson": "Бейджик для социальных сетей",
              "time": "03:14"
            },
            {
              "lesson": "Дополнительные настройки сайта",
              "time": "04:13"
            }
          ]
        },
        {
          "id": 13,
          "number": "13",
          "title": "Интернет магазин",
          "info": "10 лекций • 1ч 1м",
          "lessons": [
            {
              "lesson": "Как подключить WordPress",
              "time": "09:47"
            },
            {
              "lesson": "Ошибка. This site cant be reached",
              "time": "01:41"
            },
            {
              "lesson": "Кастомный домен бесплатно",
              "time": "07:58"
            },
            {
              "lesson": "Как убрать лейбл made in webflow",
              "time": "04:25"
            },
            {
              "lesson": "Помогите! У меня не получается",
              "time": "06:10"
            }
          ]
        },
        {
          "id": 14,
          "number": "14",
          "title": "Экспорт",
          "info": "2 лекции • 13м",
          "lessons": [
            {
              "lesson": "Как делится проектом",
              "time": "07:18"
            },
            {
              "lesson": "Как работать в команде",
              "time": "05:58"
            }
          ]
        }
      ]
    },
    "additionalCategories": [
      "С нуля"
    ]
  },
  {
    "id": 23,
    "slug": "wordpress",
    "skillspaceCourses": [{ "courseId": "40246", "groupId": "61031" }],
    "title": "Курс создание сайтов в WordPress",
    "subtitle": "C нуля",
    "description": "Курс по WordPress познакомит вас со всеми инструментами для создания современного сайта с любым дизайном и полным функционалом без подписок и дополнительных трат, которые есть у других CMS и конструкторов сайтов.",
    "fullDescription": "WordPress — это самая популярная CMS в мире. В этом курсе вы научитесь создавать сайты любой сложности, управлять контентом, подключать плагины, настраивать темы и создавать интернет-магазины.",
    "image": "/images/courses/wordpress-paper-v2.webp",
    "promoVideo": "https://rutube.ru/play/embed/59f4698445c5c95037a71892ef19f1de",
    "price": 2790,
    "originalPrice": 4990,
    "discount": 44,
    "saleDiscount": 25,
    "category": "CMS и Конструкторы",
    "lessons": 98,
    "totalHours": 13.5,
    "duration": "2 месяца",
    "level": "С нуля",
    "students": 2500,
    "rating": 4.9,
    "reviewPlatforms": {
      "udemy": { "url": "https://www.udemy.com/course/wordpress-fokeev-essential/#reviews", "rating": 4.8, "count": 400 },
      "stepik": { "url": "https://stepik.org/course/208466/reviews", "rating": 5, "count": 160 }
    },
    "features": [
      "Интерактивность, общение с преподавателем",
      "Практические задания после каждого урока",
      "Реальные проекты для портфолио",
      "Пожизненный доступ к материалам"
    ],
    "stats": [
      {
        "value": "50K+",
        "label": "Просмотров"
      },
      {
        "value": "100K+",
        "label": "Студентов"
      },
      {
        "value": "150K+",
        "label": "Практических заданий"
      }
    ],
    "topics": [
      "Создавать сайты на WordPress с любым дизайном",
      "Создавать сайты на WordPress, используя сторонние шаблоны",
      "Научитесь изменять любые стили темы сайта на WordPress",
      "Научитесь работать в no-code платформе Elementor",
      "Изучите все возможности WordPress",
      "Сможете создать интернет-магазин",
      "Научитесь подключать оплату в рублях и криптовалюте",
      "Научитесь создавать блок с комментариями",
      "Узнаете, как адаптировать сайт под любое устройство"
    ],
    "testimonials": [
      {
        "name": "Юлия",
        "role": "Студент курса",
        "text": "Отличный курс, как и все курсы этого автора! Дмитрий не только опытный специалист в своей области, но и прекрасный преподаватель, который умеет преподнести и объяснять сложные вещи простым и понятным языком. Хорошую речь, кстати тоже нельзя не отметить. Курсы у него увлекательные, затягивают, не оторваться от них до последнего урока. Отдельно отмечу, что автор всегда на связи, сразу отвечает на вопросы. И еще важный момент в веб дизайне - у преподавателя хороший вкус, у него красивые вещи получаются. Учиться ведь надо у лучших. Да, еще: информация в курсах всегда самая последняя, всякие новые фишки, источники. В общем, даже не думайте - берите курс и начинайте учиться, не пожалеете!",
        "rating": 5
      },
      {
        "name": "Павел",
        "role": "Студент курса",
        "text": "Отличный курс! Перед тем, как начал проходить курс, были сомнения, стоит ли платить за курс по теме, о которой есть много бесплатного видео на ютубе. Оказалось, что да, определённо стоит. Материал хорошо структурирован, ясно изложен, рассказано множество деталей, которые вы не найдёте в бесплатных источниках, либо вам придётся перелопатить их очень много, теряя недели и месяцы своей жизни, вместо того, чтобы уже зарабатывать, создавая сайты за деньги. Ещё понравилось, что благодаря практическим заданиям в курсе, у нас появляются навыки, как создать то или это, например, разместить элемент в нужном месте на экране и с правильным размером. Этот курс даёт необходимые знания для создания коммерческих сайтов на WordPress.",
        "rating": 5
      }
    ],
    "aboutSection": {
      "headline": "Создание сайтов любой сложности, интернет-магазины, настройка тем и плагинов. Все это Курс по WordPress",
      "highlightedText": "",
      "description": "WordPress — это самая популярная CMS в мире. В этом курсе вы научитесь создавать сайты любой сложности, управлять контентом, подключать плагины, настраивать темы и создавать интернет-магазины.",
      "featureCard": {
        "text": "WordPress — самая популярная платформа для создания и управления сайтами любой сложности."
      },
      "courseCard": {
        "title": "создание сайтов в WordPress",
        "subtitle": "C нуля",
        "tagline": "Курс по WordPress познакомит вас со всеми инструме",
        "badge": "КУ"
      },
      "targetAudience": [
              {
                      "icon": "book",
                      "title": "Новичок",
                      "description": "Хотите создавать сайты на WordPress",
                      "color": "teal",
                      "benefits": [
                              "Популярная CMS",
                              "Много возможностей"
                      ]
              },
              {
                      "icon": "palette",
                      "title": "Дизайнер",
                      "description": "Хотите сами делать сайты",
                      "color": "purple",
                      "benefits": [
                              "Темы и плагины",
                              "Кастомизация"
                      ]
              },
              {
                      "icon": "briefcase",
                      "title": "Фрилансер",
                      "description": "Хотите брать проекты на WordPress",
                      "color": "orange",
                      "benefits": [
                              "Огромный рынок",
                              "Много заказов"
                      ]
              },
              {
                      "icon": "zap",
                      "title": "Предприниматель",
                      "description": "Нужен функциональный сайт",
                      "color": "emerald",
                      "benefits": [
                              "Магазин, блог",
                              "Своими силами"
                      ]
              }
      ]
    },
    "careerSection": {
          "title": "Сколько зарабатывают WordPress-разработчики?",
          "description": "43% всех сайтов в мире работают на WordPress. Специалисты всегда востребованы",
          "vacancies": "2 400+",
          "growth": "+12%",
          "salaryLevels": [
                {
                      "title": "Начинающий",
                      "salary": "45 000 ₽",
                      "progress": "30%"
                },
                {
                      "title": "Специалист",
                      "salary": "85 000 ₽",
                      "progress": "55%"
                },
                {
                      "title": "WordPress-эксперт",
                      "salary": "150 000+ ₽",
                      "progress": "100%"
                }
          ],
          "source": "* По данным hh.ru и Хабр Карьера, 2025"
    },
    "skillsSection": {
          "skills": [
                {
                      "name": "Установка и настройка WP",
                      "level": "Продвинутый",
                      "progress": "90%"
                },
                {
                      "name": "Темы и плагины",
                      "level": "Уверенный",
                      "progress": "80%"
                },
                {
                      "name": "WooCommerce",
                      "level": "Уверенный",
                      "progress": "75%"
                },
                {
                      "name": "SEO и безопасность",
                      "level": "Базовый",
                      "progress": "65%"
                }
          ],
          "opportunities": [
                {
                      "icon": "freelance",
                      "title": "Брать заказы на WP",
                      "description": "Создавать блоги, магазины, корпоративные сайты"
                },
                {
                      "icon": "company",
                      "title": "Работать веб-мастером",
                      "description": "Поддержка и развитие сайтов на WP"
                },
                {
                      "icon": "growth",
                      "title": "Развиваться дальше",
                      "description": "Освоить кастомную разработку тем"
                }
          ]
    },
    "curriculum": {
      "headline": "Программа курса",
      "description": "Курс по WordPress познакомит вас со всеми инструментами для создания современного сайта с любым дизайном и полным функционалом без подписок и дополнительных трат, которые есть у других CMS и конструкторов сайтов.",
      "modules": [
        {
          "id": 1,
          "number": "01",
          "title": "Введение",
          "info": "5 лекций • 24м",
          "lessons": [
            {
              "lesson": "О чем курс",
              "time": "03:20"
            },
            {
              "lesson": "Приветствую на курсе!",
              "time": "03:22"
            },
            {
              "lesson": "Скачиваем материалы",
              "time": "03:59"
            },
            {
              "lesson": "Оставайтесь со мной на связи",
              "time": "00:11"
            },
            {
              "lesson": "Устанавливаем WordPress на хостинг",
              "time": "12:42"
            }
          ]
        },
        {
          "id": 2,
          "number": "02",
          "title": "Знакомство с WordPress",
          "info": "5 лекций • 37м",
          "lessons": [
            {
              "lesson": "Базовые настройки нового сайта",
              "time": "09:40"
            },
            {
              "lesson": "Как редактировать страницу",
              "time": "05:25"
            },
            {
              "lesson": "Как работают темы в WordPress",
              "time": "09:17"
            },
            {
              "lesson": "Как работают плагины в WordPress",
              "time": "08:48"
            },
            {
              "lesson": "ПРАКТИКА! Создайте свой сайт",
              "time": "03:35"
            }
          ]
        },
        {
          "id": 3,
          "number": "03",
          "title": "Знакомство с Elementor",
          "info": "11 лекций • 1ч 19м",
          "lessons": [
            {
              "lesson": "Как загружать плагины и темы с компьютера",
              "time": "07:53"
            },
            {
              "lesson": "Настройки Hello Theme Elementor",
              "time": "08:08"
            },
            {
              "lesson": "Создаем первые элементы в Elementor",
              "time": "09:30"
            },
            {
              "lesson": "Как позиционировать элементы в контейнере",
              "time": "09:41"
            },
            {
              "lesson": "Сбрасываем стандартные стили Elementor",
              "time": "04:30"
            }
          ]
        },
        {
          "id": 4,
          "number": "04",
          "title": "Стили",
          "info": "6 лекций • 59м",
          "lessons": [
            {
              "lesson": "Создаем стили цвета. Сброс стилей Elementor",
              "time": "11:11"
            },
            {
              "lesson": "Создаем стили текста и кнопок",
              "time": "11:28"
            },
            {
              "lesson": "Настройка стилей всего текста на сайте",
              "time": "06:45"
            },
            {
              "lesson": "Ограничение контента сайта и доп. настройки",
              "time": "12:11"
            },
            {
              "lesson": "Как работает настройка фонового изображения",
              "time": "06:12"
            }
          ]
        },
        {
          "id": 5,
          "number": "05",
          "title": "Настройки и ошибки",
          "info": "4 лекции • 31м",
          "lessons": [
            {
              "lesson": "Out of memory \\\\ тормозит Elementor",
              "time": "10:21"
            },
            {
              "lesson": "Как настроить WP и сбросить стили",
              "time": "09:21"
            },
            {
              "lesson": "Как сменить пароль и кастомизировать WP",
              "time": "05:54"
            },
            {
              "lesson": "Если не обновляется новое изображение вместо старого",
              "time": "05:44"
            }
          ]
        },
        {
          "id": 6,
          "number": "06",
          "title": "Углубление в Elementor",
          "info": "11 лекций • 2ч 4м",
          "lessons": [
            {
              "lesson": "Размеры изображений и overflow hidden",
              "time": "08:17"
            },
            {
              "lesson": "Центрирование абсолютно позиционированного элемента",
              "time": "09:00"
            },
            {
              "lesson": "Как работают CSS фильтры",
              "time": "04:04"
            },
            {
              "lesson": "Библиотека иконок Elementor. Додаем карточки",
              "time": "15:59"
            },
            {
              "lesson": "Свойства трансформирования элементов",
              "time": "04:05"
            }
          ]
        },
        {
          "id": 7,
          "number": "07",
          "title": "Анимации",
          "info": "5 лекций • 38м",
          "lessons": [
            {
              "lesson": "Про видео этого блока",
              "time": "00:42"
            },
            {
              "lesson": "Якорные ссылки",
              "time": "06:44"
            },
            {
              "lesson": "Эффекты движения",
              "time": "08:40"
            },
            {
              "lesson": "Анимации виджетами",
              "time": "07:09"
            },
            {
              "lesson": "Lottie Анимации",
              "time": "15:03"
            }
          ]
        },
        {
          "id": 8,
          "number": "08",
          "title": "Адаптивный дизайн",
          "info": "9 лекций • 1ч 13м",
          "lessons": [
            {
              "lesson": "Теория адаптивного дизайна",
              "time": "08:23"
            },
            {
              "lesson": "Создаем breakpoints",
              "time": "07:39"
            },
            {
              "lesson": "Небольшое исправление следующего урока.",
              "time": "00:32"
            },
            {
              "lesson": "Адаптируем планшетную версию",
              "time": "09:25"
            },
            {
              "lesson": "Адаптация Grid сетки",
              "time": "07:41"
            }
          ]
        },
        {
          "id": 9,
          "number": "09",
          "title": "Формы и Popup",
          "info": "2 лекции • 13м",
          "lessons": [
            {
              "lesson": "Форма через Royal Addon",
              "time": "07:17"
            },
            {
              "lesson": "Как создать popup",
              "time": "05:44"
            }
          ]
        },
        {
          "id": 10,
          "number": "10",
          "title": "Введение в шаблоны и конструктор тем",
          "info": "2 лекции • 16м",
          "lessons": [
            {
              "lesson": "Как работают шаблоны",
              "time": "07:25"
            },
            {
              "lesson": "Как работают динамические шаблоны",
              "time": "08:33"
            }
          ]
        },
        {
          "id": 11,
          "number": "11",
          "title": "Блог и конструктор тем",
          "info": "9 лекций • 1ч 46м",
          "lessons": [
            {
              "lesson": "О чем блок",
              "time": "03:11"
            },
            {
              "lesson": "Верстаем страницу блога",
              "time": "15:10"
            },
            {
              "lesson": "Автоматическое создание карточки поста",
              "time": "16:11"
            },
            {
              "lesson": "Как работают категории и метки",
              "time": "07:48"
            },
            {
              "lesson": "Как сделать динамическую запись поста",
              "time": "24:29"
            }
          ]
        },
        {
          "id": 12,
          "number": "12",
          "title": "Интернет Магазин",
          "info": "15 лекций • 1ч 54м",
          "lessons": [
            {
              "lesson": "Устанавливаем Woocommerce",
              "time": "08:38"
            },
            {
              "lesson": "Как создать единичный товар",
              "time": "13:57"
            },
            {
              "lesson": "Что такое вариативный товар",
              "time": "05:29"
            },
            {
              "lesson": "ПРАКТИКА. Создаете 2 товара",
              "time": "05:35"
            },
            {
              "lesson": "Что такое Up Sale и Cross Sale",
              "time": "03:43"
            }
          ]
        },
        {
          "id": 13,
          "number": "13",
          "title": "Готовый сайт из шаблонов",
          "info": "3 лекции • 32м",
          "lessons": [
            {
              "lesson": "Демо контент темы",
              "time": "14:42"
            },
            {
              "lesson": "Установка темы из интернета",
              "time": "09:14"
            },
            {
              "lesson": "Как использовать шаблоны",
              "time": "07:46"
            }
          ]
        },
        {
          "id": 14,
          "number": "14",
          "title": "SEO",
          "info": "6 лекций • 43м",
          "lessons": [
            {
              "lesson": "Первичная настройка YAST SEO",
              "time": "05:55"
            },
            {
              "lesson": "SEO Заголовок и описание",
              "time": "08:57"
            },
            {
              "lesson": "Заголовок h1",
              "time": "06:19"
            },
            {
              "lesson": "404 / alt / индексация страниц",
              "time": "09:31"
            },
            {
              "lesson": "Google search & Yandex Master",
              "time": "08:05"
            }
          ]
        },
        {
          "id": 15,
          "number": "15",
          "title": "Свой код и ElementorPro",
          "info": "4 лекции • 30м",
          "lessons": [
            {
              "lesson": "Свой CSS код",
              "time": "16:59"
            },
            {
              "lesson": "Обзор Elementor Pro",
              "time": "05:01"
            },
            {
              "lesson": "Динамические теги",
              "time": "03:12"
            },
            {
              "lesson": "Виджет HTML",
              "time": "04:23"
            }
          ]
        },
        {
          "id": 16,
          "number": "16",
          "title": "До новых встреч!",
          "info": "1 лекция • 3м",
          "lessons": [
            {
              "lesson": "Подводим итог.",
              "time": "02:43"
            }
          ]
        }
      ]
    },
    "additionalCategories": [
      "С нуля"
    ]
  },
  {
    "id": 24,
    "slug": "ai-course",
    "skillspaceCourses": [{ "courseId": "108910" }],
    "title": "Нейросети с нуля до результата!",
    "subtitle": "Ultimate курс по нейросетям",
    "description": "Все самые современные и востребованные нейросети в одном курсе. От генерации изображений и видео до программирования с помощью AI и автоматизации бизнеса. Курс обновляется ежемесячно!",
    "fullDescription": "Полный курс по работе с нейросетями и AI-инструментами. Научитесь генерировать изображения, видео, аудио, создавать сайты и приложения без кода, автоматизировать бизнес-процессы и использовать AI для работы и творчества.",
    "image": "/images/courses/ai-course-paper-v2.webp",
    "promoVideo": "https://rutube.ru/play/embed/22419e8903c2b91714458013a1d01f53",
    "price": 3390,
    "originalPrice": 4238,
    "discount": 20,
    "saleDiscount": 20,
    "category": "Искусственный интеллект",
    "lessons": 95,
    "totalHours": 10,
    "duration": "10 часов видео",
    "level": "С нуля",
    "students": 700,
    "rating": 4.9,
    "importantNote": "⚡️ Курс актуален всегда — автор обновляет все темы ежемесячно.\n\n⚡️⚡️ Для использования всех AI-инструментов курса необходимо отдельно приобрести подписку на агрегатор нейросетей Freepik: https://www.freepik.com/",
    "importantNoteButton": {
      "text": "Все нейросети вы можете оплатить на нашем сервисе",
      "buttonLabel": "Статья как оплатить подписку",
      "link": "https://vc.ru/id3912696/2704052-oplata-podpisok-v-rossii-luchshie-sposoby"
    },
    "features": [
      "Пожизненный доступ к материалам",
      "Сертификат о прохождении",
      "Поддержка преподавателя",
      "Ежемесячные обновления контента"
    ],
    "stats": [
      {
        "value": "95",
        "label": "Уроков"
      },
      {
        "value": "10ч",
        "label": "Видео"
      },
      {
        "value": "700+",
        "label": "Студентов"
      }
    ],
    "topics": [
      "Научитесь генерировать профессиональные изображения студийного качества",
      "Сможете создавать баннеры, визуалы для видео и карточки товаров",
      "Освоите лучшие AI-генераторы видео и научитесь делать последовательные и качественные видеоролики",
      "Сможете создавать рекламу, мультфильмы и оживлять персонажей с помощью AI",
      "Разберётесь в текстовых нейросетях, Prompt-инжиниринге и принципах работы LLM-моделей (ChatGPT и др.)",
      "Поймёте, как нейросети меняют мир и как использовать их в работе уже сейчас",
      "Научитесь генерировать аудио профессионального уровня: дубляж, клонирование голоса и перевод речи",
      "Сможете создавать музыку и звуковые эффекты с помощью AI",
      "Освоите создание AI-аватаров для видео и контента",
      "Разберётесь с Vibe-кодингом и созданием сайтов, приложений и игр без кода",
      "Изучите современные методы разработки с использованием AI-агентов",
      "Научитесь использовать AI для образования, языков, презентаций и исследований",
      "Сможете анализировать большие объёмы информации из интернета и видео",
      "Освоите автоматизацию на базе n8n и создадите Telegram-бота с интеграцией ChatGPT",
      "Получите полный набор современных AI-инструментов для работы, творчества и бизнеса"
    ],
    "testimonials": [],
    "aboutSection": {
      "headline": "AI — это новая грамотность. Курс актуален всегда!",
      "highlightedText": "",
      "description": "Нейросети меняют мир прямо сейчас. Те, кто освоит AI-инструменты сегодня, получат огромное преимущество завтра. Автор обновляет все темы ежемесячно!",
      "featureCard": {
        "text": "Генерация изображений, видео, аудио, Vibe-кодинг, автоматизация — всё в одном курсе"
      },
      "courseCard": {
        "title": "Нейросети",
        "subtitle": "Ultimate Course",
        "tagline": "От нуля до результата с AI",
        "badge": "AI"
      },
      "targetAudience": [
              {
                      "icon": "book",
                      "title": "Новичок в AI",
                      "description": "Хотите понять возможности ИИ",
                      "color": "teal",
                      "benefits": [
                              "Основы нейросетей",
                              "ChatGPT и другие LLM"
                      ]
              },
              {
                      "icon": "palette",
                      "title": "Дизайнер / Контент-мейкер",
                      "description": "Хотите использовать AI в работе",
                      "color": "purple",
                      "benefits": [
                              "Генерация изображений и видео",
                              "AI-аватары и анимация"
                      ]
              },
              {
                      "icon": "briefcase",
                      "title": "Предприниматель",
                      "description": "Хотите автоматизировать бизнес",
                      "color": "orange",
                      "benefits": [
                              "Telegram-боты с AI",
                              "Автоматизация на n8n"
                      ]
              },
              {
                      "icon": "zap",
                      "title": "Разработчик",
                      "description": "Хотите освоить Vibe-кодинг",
                      "color": "emerald",
                      "benefits": [
                              "Сайты и приложения без кода",
                              "AI-агенты для разработки"
                      ]
              }
      ],
      "requirements": "Для полноценного прохождения курса необходимо оплатить подписку на агрегатор нейросетей Freepik (~20$/мес). Нейросети — это платные инструменты."
    },
    "careerSection": {
          "title": "Сколько зарабатывают AI-специалисты?",
          "description": "Навыки работы с AI повышают ценность любого специалиста на 30-50%",
          "vacancies": "4 500+",
          "growth": "+120%",
          "salaryLevels": [
                {
                      "title": "AI-пользователь",
                      "salary": "+20% к ЗП",
                      "progress": "30%"
                },
                {
                      "title": "AI-специалист",
                      "salary": "+40% к ЗП",
                      "progress": "55%"
                },
                {
                      "title": "AI-эксперт",
                      "salary": "300 000+ ₽",
                      "progress": "100%"
                }
          ],
          "source": "* По данным hh.ru и Хабр Карьера, 2025"
    },
    "skillsSection": {
          "skills": [
                {
                      "name": "Генерация изображений",
                      "level": "Продвинутый",
                      "progress": "95%"
                },
                {
                      "name": "AI-видео и аватары",
                      "level": "Продвинутый",
                      "progress": "90%"
                },
                {
                      "name": "Prompt-инжиниринг",
                      "level": "Уверенный",
                      "progress": "85%"
                },
                {
                      "name": "Vibe-кодинг",
                      "level": "Уверенный",
                      "progress": "80%"
                },
                {
                      "name": "Автоматизация (n8n)",
                      "level": "Базовый",
                      "progress": "75%"
                }
          ],
          "opportunities": [
                {
                      "icon": "freelance",
                      "title": "Ускорить свою работу",
                      "description": "Использовать AI как помощника"
                },
                {
                      "icon": "company",
                      "title": "Стать AI-специалистом",
                      "description": "Внедрять AI-инструменты в компании"
                },
                {
                      "icon": "growth",
                      "title": "Развиваться дальше",
                      "description": "Освоить AI-автоматизацию и интеграции"
                }
          ]
    },
    "curriculum": {
      "headline": "Программа курса",
      "description": "95 уроков • 10 часов видео • Ежемесячные обновления",
      "modules": [
        {
          "id": 1,
          "number": "01",
          "title": "Введение",
          "info": "5 уроков",
          "lessons": [
            { "lesson": "Про материалы и презентацию", "time": "" },
            { "lesson": "Это мультиязычный курс", "time": "" },
            { "lesson": "Как проходить курс", "time": "" },
            { "lesson": "Актуален ли курс", "time": "" }
          ]
        },
        {
          "id": 2,
          "number": "02",
          "title": "Профессиональное фото для резюме",
          "info": "3 урока",
          "lessons": [
            { "lesson": "Как оплатить AI-сервис из РФ", "time": "" },
            { "lesson": "Профессиональное фото для резюме", "time": "" },
            { "lesson": "Оживляем фото", "time": "" }
          ]
        },
        {
          "id": 3,
          "number": "03",
          "title": "Введение в нейросети",
          "info": "3 урока",
          "lessons": [
            { "lesson": "Типы нейросетей", "time": "" },
            { "lesson": "Создатели нейросетей vs Агрегаторы", "time": "" },
            { "lesson": "Платёжные системы для AI", "time": "" }
          ]
        },
        {
          "id": 4,
          "number": "04",
          "title": "AI-изображения",
          "info": "12 уроков",
          "lessons": [
            { "lesson": "Топ нейросетей для изображений", "time": "" },
            { "lesson": "Генерация изображений в ChatGPT", "time": "" },
            { "lesson": "Обзор Freepik для изображений", "time": "" },
            { "lesson": "Обзор Adobe Photoshop", "time": "" },
            { "lesson": "Обзор Midjourney", "time": "" },
            { "lesson": "Как держать руку на пульсе ИИ", "time": "" },
            { "lesson": "Что выбрать для генерации изображений", "time": "" },
            { "lesson": "Что такое диффузионные модели", "time": "" },
            { "lesson": "Создаём заставку для видео", "time": "" },
            { "lesson": "Создание изображения с нуля", "time": "" },
            { "lesson": "Бонус: Создание профессионального фото продукта", "time": "" },
            { "lesson": "Бонус: Как редактировать баги нейросети", "time": "" }
          ]
        },
        {
          "id": 5,
          "number": "05",
          "title": "AI-тексты",
          "info": "6 уроков",
          "lessons": [
            { "lesson": "Топ LLM-моделей", "time": "" },
            { "lesson": "Пробуем ChatGPT", "time": "" },
            { "lesson": "Основной функционал ChatGPT", "time": "" },
            { "lesson": "Веб-интерфейс и создание проектов", "time": "" },
            { "lesson": "Голосовой ассистент ChatGPT", "time": "" },
            { "lesson": "Что насчёт отечественных нейросетей", "time": "" }
          ]
        },
        {
          "id": 6,
          "number": "06",
          "title": "AI-браузеры",
          "info": "1 урок",
          "lessons": [
            { "lesson": "Обзор ИИ для интернета", "time": "" }
          ]
        },
        {
          "id": 7,
          "number": "07",
          "title": "Необходимая теория работы LLM",
          "info": "6 уроков",
          "lessons": [
            { "lesson": "Что такое LLM", "time": "" },
            { "lesson": "На каком языке общаться с нейросетью", "time": "" },
            { "lesson": "Как ИИ работает под капотом", "time": "" },
            { "lesson": "В чём хороши LLM", "time": "" },
            { "lesson": "Ограничения LLM", "time": "" },
            { "lesson": "Почему ИИ галлюцинируют", "time": "" }
          ]
        },
        {
          "id": 8,
          "number": "08",
          "title": "Prompt Engineering",
          "info": "7 уроков",
          "lessons": [
            { "lesson": "Что такое Prompt Engineering", "time": "" },
            { "lesson": "Универсальная формула промпта", "time": "" },
            { "lesson": "Основные техники промпт-инжиниринга", "time": "" },
            { "lesson": "Ошибки в prompt engineering", "time": "" },
            { "lesson": "Итерации и улучшение промпта", "time": "" },
            { "lesson": "Ограничения и этика ИИ", "time": "" },
            { "lesson": "Просите GPT составлять промпты", "time": "" }
          ]
        },
        {
          "id": 9,
          "number": "09",
          "title": "Будущее ИИ",
          "info": "3 урока",
          "lessons": [
            { "lesson": "Может ли нейросеть захватить мир", "time": "" },
            { "lesson": "Что такое AGI", "time": "" },
            { "lesson": "Кого в теории может заменить нейросеть", "time": "" }
          ]
        },
        {
          "id": 10,
          "number": "10",
          "title": "AI-видео",
          "info": "10 уроков",
          "lessons": [
            { "lesson": "Топ нейросетей для видео", "time": "" },
            { "lesson": "Основы AI-видео, реклама наушников", "time": "" },
            { "lesson": "Как создавать последовательное видео", "time": "" },
            { "lesson": "Motion Control", "time": "" },
            { "lesson": "Проблемы нейросетей в генерации видео", "time": "" },
            { "lesson": "Подводим итоги", "time": "" },
            { "lesson": "Второй агрегатор Higgsfield", "time": "" },
            { "lesson": "Динамический урок", "time": "" },
            { "lesson": "Сравнение последних моделей", "time": "" }
          ]
        },
        {
          "id": 11,
          "number": "11",
          "title": "AI-аудио",
          "info": "7 уроков",
          "lessons": [
            { "lesson": "Текст в голос — Закадровый голос", "time": "" },
            { "lesson": "Копирование голоса и синхронизация губ", "time": "" },
            { "lesson": "Как создавать звуковые эффекты", "time": "" },
            { "lesson": "Как удалить фоновый шум в аудио", "time": "" },
            { "lesson": "Как заменить свой голос на другой", "time": "" },
            { "lesson": "Перевод и озвучка видео", "time": "" },
            { "lesson": "Подводим итоги блока про аудио", "time": "" }
          ]
        },
        {
          "id": 12,
          "number": "12",
          "title": "AI-аватары",
          "info": "2 урока",
          "lessons": [
            { "lesson": "Обзор платформы HeyGen", "time": "" },
            { "lesson": "Как сгенерировать аватар себя", "time": "" }
          ]
        },
        {
          "id": 13,
          "number": "13",
          "title": "AI для образования",
          "info": "4 урока",
          "lessons": [
            { "lesson": "Google AI Studio и голосовой ассистент", "time": "" },
            { "lesson": "Анализ информации с помощью AI — NotebookLM", "time": "" },
            { "lesson": "AI-презентации", "time": "" },
            { "lesson": "Визуализация текста — Napkin AI", "time": "" }
          ]
        },
        {
          "id": 14,
          "number": "14",
          "title": "Vibe-кодинг",
          "info": "5 уроков",
          "lessons": [
            { "lesson": "Обзор Vibe Coding — Emergent", "time": "" },
            { "lesson": "Vibe Coding — Создаём лендинг", "time": "" },
            { "lesson": "Как редактировать сайт", "time": "" },
            { "lesson": "Деплой проекта", "time": "" },
            { "lesson": "Emergent VS Replit VS Lovable", "time": "" }
          ]
        },
        {
          "id": 15,
          "number": "15",
          "title": "AI-кодинг",
          "info": "6 уроков",
          "lessons": [
            { "lesson": "Кодинг совместно с ChatGPT", "time": "" },
            { "lesson": "Современные инструменты разработки", "time": "" },
            { "lesson": "Как работает Codex", "time": "" },
            { "lesson": "Приложение Codex", "time": "" },
            { "lesson": "Codex + Сторонние сервисы", "time": "" },
            { "lesson": "Обзор Claude AI", "time": "" }
          ]
        },
        {
          "id": 16,
          "number": "16",
          "title": "Claude AI",
          "info": "5 уроков",
          "lessons": [
            { "lesson": "Обзор Claude AI", "time": "" },
            { "lesson": "Как манипулировать браузером через Claude", "time": "" },
            { "lesson": "Подключение LLM к программам через MCP", "time": "" },
            { "lesson": "Как работает Cowork", "time": "" },
            { "lesson": "Как работают Skills", "time": "" }
          ]
        },
        {
          "id": 17,
          "number": "17",
          "title": "AI-агент в n8n",
          "info": "14 уроков",
          "lessons": [
            { "lesson": "О чём этот раздел курса", "time": "" },
            { "lesson": "Создаём первую ноду n8n", "time": "" },
            { "lesson": "Подключаем Google Таблицы", "time": "" },
            { "lesson": "Подключаем почту Gmail", "time": "" },
            { "lesson": "Что такое JSON", "time": "" },
            { "lesson": "Подключаем Telegram к n8n", "time": "" },
            { "lesson": "Подключаем ChatGPT в n8n", "time": "" },
            { "lesson": "Реализуем функционал ChatGPT в Telegram", "time": "" },
            { "lesson": "Дополнительные настройки AI в n8n", "time": "" },
            { "lesson": "Как работает webhook", "time": "" },
            { "lesson": "Как работает метод POST в Webhook", "time": "" },
            { "lesson": "Как подключаться к сторонним сервисам", "time": "" },
            { "lesson": "Метод POST в HTTP Request", "time": "" },
            { "lesson": "Подводим итоги n8n", "time": "" }
          ]
        }
      ]
    },
    "additionalCategories": [
      "Бестселлеры",
      "С нуля"
    ]
  },
  {
    "id": 25,
    "slug": "ai-agents-dev",
    "hidden": false,
    "skillspaceCourses": [{ "courseId": "126779" }],
    "title": "AI-разработка и создание AI-агентов",
    "subtitle": "С нуля до результата",
    "description": "Соберите 3 рабочих AI-проекта — от сайта-портфолио до голосового ИИ-ассистента для бизнеса. Освойте самые современные методы разработки и создания цифровых продуктов от запуска до монетизации.",
    "fullDescription": "Соберите 3 рабочих AI-проекта — от сайта-портфолио до голосового ИИ-ассистента для бизнеса. Освойте самые современные методы разработки и создания цифровых продуктов от запуска до монетизации.",
    "image": "/images/courses/ai-agents-dev-paper-v2.webp",
    "promoVideo": "https://rutube.ru/play/embed/ec797765f0ec2b54f5e5638be9da6227",
    "price": 3990,
    "originalPrice": 4490,
    "discount": 11,
    "saleDiscount": 20,
    "category": "Искусственный интеллект",
    "lessons": 47,
    "totalHours": 7,
    "duration": "7 часов видео",
    "level": "С нуля",
    "students": 0,
    "rating": 0,
    "importantNote": "Для прохождения курса нужна активная подписка Claude или ChatGPT.\n\nПодписку можно оплатить виртуальной картой WantToPay.\n\nКурс можно проходить только с компьютера.",
    "importantNoteButton": {
      "buttonLabel": "Виртуальная карта WantToPay",
      "link": "https://wanttopay.net/?pid=NVDEH"
    },
    "features": [
      "Пожизненный доступ к материалам",
      "Сертификат о прохождении",
      "Поддержка преподавателя",
      "3 реальных проекта в портфолио",
      "30-дневная гарантия возврата средств"
    ],
    "stats": [
      {
        "value": "47",
        "label": "Уроков"
      },
      {
        "value": "7ч",
        "label": "Видео"
      },
      {
        "value": "3",
        "label": "Проекта"
      }
    ],
    "topics": [
      "Поймёте архитектуру AI-агентов и научитесь применять готовые паттерны: Router, Chain, Memory, Tool Calling и RAG",
      "Узнаете, как создают агентов на чистом Python",
      "Изучите, как работают AI-фреймворки (OpenAI Agents SDK, CrewAI, LangGraph), и выберете инструмент под свою задачу",
      "Узнаете, как у агентов работает память — от истории диалога до долговременного хранения данных в базе",
      "Научитесь подключать к агенту реальные инструменты: поиск в интернете, отправку уведомлений и запись в CRM",
      "Запустите готового AI-агента в интернете, чтобы он круглосуточно отвечал клиентам без вашего участия",
      "Освоите лучшие площадки и хостинги для размещения AI-агентов, Telegram-ботов и любых других цифровых продуктов",
      "Разберётесь, как работают локальные бесплатные AI-модели, которые запускаются только на вашем компьютере",
      "Научитесь выбирать AI-модель под конкретную задачу",
      "Разберётесь, как подключать через API любые сторонние нейросети к своим проектам",
      "Узнаете, как упаковать AI-агента в готовый продукт и зарабатывать на нём",
      "Разработаете сайт-портфолио на уровне топовых дизайн-студий",
      "Создадите коммерческого SMM-бота для Telegram, который самостоятельно ищет информацию в интернете и пишет посты с изображениями",
      "Построите голосового AI-ассистента для бизнеса, который консультирует клиентов и самостоятельно записывает их на услуги"
    ],
    "testimonials": [],
    "projects": [
      {
        "title": "Сайт-портфолио",
        "description": "Личный сайт на уровне топовых дизайн-студий, сделанный с нуля",
        "url": "https://dmitrii-fokeev-portfolio.vercel.app/"
      },
      {
        "title": "SMM-бот для Telegram",
        "description": "Сам ищет информацию в интернете, пишет посты в заданном стиле и генерирует изображения",
        "url": "https://t.me/Publisher_Fokeev_Bot"
      },
      {
        "title": "Голосовой ИИ-ассистент для бизнеса",
        "description": "Консультирует клиентов текстом и голосом онлайн и самостоятельно записывает на услуги",
        "url": "https://garage24-ai-assistant.onrender.com/"
      }
    ],
    "aboutSection": {
      "headline": "Один раз разобравшись в паттернах, вы соберёте агента под любую задачу — какая бы нейросеть или фреймворк ни появились завтра",
      "highlightedText": "",
      "description": "Курс не про программирование и не про подбор промптов. Мы разбираем архитектуру AI-агентов — типовые паттерны сборки, которые лежат в основе любого работающего бота: от простого консультанта до автономного помощника.",
      "featureCard": {
        "text": "3 уровня — от голого кода до готовых AI-фреймворков (OpenAI Agents SDK, CrewAI, LangGraph)"
      },
      "courseCard": {
        "title": "AI-агенты",
        "subtitle": "С нуля до результата",
        "tagline": "Соберите 3 рабочих AI-проекта",
        "badge": "AI"
      },
      "targetAudience": [
        {
          "icon": "book",
          "title": "Новичок без кода",
          "description": "Хотите войти в AI-разработку с нуля",
          "color": "teal",
          "benefits": [
            "Код пишем вместе с ИИ",
            "Объясняем логику, а не синтаксис"
          ]
        },
        {
          "icon": "briefcase",
          "title": "Предприниматель",
          "description": "Хотите автоматизировать бизнес",
          "color": "orange",
          "benefits": [
            "Голосовой ИИ-ассистент",
            "Запись клиентов на услуги"
          ]
        },
        {
          "icon": "zap",
          "title": "Фрилансер / контент-мейкер",
          "description": "Хотите зарабатывать на AI-продуктах",
          "color": "emerald",
          "benefits": [
            "Коммерческие Telegram-боты",
            "Упаковка агента в продукт"
          ]
        },
        {
          "icon": "palette",
          "title": "Разработчик",
          "description": "Хотите освоить архитектуру агентов",
          "color": "purple",
          "benefits": [
            "Паттерны: Router, Memory, RAG",
            "Фреймворки и Tool Calling"
          ]
        }
      ],
      "requirements": "Для прохождения курса нужна активная подписка Claude или ChatGPT. Подписку можно оплатить виртуальной картой WantToPay. Курс можно проходить только с компьютера."
    },
    "careerSection": {
      "title": "Сколько зарабатывают AI-разработчики?",
      "description": "Специалисты, которые умеют собирать AI-агентов и автоматизации, — одни из самых востребованных на рынке",
      "vacancies": "4 500+",
      "growth": "+120%",
      "salaryLevels": [
        {
          "title": "Начинающий (0-1 год)",
          "salary": "80 000 ₽",
          "progress": "30%"
        },
        {
          "title": "Средний (1-3 года)",
          "salary": "180 000 ₽",
          "progress": "55%"
        },
        {
          "title": "Профессионал (3+ лет)",
          "salary": "350 000+ ₽",
          "progress": "100%"
        }
      ],
      "source": "* По данным hh.ru и Хабр Карьера, 2025"
    },
    "skillsSection": {
      "skills": [
        {
          "name": "Архитектура AI-агентов",
          "level": "Продвинутый",
          "progress": "90%"
        },
        {
          "name": "Паттерны: Tool Calling, Memory, RAG",
          "level": "Продвинутый",
          "progress": "85%"
        },
        {
          "name": "Python + подключение нейросетей по API",
          "level": "Уверенный",
          "progress": "80%"
        },
        {
          "name": "Деплой и хостинг ботов",
          "level": "Уверенный",
          "progress": "75%"
        },
        {
          "name": "Telegram-боты и автоматизации",
          "level": "Базовый",
          "progress": "70%"
        }
      ],
      "opportunities": [
        {
          "icon": "freelance",
          "title": "Брать заказы на AI-агентов",
          "description": "Создавать ботов и ассистентов для бизнеса"
        },
        {
          "icon": "company",
          "title": "Стать AI-разработчиком",
          "description": "Внедрять AI-решения в компании"
        },
        {
          "icon": "growth",
          "title": "Запустить свой продукт",
          "description": "Упаковать агента и зарабатывать на нём"
        }
      ]
    },
    "curriculum": {
      "headline": "Программа курса",
      "description": "47 уроков • 7 часов видео • 3 реальных проекта",
      "modules": [
        {
          "id": 1,
          "number": "01",
          "title": "Введение",
          "info": "3 урока",
          "lessons": [
            { "lesson": "Скачайте материалы к курсу", "time": "" },
            { "lesson": "Скачиваем Claude", "time": "" },
            { "lesson": "Как оплатить Claude в России", "time": "" }
          ]
        },
        {
          "id": 2,
          "number": "02",
          "title": "Эра AI-исполнителей уже здесь",
          "info": "5 уроков",
          "lessons": [
            { "lesson": "Парадигма исполнителя", "time": "" },
            { "lesson": "Создаём сайт одним промптом", "time": "" },
            { "lesson": "Выкладываем сайт в Интернет", "time": "" },
            { "lesson": "Практика №1 — Создайте сайт о себе", "time": "" },
            { "lesson": "Пример преподавателя — сайт-портфолио", "time": "" }
          ]
        },
        {
          "id": 3,
          "number": "03",
          "title": "О чём курс",
          "info": "2 урока",
          "lessons": [
            { "lesson": "Disclaimer", "time": "" },
            { "lesson": "Программа курса", "time": "" }
          ]
        },
        {
          "id": 4,
          "number": "04",
          "title": "Знакомство с Claude",
          "info": "5 уроков",
          "lessons": [
            { "lesson": "Почему Claude?", "time": "" },
            { "lesson": "Различия Chat / Work / Code", "time": "" },
            { "lesson": "Как работает Browser Use", "time": "" },
            { "lesson": "Skills, Plugins, Connectors", "time": "" },
            { "lesson": "Claude + Microsoft", "time": "" }
          ]
        },
        {
          "id": 5,
          "number": "05",
          "title": "Основы LLM-систем",
          "info": "1 урок",
          "lessons": [
            { "lesson": "Необходимая теория работы LLM-систем", "time": "" }
          ]
        },
        {
          "id": 6,
          "number": "06",
          "title": "ИИ-агенты",
          "info": "17 уроков",
          "lessons": [
            { "lesson": "Как создаются ИИ-агенты", "time": "" },
            { "lesson": "Подготовка", "time": "" },
            { "lesson": "Запускаем агента на чистом Python", "time": "" },
            { "lesson": "Подключаем Gemini по API", "time": "" },
            { "lesson": "Паттерны создания ИИ-агентов", "time": "" },
            { "lesson": "Паттерны агентов (Текст)", "time": "" },
            { "lesson": "Тест на понимание паттернов ИИ-агентов", "time": "" },
            { "lesson": "Как работает память у ИИ", "time": "" },
            { "lesson": "Как запустить агента в Gradio", "time": "" },
            { "lesson": "Как работают фреймворки", "time": "" },
            { "lesson": "Как работает паттерн Tool Calling", "time": "" },
            { "lesson": "Как опубликовать свой проект", "time": "" },
            { "lesson": "Запускаем реального ИИ-ассистента", "time": "" },
            { "lesson": "Сохраняем заявки от ИИ в базе", "time": "" },
            { "lesson": "Подключаем ИИ к сервисам", "time": "" },
            { "lesson": "Практика №2 — Создайте ИИ-ассистента", "time": "" },
            { "lesson": "Пример преподавателя — создание ИИ-ассистента", "time": "" }
          ]
        },
        {
          "id": 7,
          "number": "07",
          "title": "ИИ-ассистент + Telegram",
          "info": "5 уроков",
          "lessons": [
            { "lesson": "ИИ-ассистент + Telegram", "time": "" },
            { "lesson": "ИИ управляет Telegram", "time": "" },
            { "lesson": "Практика №3 — Создайте бота AI Telegram Publisher", "time": "" },
            { "lesson": "Пример преподавателя — бот AI Telegram Publisher", "time": "" },
            { "lesson": "Что можно подключить через API", "time": "" }
          ]
        },
        {
          "id": 8,
          "number": "08",
          "title": "Сервисы ИИ автоматизации",
          "info": "4 урока",
          "lessons": [
            { "lesson": "Способы создания автоматизаций", "time": "" },
            { "lesson": "Актуальны ли n8n и Make?", "time": "" },
            { "lesson": "Как лопнет AI пузырь", "time": "" },
            { "lesson": "Прогноз развития ИИ на 4 года", "time": "" }
          ]
        },
        {
          "id": 9,
          "number": "09",
          "title": "Как использовать знания в работе",
          "info": "4 урока",
          "lessons": [
            { "lesson": "Что такое Claude Design", "time": "" },
            { "lesson": "В чём Claude хорош, а в чём плох?", "time": "" },
            { "lesson": "Что и как изучать дальше", "time": "" },
            { "lesson": "Как зарабатывать на ИИ", "time": "" }
          ]
        },
        {
          "id": 10,
          "number": "10",
          "title": "До новых встреч",
          "info": "1 урок",
          "lessons": [
            { "lesson": "Спасибо за прохождение курса", "time": "" }
          ]
        }
      ]
    },
    "additionalCategories": [
      "С нуля"
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Артём Дроботущенко",
    role: "Студент курса по монтажу",
    text: "Хороший курс) Автор подробно(но не занудно) и быстро рассказывает про базовые навыки монтажа. Тут вы научитесь быстро нарезать видео при помощи горячих клавиш, обрабатывать звук для своих видео, чтобы приятно было слушать.",
    rating: 5
  },
  {
    id: 2,
    name: "Александр Ларькин",
    role: "Студент курса по Web-дизайну",
    text: "Научился создавать макеты сайта по принципам и нормам Web-дизайна, еще раз потренировался с функциональностью приложения Figma. Понравилось мне еще раз все у Дмитрия: грамотное преподавание и структура тем.",
    rating: 5
  },
  {
    id: 3,
    name: "Мария Суворова",
    role: "Студентка курса по JavaScript",
    text: "Рада, что взяла именно этот курс по JavaScript. Курс большой, сложность нарастает постепенно, подходит для новичков. Очень понравилось, что вся теория разобрана подробно и понятно.",
    rating: 5
  },
  {
    id: 4,
    name: "Elena Miller",
    role: "Студентка курса по After Effects",
    text: "Офигенный курс, офигенный преподаватель. Изначально смотрел на YouTube, как делают некоторые моменты, и это заинтересовало. Нашёл курс, прошёл. И теперь я знаю азы данной программы.",
    rating: 5
  },
  {
    id: 5,
    name: "Ирина Бреус",
    role: "Студентка курса по дизайну",
    text: "Курс понравился, проходится легко. Как обычно в курсах Дмитрия - все четко и по делу. Хотя в курсе нет ничего такого глобального, но тут рассматриваются мелочи, которые можно не заметить.",
    rating: 5
  },
  {
    id: 6,
    name: "Лина Мр",
    role: "Студентка курса по Illustrator",
    text: "Отличный курс для начинающих. Все довольно просто и понятно в объяснении. Этой базы более чем достаточно для дальнейшего использования иллюстратора.",
    rating: 5
  }
];

export const advantages = [
  {
    id: 1,
    title: "30 дней гарантии",
    description: "Если курс вам не подойдёт, мы вернём деньги в течение 30 дней без лишних вопросов.",
    icon: "Shield"
  },
  {
    id: 2,
    title: "Сертификат о прохождении",
    description: "Каждый выпускник получает именной сертификат, подтверждающий навыки и карьеры.",
    icon: "Award"
  },
  {
    id: 3,
    title: "Lifetime Access",
    description: "Пожизненный доступ ко всем материалам курса, включая будущие обновления контента.",
    icon: "Infinity"
  },
  {
    id: 4,
    title: "Рост карьеры",
    description: "Наши студенты в среднем увеличивают доход на 40% после прохождения курсов.",
    icon: "TrendingUp"
  }
];

export const learningSteps = [
  {
    id: 1,
    tab: "Видеоуроки",
    title: "Короткие видеоуроки",
    description: "Формат коротких уроков по 5-20 минут. Каждый урок посвящён одной конкретной теме. Вам не нужно тратить часы на просмотр — учитесь эффективно.",
    features: ["Длительность 5-20 минут", "Одна тема — один урок", "HD качество"]
  },
  {
    id: 2,
    tab: "Практика",
    title: "Практические задания",
    description: "После каждого видеоурока вас ждут практические задания для закрепления материала. Реальные проекты, а не абстрактные примеры.",
    features: ["Реальные проекты", "Автоматическая проверка", "Подробные решения"]
  },
  {
    id: 3,
    tab: "Результат",
    title: "Готовые проекты в портфолио",
    description: "К концу курса у вас будет готовое портфолио из реальных проектов, которое можно показать работодателю или клиентам.",
    features: ["1-3 проекта в портфолио", "Сертификат об окончании"]
  }
];

export const flexibleFeatures = [
  {
    id: 1,
    title: "Без дедлайнов на домашки",
    description: "Выполняйте задания в своём ритме. Никакого давления сроков — учитесь когда удобно вам."
  },
  {
    id: 2,
    title: "Полная программа по теме",
    description: "Каждый курс содержит исчерпывающую программу. От основ до продвинутых тем — всё в одном месте."
  },
  {
    id: 3,
    title: "Никаких групп из 20+ человек",
    description: "Индивидуальный подход к каждому студенту. Преподаватель лично отвечает на ваши вопросы."
  }
];

export const comparisonData = [
  {
    id: 1,
    title: "Fokeev",
    highlighted: true,
    color: "teal",
    useLogo: true,
    features: [
      { text: "Короткие уроки от профи по теме в высоком качестве", positive: true },
      { text: "Цена в 50-80 раз дешевле других школ", positive: true },
      { text: "Оценки студентов выше любой другой школы", positive: true },
      { text: "Преподаватель сначала показывает, как сделать — потом даёт задание на закрепление", positive: true },
      { text: "Методика наставничества: повторил — сделал — закрепил", positive: true },
      { text: "Высокая мотивация на протяжении всего курса", positive: true },
      { text: "Без посредников и кураторов — только личное общение с автором курса", positive: true }
    ]
  },
  {
    id: 2,
    title: "Большие онлайн школы",
    highlighted: false,
    color: "blue",
    features: [
      { text: "3-часовые стримы в группе из 20 студентов", positive: false },
      { text: "Преподаватели на ставке — без личной заинтересованности", positive: false },
      { text: "Обязательные домашние по темам, которые вам могут быть не нужны", positive: false },
      { text: "Преподаватель отвечает на вопросы только на сессиях в Zoom, раз в неделю", positive: false },
      { text: "Цены от 150 000 ₽", positive: false }
    ]
  },
  {
    id: 3,
    title: "Оффлайн образование",
    highlighted: false,
    color: "slate",
    features: [
      { text: "Скучнейшие лекции по 1.5 часа", positive: false },
      { text: "Устаревшая программа", positive: false },
      { text: "Группы по 30 человек", positive: false },
      { text: "Цены от 150 000 ₽ ежегодно", positive: false }
    ]
  }
];

export const pricingFeatures = [
  "Доступ ко всем урокам курса",
  "Практические задания",
  "Ответы на вопросы студентов каждый день",
  "Пожизненный доступ к материалам",
  "Проекты в портфолио",
  "Сертификат об окончании"
];
